(function() {
    'use strict';

    angular
        .module('sgnmrApp', [
            'ngStorage',
            'tmh.dynamicLocale',
            'pascalprecht.translate',
            'ngResource',
            'ngCookies',
            'ngAria',
            'ngCacheBuster',
            'ngFileUpload',
            'ui.bootstrap',
            'ui.bootstrap.datetimepicker',
            'ui.router',
            'infinite-scroll',
            'ds.objectDiff',
            'ui.select',
            'ngSanitize',
            'chart.js',
            'flow',
            'rzModule',
            'scjn.components',
            'treeControl',
            // jhipster-needle-angularjs-add-module JHipster will add new module here
            'angular-loading-bar'
        ])
        .run(run);

    run.$inject = ['stateHandler', 'translationHandler'];

    function run(stateHandler, translationHandler) {
        stateHandler.initialize();
        translationHandler.initialize();
    }
})();

(function () {
    'use strict';

    angular
        .module('sgnmrApp')
        .factory('User', User);

    User.$inject = ['$resource'];

    function User ($resource) {
        var service = $resource('api/users/:login', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'save': { method:'POST' },
            'update': { method:'PUT' },
            'delete':{ method:'DELETE'}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .factory('StorageService', StorageService);

    StorageService.$inject = ['$http', '$localStorage' ];

    function StorageService ($http, $localStorage ) {
        var service = {
            setTotal: setTotal,
            getTotal: getTotal
            
        };

        return service;
        function setTotal(total){
            $localStorage.total = total;
        }
        function getTotal(){
            return $localStorage.total;
        }

        
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .factory('ProfileService', ProfileService);

    ProfileService.$inject = ['$http'];

    function ProfileService($http) {

        var dataPromise;

        var service = {
            getProfileInfo : getProfileInfo
        };

        return service;

        function getProfileInfo() {
            if (angular.isUndefined(dataPromise)) {
                dataPromise = $http.get('api/profile-info').then(function(result) {
                    if (result.data.activeProfiles) {
                        var response = {};
                        response.activeProfiles = result.data.activeProfiles;
                        response.ribbonEnv = result.data.ribbonEnv;
                        response.inProduction = result.data.activeProfiles.indexOf("prod") !== -1;
                        response.swaggerEnabled = result.data.activeProfiles.indexOf("swagger") !== -1;
                        return response;
                    }
                });
            }
            return dataPromise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .directive('pageRibbon', pageRibbon);

    pageRibbon.$inject = ['ProfileService', '$rootScope', '$translate'];

    function pageRibbon(ProfileService, $rootScope, $translate) {
        var directive = {
            replace : true,
            restrict : 'AE',
            template : '<div class="ribbon hidden"><a href="" data-translate="global.ribbon.{{ribbonEnv}}">{{ribbonEnv}}</a></div>',
            link : linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            ProfileService.getProfileInfo().then(function(response) {
                if (response.ribbonEnv) {
                    scope.ribbonEnv = response.ribbonEnv;
                    element.addClass(response.ribbonEnv);
                    element.removeClass('hidden');
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .factory('Sessions', Sessions);

    Sessions.$inject = ['$resource'];

    function Sessions ($resource) {
        return $resource('api/account/sessions/:series', {}, {
            'getAll': { method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('sgnmrApp')
        .factory('Register', Register);

    Register.$inject = ['$resource'];

    function Register ($resource) {
        return $resource('api/register', {}, {});
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .factory('Principal', Principal);

    Principal.$inject = ['$q', 'Account'];

    function Principal ($q, Account) {
        var _identity,
            _authenticated = false;

        var service = {
            authenticate: authenticate,
            hasAnyAuthority: hasAnyAuthority,
            hasAuthority: hasAuthority,
            identity: identity,
            isAuthenticated: isAuthenticated,
            isIdentityResolved: isIdentityResolved
        };

        return service;

        function authenticate (identity) {
            _identity = identity;
            _authenticated = identity !== null;
        }

        function hasAnyAuthority (authorities) {
            if (!_authenticated || !_identity || !_identity.authorities) {
                return false;
            }

            for (var i = 0; i < authorities.length; i++) {
                if (_identity.authorities.indexOf(authorities[i]) !== -1) {
                    return true;
                }
            }

            return false;
        }

        function hasAuthority (authority) {
            if (!_authenticated) {
                return $q.when(false);
            }

            return this.identity().then(function(_id) {
                return _id.authorities && _id.authorities.indexOf(authority) !== -1;
            }, function(){
                return false;
            });
        }

        function identity (force) {
            var deferred = $q.defer();

            if (force === true) {
                _identity = undefined;
            }

            // check and see if we have retrieved the identity data from the server.
            // if we have, reuse it by immediately resolving
            if (angular.isDefined(_identity)) {
                deferred.resolve(_identity);

                return deferred.promise;
            }

            // retrieve the identity data from the server, update the identity object, and then resolve.
            Account.get().$promise
                .then(getAccountThen)
                .catch(getAccountCatch);

            return deferred.promise;

            function getAccountThen (account) {
                _identity = account.data;
                _authenticated = true;
                deferred.resolve(_identity);
            }

            function getAccountCatch () {
                _identity = null;
                _authenticated = false;
                deferred.resolve(_identity);
            }
        }

        function isAuthenticated () {
            return _authenticated;
        }

        function isIdentityResolved () {
            return angular.isDefined(_identity);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .factory('PasswordResetInit', PasswordResetInit);

    PasswordResetInit.$inject = ['$resource'];

    function PasswordResetInit($resource) {
        var service = $resource('api/account/reset-password/init', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .factory('PasswordResetFinish', PasswordResetFinish);

    PasswordResetFinish.$inject = ['$resource'];

    function PasswordResetFinish($resource) {
        var service = $resource('api/account/reset-password/finish', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .factory('Password', Password);

    Password.$inject = ['$resource'];

    function Password($resource) {
        var service = $resource('api/account/change-password', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .directive('hasAuthority', hasAuthority);

    hasAuthority.$inject = ['Principal'];

    function hasAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authority = attrs.hasAuthority.replace(/\s+/g, '');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {

                    if (reset) {
                        setVisible();
                    }

                    Principal.hasAuthority(authority)
                        .then(function (result) {
                            if (result) {
                                setVisible();
                            } else {
                                setHidden();
                            }
                        });
                };

            if (authority.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .directive('hasAnyAuthority', hasAnyAuthority);

    hasAnyAuthority.$inject = ['Principal'];

    function hasAnyAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authorities = attrs.hasAnyAuthority.replace(/\s+/g, '').split(',');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {
                    var result;
                    if (reset) {
                        setVisible();
                    }

                    result = Principal.hasAnyAuthority(authorities);
                    if (result) {
                        setVisible();
                    } else {
                        setHidden();
                    }
                };

            if (authorities.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .factory('AuthServerProvider', AuthServerProvider);

    AuthServerProvider.$inject = ['$http', '$localStorage' ];

    function AuthServerProvider ($http, $localStorage ) {
        var service = {
            getToken: getToken,
            hasValidToken: hasValidToken,
            login: login,
            logout: logout
        };

        return service;

        function getToken () {
            var token = $localStorage.authenticationToken;
            return token;
        }

        function hasValidToken () {
            var token = this.getToken();
            return !!token;
        }

        function login (credentials) {
            var data = 'j_username=' + encodeURIComponent(credentials.username) +
                '&j_password=' + encodeURIComponent(credentials.password) +
                '&remember-me=' + credentials.rememberMe + '&submit=Login';

            return $http.post('api/authentication', data, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).success(function (response) {
                return response;
            });
        }

        function logout () {

            
            // logout from the server
            $http.post('api/logout').success(function (response) {
                delete $localStorage.authenticationToken;
                // to get a new csrf token call the api
                $http.get('api/account');
                return response;
            });
            
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .factory('Auth', Auth);

    Auth.$inject = ['$rootScope', '$state', '$sessionStorage', '$q', '$translate', 'Principal', 'AuthServerProvider', 'Account', 'LoginService', 'Register', 'Activate', 'Password', 'PasswordResetInit', 'PasswordResetFinish'];

    function Auth ($rootScope, $state, $sessionStorage, $q, $translate, Principal, AuthServerProvider, Account, LoginService, Register, Activate, Password, PasswordResetInit, PasswordResetFinish) {
        var service = {
            activateAccount: activateAccount,
            authorize: authorize,
            changePassword: changePassword,
            createAccount: createAccount,
            getPreviousState: getPreviousState,
            login: login,
            logout: logout,
            loginWithToken: loginWithToken,
            resetPasswordFinish: resetPasswordFinish,
            resetPasswordInit: resetPasswordInit,
            resetPreviousState: resetPreviousState,
            storePreviousState: storePreviousState,
            updateAccount: updateAccount
        };

        return service;

        function activateAccount (key, callback) {
            var cb = callback || angular.noop;

            return Activate.get(key,
                function (response) {
                    return cb(response);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function authorize (force) {
            var authReturn = Principal.identity(force).then(authThen);

            return authReturn;

            function authThen () {
                var isAuthenticated = Principal.isAuthenticated();

                // an authenticated user can't access to login and register pages
                if (isAuthenticated && $rootScope.toState.parent === 'account' && ($rootScope.toState.name === 'login' || $rootScope.toState.name === 'register' || $rootScope.toState.name === 'social-auth')) {
                    $state.go('home');
                }

                // recover and clear previousState after external login redirect (e.g. oauth2)
                if (isAuthenticated && !$rootScope.fromState.name && getPreviousState()) {
                    var previousState = getPreviousState();
                    resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }

                if ($rootScope.toState.data.authorities && $rootScope.toState.data.authorities.length > 0 && !Principal.hasAnyAuthority($rootScope.toState.data.authorities)) {
                    if (isAuthenticated) {
                        // user is signed in but not authorized for desired state
                        $state.go('accessdenied');
                    }
                    else {
                        // user is not authenticated. stow the state they wanted before you
                        // send them to the login service, so you can return them when you're done
                        storePreviousState($rootScope.toState.name, $rootScope.toStateParams);

                        // now, send them to the signin state so they can log in
                        $state.go('accessdenied').then(function() {
                            LoginService.open();
                        });
                    }
                }
            }
        }

        function changePassword (newPassword, callback) {
            var cb = callback || angular.noop;

            return Password.save(newPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function createAccount (account, callback) {
            var cb = callback || angular.noop;

            return Register.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    this.logout();
                    return cb(err);
                }.bind(this)).$promise;
        }

        function login (credentials, callback) {
            var cb = callback || angular.noop;
            var deferred = $q.defer();

            AuthServerProvider.login(credentials)
                .then(loginThen)
                .catch(function (err) {
                    this.logout();
                    deferred.reject(err);
                    return cb(err);
                }.bind(this));

            function loginThen (data) {
                Principal.identity(true).then(function(account) {
                    // After the login the language will be changed to
                    // the language selected by the user during his registration
                    if (account!== null) {
                        $translate.use(account.langKey).then(function () {
                            $translate.refresh();
                        });
                    }
                    deferred.resolve(data);
                });
                return cb();
            }

            return deferred.promise;
        }

        function loginWithToken(jwt, rememberMe) {
            return AuthServerProvider.loginWithToken(jwt, rememberMe);
        }

        function logout () {
            AuthServerProvider.logout();
            Principal.authenticate(null);
        }

        function resetPasswordFinish (keyAndPassword, callback) {
            var cb = callback || angular.noop;

            return PasswordResetFinish.save(keyAndPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function resetPasswordInit (mail, callback) {
            var cb = callback || angular.noop;

            return PasswordResetInit.save(mail, function() {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function updateAccount (account, callback) {
            var cb = callback || angular.noop;

            return Account.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function getPreviousState() {
            var previousState = $sessionStorage.previousState;
            return previousState;
        }

        function resetPreviousState() {
            delete $sessionStorage.previousState;
        }

        function storePreviousState(previousStateName, previousStateParams) {
            var previousState = { "name": previousStateName, "params": previousStateParams };
            $sessionStorage.previousState = previousState;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .factory('AuthServerProvider', AuthServerProvider);

    AuthServerProvider.$inject = ['$http', '$localStorage', '$sessionStorage', '$q'];

    function AuthServerProvider ($http, $localStorage, $sessionStorage, $q) {
        var service = {
            getToken: getToken,
            login: login,
            loginWithToken: loginWithToken,
            storeAuthenticationToken: storeAuthenticationToken,
            logout: logout
        };

        return service;

        function getToken () {
            return $localStorage.authenticationToken || $sessionStorage.authenticationToken;
        }

        function login (credentials) {

            var data = {
                username: credentials.username,
                password: credentials.password,
                rememberMe: credentials.rememberMe
            };
            return $http.post('api/authenticate', data).success(authenticateSuccess);

            function authenticateSuccess (data, status, headers) {
                var bearerToken = headers('Authorization');
                if (angular.isDefined(bearerToken) && bearerToken.slice(0, 7) === 'Bearer ') {
                    var jwt = bearerToken.slice(7, bearerToken.length);
                    service.storeAuthenticationToken(jwt, credentials.rememberMe);
                    return jwt;
                }
            }
        }

        function loginWithToken(jwt, rememberMe) {
            var deferred = $q.defer();

            if (angular.isDefined(jwt)) {
                this.storeAuthenticationToken(jwt, rememberMe);
                deferred.resolve(jwt);
            } else {
                deferred.reject();
            }

            return deferred.promise;
        }

        function storeAuthenticationToken(jwt, rememberMe) {
            if(rememberMe){
                $localStorage.authenticationToken = jwt;
            } else {
                $sessionStorage.authenticationToken = jwt;
            }
        }

        function logout () {
            delete $localStorage.authenticationToken;
            delete $sessionStorage.authenticationToken;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .factory('Activate', Activate);

    Activate.$inject = ['$resource'];

    function Activate ($resource) {
        var service = $resource('api/activate', {}, {
            'get': { method: 'GET', params: {}, isArray: false}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .factory('Account', Account);

    Account.$inject = ['$resource'];

    function Account ($resource) {
        var service = $resource('api/account', {}, {
            'get': { method: 'GET', params: {}, isArray: false,
                interceptor: {
                    response: function(response) {
                        // expose response
                        return response;
                    }
                }
            }
        });

        return service;
    }
})();

(function () {
    'use strict';

    angular
        .module('sgnmrApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('public', {
            abstract: true,
            views: {
                'content@': {
                    templateUrl: 'app/layouts/public/public.html',
                    controller: 'PublicController',
                    controllerAs: 'vm'
                }
            },
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .controller('PublicController', PublicController);

    PublicController.$inject = ['$state', 'Principal'];

    function PublicController ($state, Principal) {
        var vm = this;

        vm.menuNavbarCollapsed = true;
        vm.searchValue = '';
        vm.toggleMenuNavbar = toggleMenuNavbar;
        vm.collapseMenuNavbar = collapseMenuNavbar;
        vm.scrollToTop = scrollToTop;
        vm.search = search;
        vm.$state = $state;
        vm.isAuthenticated = Principal.isAuthenticated;

        $(window).scroll(function(){
            if ($(this).scrollTop() > 200) {
                /* show header sticky */
                $('#header-sticky').addClass('sticky');
                $('#header-sticky').removeClass('hidden');
                $('#header-sticky').addClass('hidden-xs');
                /* show social network sticky */
                $('#social-network-sticky').addClass('sticky');
                $('#social-network-sticky').removeClass('hidden');
                $('#social-network-sticky').addClass('hidden-xs');
                /* show scroll top top */
                $('#scroll-to-top').fadeIn();

            } else {
                /* hide header sticky */
                $('#header-sticky').removeClass('sticky');
                $('#header-sticky').removeClass('hidden-xs');
                $('#header-sticky').addClass('hidden');
                /* hide social network sticky */
                $('#social-network-sticky').removeClass('sticky');
                $('#social-network-sticky').removeClass('hidden-xs');
                $('#social-network-sticky').addClass('hidden');

                /* hide scroll top top */
                $('#scroll-to-top').fadeOut();
            }
        });

        function toggleMenuNavbar() {
            vm.menuNavbarCollapsed = !vm.menuNavbarCollapsed;
        }

        function collapseMenuNavbar() {
            vm.menuNavbarCollapsed = true;
        }

        function scrollToTop() {
            $('html, body').animate({ scrollTop: 0 }, 600);
        };

        function search() {
            if (vm.searchValue !== undefined && vm.searchValue !== '') {
                window.location.replace('/gw/#/sistema-de-consulta/sitios?q=' + vm.searchValue);
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('sgnmrApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('private', {
            abstract: true,
            views: {
                'content@': {
                    templateUrl: 'app/layouts/private/private.html',
                    controller: 'PrivateController',
                    controllerAs: 'vm'
                }
            },
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .controller('PrivateController', PrivateController);

    PrivateController.$inject = ['$state', '$translate', 'Auth', 'Principal', 'ProfileService', 'LoginService'];

    function PrivateController ($state, $translate, Auth, Principal, ProfileService, LoginService) {
        var vm = this;

        vm.isNavbarCollapsed = true;
        vm.isAuthenticated = Principal.isAuthenticated;

        ProfileService.getProfileInfo().then(function(response) {
            vm.inProduction = response.inProduction;
            vm.swaggerEnabled = response.swaggerEnabled;
        });

        vm.isAdmin = Principal.hasAnyAuthority(['ROLE_ADMIN']);

        vm.login = login;
        vm.logout = logout;
        vm.toggleNavbar = toggleNavbar;
        vm.collapseNavbar = collapseNavbar;
        vm.$state = $state;

        vm.menu = [{
          name: $translate.instant('global.menu.home'),
          action: function (){ $state.go('home'); },
          icon: 'glyphicon glyphicon-home',
          hasChild: false,
          isOpen: false,
          isActive: false,
          isVisible: true
        }, {
          name: $translate.instant('global.menu.entities.main'),
          icon: 'glyphicon glyphicon-th-list',
          action: function () {return; },
          hasChild: true,
          isOpen: false,
          isActive: false,
          isVisible: true,
          childrens: [{
            name: $translate.instant('global.menu.entities.norma'),
            action: function (){ $state.go('norma'); },
            icon: 'glyphicon glyphicon-asterisk',
            isActive: false,
            isVisible: true
          }, {
            name: $translate.instant('global.menu.entities.tipoOrdenamiento'),
            action: function (){ $state.go('tipo-ordenamiento'); },
            icon: 'glyphicon glyphicon-asterisk',
            isActive: false,
            isVisible: true
          }, {
            name: $translate.instant('global.menu.entities.materia'),
            action: function (){ $state.go('materia'); },
            icon: 'glyphicon glyphicon-asterisk',
            isActive: false,
            isVisible: true
          }, {
            name: $translate.instant('global.menu.entities.organo'),
            action: function (){ $state.go('organo'); },
            icon: 'glyphicon glyphicon-asterisk',
            isActive: false,
            isVisible: true
          }, {
            name: $translate.instant('global.menu.entities.documento'),
            action: function (){ $state.go('documento'); },
            icon: 'glyphicon glyphicon-asterisk',
            isActive: false,
            isVisible: true
          }, {
            name: $translate.instant('global.menu.entities.intrumentoRelacionado'),
            action: function (){ $state.go('intrumento-relacionado'); },
            icon: 'glyphicon glyphicon-asterisk',
            isActive: false,
            isVisible: true
          }, {
            name: $translate.instant('global.menu.entities.organoRelevante'),
            action: function (){ $state.go('organo-relevante'); },
            icon: 'glyphicon glyphicon-asterisk',
            isActive: false,
            isVisible: true
          }, {
            name: $translate.instant('global.menu.entities.palabraClave'),
            action: function (){ $state.go('palabra-clave'); },
            icon: 'glyphicon glyphicon-asterisk',
            isActive: false,
            isVisible: true
          }]
        }, {
          name: $translate.instant('global.menu.admin.main'),
          icon: 'glyphicon glyphicon-tower',
          action: function (){ return; },
          hasChild: true,
          isOpen: false,
          isActive: false,
          isVisible: vm.isAdmin,
          childrens: [{
            name: $translate.instant('global.menu.admin.userManagement'),
            action: function (){ $state.go('user-management'); },
            icon: 'glyphicon glyphicon-user',
            isActive: false,
            isVisible: vm.isAdmin
          }, {
            name: $translate.instant('global.menu.admin.metrics'),
            action: function (){ $state.go('jhi-metrics'); },
            icon: 'glyphicon glyphicon-dashboard',
            isActive: false,
            isVisible: vm.isAdmin
          }, {
            name: $translate.instant('global.menu.admin.health'),
            action: function (){ $state.go('jhi-health'); },
            icon: 'glyphicon glyphicon-heart',
            isActive: false,
            isVisible: vm.isAdmin
          }, {
            name: $translate.instant('global.menu.admin.configuration'),
            action: function (){ $state.go('jhi-configuration'); },
            icon: 'glyphicon glyphicon-list-alt',
            isActive: false,
            isVisible: vm.isAdmin
          }, {
            name: $translate.instant('global.menu.admin.audits'),
            action: function (){ $state.go('audits'); },
            icon: 'glyphicon glyphicon-bell',
            isActive: false,
            isVisible: vm.isAdmin
          }, {
            name: $translate.instant('global.menu.admin.logs'),
            action: function (){ $state.go('logs'); },
            icon: 'glyphicon glyphicon-tasks',
            isActive: false,
            isVisible: vm.isAdmin
          }, {
            name: $translate.instant('global.menu.admin.apidocs'),
            action: function (){ $state.go('docs'); },
            icon: 'glyphicon glyphicon-book',
            isActive: false,
            isVisible: vm.swaggerEnabled
          }, {
            name: $translate.instant('global.menu.admin.entity-audit'),
            action: function (){ $state.go('entity-audit'); },
            icon: 'glyphicon glyphicon-list-alt',
            isActive: false,
            isVisible: vm.isAdmin
          }, {
            name: $translate.instant('global.menu.admin.elasticsearch-reindex'),
            action: function (){ $state.go('elasticsearch-reindex'); },
            icon: 'glyphicon glyphicon-refresh',
            isActive: false,
            isVisible: vm.isAdmin
          }]
        },  {
          name: $translate.instant('global.menu.account.main'),
          icon: 'glyphicon glyphicon-user',
          action: function (){ return; },
          hasChild: true,
          isOpen: false,
          isActive: false,
          isVisible: true,
          childrens: [{
            name: $translate.instant('global.menu.account.settings'),
            action: function (){ $state.go('settings'); },
            icon: 'glyphicon glyphicon-wrench',
            isActive: false,
            isVisible: true
          }, {
            name: $translate.instant('global.menu.account.password'),
            action: function (){ $state.go('password'); },
            icon: 'glyphicon glyphicon-lock',
            isActive: false,
            isVisible: true
          }, {
            name: $translate.instant('global.menu.account.logout'),
            action: logout,
            icon: 'glyphicon glyphicon-log-out',
            isActive: false,
            isVisible: true
          }]
        }];

        function login() {
            collapseNavbar();
            LoginService.open();
        }

        function logout() {
            collapseNavbar();
            Auth.logout();
            $state.go('home');
        }

        function toggleNavbar() {
            vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
        }

        function collapseNavbar() {
            vm.isNavbarCollapsed = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .controller('NavbarController', NavbarController);

    NavbarController.$inject = ['$state', 'Auth', 'Principal', 'ProfileService', 'LoginService'];

    function NavbarController ($state, Auth, Principal, ProfileService, LoginService) {
        var vm = this;

        vm.isNavbarCollapsed = true;
        vm.isAuthenticated = Principal.isAuthenticated;

        ProfileService.getProfileInfo().then(function(response) {
            vm.inProduction = response.inProduction;
            vm.swaggerEnabled = response.swaggerEnabled;
        });

        vm.login = login;
        vm.logout = logout;
        vm.toggleNavbar = toggleNavbar;
        vm.collapseNavbar = collapseNavbar;
        vm.$state = $state;

        function login() {
            collapseNavbar();
            LoginService.open();
        }

        function logout() {
            collapseNavbar();
            Auth.logout();
            $state.go('home');
        }

        function toggleNavbar() {
            vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
        }

        function collapseNavbar() {
            vm.isNavbarCollapsed = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .directive('activeMenu', activeMenu);

    activeMenu.$inject = ['$translate', '$locale', 'tmhDynamicLocale'];

    function activeMenu($translate, $locale, tmhDynamicLocale) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var language = attrs.activeMenu;

            scope.$watch(function() {
                return $translate.use();
            }, function(selectedLanguage) {
                if (language === selectedLanguage) {
                    tmhDynamicLocale.set(language);
                    element.addClass('active');
                } else {
                    element.removeClass('active');
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('error', {
                parent: 'app',
                url: '/error',
                data: {
                    authorities: [],
                    pageTitle: 'error.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/error.html'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            })
            .state('accessdenied', {
                parent: 'app',
                url: '/accessdenied',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/accessdenied.html'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            });
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .factory('Search', Search);

    Search.$inject = ['$resource'];

    function Search($resource) {
        var resourceUrl =  'public/api/search';

        return $resource(resourceUrl, {}, {
            'query': { method: 'POST', isArray: true},
            'aggs': {
              url: 'public/api/aggs',
              method: 'POST',
              isArray: false
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('home', {
            parent: 'public',
            url: '/?page&sort&search&tipo&organo&materia',
            data: {
                authorities: [],
                pageTitle: 'sgnmrApp.materia.home.title'
            },
            views: {
                'content@public': {
                    templateUrl: 'app/home/home.html',
                    controller: 'HomeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'fechaEmision,desc',
                    squash: true
                },
                search: null,
                tipo: null,
                organo: null,
                materia: null,
                emistart: null,
                emiend: null,
                pubstart: null,
                pubend: null,
                abrogado: false
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    //http://localhost:8080/public/api/search?cacheBuster=1496249646638&page=0&size=20&sort=fechaEmision,desc&sort=id

                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search,
                        tipo: $stateParams.tipo,
                        organo: $stateParams.organo,
                        materia: $stateParams.materia,
                        emistart: $stateParams.emistart,
                        emiend: $stateParams.emiend,
                        pubstart: $stateParams.pubstart,
                        pubend: $stateParams.pubend,
                        abrogado: $stateParams.abrogado
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }],
                organHierarchy: ['OrganoHierarchy', function(OrganoHierarchy) {
                    return OrganoHierarchy.get().$promise;
                }]
            }
        })
        .state('home-materia', {
            parent: 'public',
            url: '/materia/{materia}?page&sort&search&tipo&organo',
            data: {
                authorities: [],
                pageTitle: 'sgnmrApp.materia.home.title'
            },
            views: {
                'content@public': {
                    templateUrl: 'app/home/home.html',
                    controller: 'HomeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'fechaEmision,desc',
                    squash: true
                },
                search: null,
                tipo: null,
                organo: null,
                materia: null,
                emistart: null,
                emiend: null,
                pubstart: null,
                pubend: null,
                abrogado: false
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    //http://localhost:8080/public/api/search?cacheBuster=1496249646638&page=0&size=20&sort=fechaEmision,desc&sort=id

                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search,
                        tipo: $stateParams.tipo,
                        organo: $stateParams.organo,
                        materia: $stateParams.materia,
                        emistart: $stateParams.emistart,
                        emiend: $stateParams.emiend,
                        pubstart: $stateParams.pubstart,
                        pubend: $stateParams.pubend,
                        abrogado: $stateParams.abrogado
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }],
                organHierarchy: ['OrganoHierarchy', function(OrganoHierarchy) {
                    return OrganoHierarchy.get().$promise;
                }]
            }
        })
        .state('materia-abrogado', {
            parent: 'public',
            url: '/materia/{materia}/abrogado?page&sort&search',
            data: {
                authorities: [],
                pageTitle: 'sgnmrApp.materia.home.title'
            },
            views: {
                'content@public': {
                    templateUrl: 'app/home/home.html',
                    controller: 'HomeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'fechaEmision,desc',
                    squash: true
                },
                search: null,
                materia: null,
                abrogado: true
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    //http://localhost:8080/public/api/search?cacheBuster=1496249646638&page=0&size=20&sort=fechaEmision,desc&sort=id

                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search,
                        materia: $stateParams.materia,
                        abrogado: $stateParams.abrogado
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }],
                organHierarchy: ['OrganoHierarchy', function(OrganoHierarchy) {
                    return OrganoHierarchy.get().$promise;
                }]
            }
        });

    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .controller('HomeController', HomeController);

    HomeController.$inject = ['$sce','$filter','$timeout','$scope', '$state', 'Principal', 'Search', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams','organHierarchy'];

    function HomeController ($sce,$filter,$timeout,$scope, $state, Principal, Search, ParseLinks, AlertService, paginationConstants, pagingParams, organHierarchy) {
        var vm = this;

        vm.isAuthenticated = Principal.isAuthenticated;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.runSearch = runSearch;
        vm.materias = {};
        vm.tipos = {};
        vm.organos = {};
        vm.refreshSlider = refreshSlider;
        vm.translate = translate;
        vm.clearEmissionDate = clearEmissionDate;
        vm.clearPublicationDate = clearPublicationDate;
        vm.disableEmission = disableEmission;
        vm.disablePublication = disablePublication;
        vm.denominacionFormat = denominacionFormat;
        vm.criteria = {
          query: pagingParams.search,
          tipoOrdenamiento: pagingParams.tipo,
          organo: pagingParams.organo,
          materia: capitalize(pagingParams.materia),
          fechaEmisionInicial: pagingParams.emistart,
          fechaEmisionFinal: pagingParams.emiend,
          fechaPublicacionInicial: pagingParams.pubstart,
          fechaPublicacionFinal: pagingParams.pubend,
          abrogado: pagingParams.abrogado
        };
        vm.emissionDates = null;
        vm.publicationDates = null;
        vm.emissionSlider = null;
        vm.publicationSlider = null;
        vm.toggle = toggle;
        vm.toggleWords = toggleWords;
        vm.theight = {'max-height': '500px'};
        vm.orheight = {'max-height': '500px'};
        vm.expandedNodes = [];
        vm.organoHierarchy = [];
        vm.optsTree = optionsTree();
        vm.showSelected = showSelected;
        vm.getExpandedNodes = [];
        vm.state = $state.current;
        vm.fulldates = {};
        loadAll();
        function capitalize(input){
          if(input!=null && input.trim().length>1){
            return input.charAt(0).toUpperCase() + input.slice(1);
          }
          return input;
        }

        function showSelected(sel) {
            vm.selectedNode = sel;
            if(!angular.isUndefined(vm.organos[sel.nombre])){
                vm.organos[sel.nombre] = !vm.organos[sel.nombre]

            }else{
                vm.organos[sel.nombre] = true;
            }
            runSearch();
        };

        function optionsTree(){
            var opts = {
                nodeChildren: "hijos",
                dirSelectable: true,
                injectClasses: {
                    ul: "c-ul",
                    li: "c-li",
                    liSelected: "c-liSelected",
                    iExpanded: "c-iExpanded",
                    iCollapsed: "c-iCollapsed",
                    iLeaf: "c-iLeaf",

                }
            }
            return opts;
        }

        function getValuesorganos(hierarchy){
            var hierarchyarray = [];
            angular.forEach(vm.aggs.organos, function(value, key) {
                var result = $filter('filter')(hierarchy,{nombre:key}, true);
                if(!angular.isUndefined(result) && result.length>0){
                    var node = result[0];
                    node.value = value;

                    hierarchyarray.push(node);
                }

            });

            return hierarchyarray;
        }

        function organFilter(hierarchy){
            var hierarchyarray = getValuesorganos(hierarchy, parent);

            if(hierarchyarray!=null){
                for (var i = 0; i < hierarchyarray.length; i++) {
                    var array = [];
                    hierarchyarray[i].hijos = organFilter(hierarchyarray[i].hijos);

                    for (var j = 0; j < hierarchyarray[i].hijos.length; j++) {
                        var child = hierarchyarray[i].hijos[j];
                        child.padre = hierarchyarray[i];
                    };

                };
            }
            angular.forEach(vm.organos, function(value, key) {
                var expandNode = $filter('filter')(hierarchyarray,{nombre:key}, true);
                if(expandNode.length>0){
                    vm.expandedNodes.push(expandNode[0]);
                }

            });
            return hierarchyarray;
        }

        function getExpandedNodes(){

            for (var i = 0; i < vm.expandedNodes.length; i++) {
                var node = vm.expandedNodes[i];
                while(node.padre!=null){
                    var result = $filter('filter')(vm.expandedNodes,{nombre:node.padre.nombre}, true);
                    if(result.length==0 && !angular.isUndefined(node.padre)){
                        vm.expandedNodes.push(node.padre);
                    }
                    node = node.padre;
                }
            };
        }

        function loadAll () {
            Search.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, vm.criteria, onSuccess, onError);

            Search.aggs({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, vm.criteria, onAggsSuccess, onAggsError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                if(vm.criteria.query!=null && !angular.isUndefined(vm.criteria.query) && vm.criteria.query.trim().length > 0) {
                    result = [];
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.normas = data;
                vm.page = pagingParams.page;
                if(vm.totalItems==0){
                    clearCriteria();
                }else{
                  for (var i = 0; i < vm.normas.length; i++) {
                      vm.normas[i]['height'] = 'true';
                  };
                }
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }

            function onAggsSuccess(data, headers) {
                vm.aggs = data;
                vm.emissionDates = getAllDays(vm.aggs.fechasEmision);
                vm.publicationDates = getAllDays(vm.aggs.fechasPublicacion);
                vm.emissionSlider  = slider(vm.emissionDates, true);
                vm.publicationSlider = slider(vm.publicationDates, false);
                if (!angular.isUndefined(pagingParams.materia) && pagingParams.materia !== null) {
                    vm.materias[pagingParams.materia] = true;
                }

                if (!angular.isUndefined(pagingParams.tipo) && pagingParams.tipo !== null) {
                    vm.tipos[pagingParams.tipo] = true;
                }

                if (!angular.isUndefined(pagingParams.organo) && pagingParams.organo !== null) {
                    vm.organos[pagingParams.organo] = true;
                }
                vm.organoHierarchy= organFilter(organHierarchy);
                getExpandedNodes();
            }
            function onAggsError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.criteria.query,
                tipo: vm.criteria.tipoOrdenamiento,
                organo: vm.criteria.organo,
                materia: vm.criteria.materia,
                emistart: vm.criteria.fechaEmisionInicial,
                emiend: vm.criteria.fechaEmisionFinal,
                pubstart: vm.criteria.fechaPublicacionInicial,
                pubend: vm.criteria.fechaPublicacionFinal
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = false;
            vm.criteria.query = searchQuery;
            vm.transition();
        }

        function clearCriteria() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.criteria.query = null;
            vm.criteria.tipoOrdenamiento = null;
            //vm.criteria.materia = null;
            vm.criteria.organo = null;
            vm.criteria.fechaEmisionInicial = null;
            vm.criteria.fechaEmisionFinal = null;
            vm.criteria.fechaPublicacionInicial = null;
            vm.criteria.fechaPublicacionFinal = null;
        }

        function clear() {
            clearCriteria();
            vm.transition();
        }

        function runSearch() {
            vm.criteria.tipoOrdenamiento = null;
            vm.criteria.materia = null;
            vm.criteria.organo = null;
            angular.forEach(vm.tipos, function(value, key){
                if (value) {
                    vm.criteria.tipoOrdenamiento = key;
                }
            });
            angular.forEach(vm.materias, function(value, key){
                if (value) {
                    vm.criteria.materia = key;
                }
            });
            angular.forEach(vm.organos, function(value, key){
                if (value) {
                    vm.criteria.organo = key;
                }
            });

            loadPage();
        }

        function slider(data_slider, emission_flag){

            var slider = {
                minValue:data_slider[0],
                maxValue:data_slider[data_slider.length - 1],
                options: {
                     stepsArray: data_slider,


                     showTicks: true,

                      onStart: function(id) {
                      },
                      onChange: function(id) {

                      },
                      onEnd: function(id) {
                        rangeDates(emission_flag);
                        runSearch();
                      },
                      ticksTooltip: function(v) {
                        return data_slider[v];
                      },
                      getSelectionBarColor: function() {
                          return '#003A70';
                      }
                }

            };
            return slider;
        }

        function refreshSlider() {
            $timeout(function () {
            $scope.$broadcast('rzSliderForceRender');
            });
        };

        function translate(value, sliderId, label) {
            switch (label) {
              case 'model':
                return 'date'
              case 'high':
                return 'date'
              default:
                return '$' + value
            }
        }

        function getAllDays(aggs_dates) {

            var range = [];
            var dates = [];

            for (var k in aggs_dates){
                if (aggs_dates.hasOwnProperty(k)) {
                     dates.push(new Date(Number(k)));
                }
            }

            dates = dates.sort(date_sort_asc);

            for (var i = 0; i < dates.length; i++) {
                    var _date = $filter('date')(dates[i], 'MMMM yyyy');
                    if(range.indexOf(_date) < 0 ){
                        vm.fulldates[_date] = dates[i];
                        range.push(_date);
                    }
            };

            return range;
        };

        function rangeDates(emission_flag){
            var startDate ;
            var endDate;
            if(emission_flag){
                startDate = startMonth(vm.emissionSlider.minValue);
                endDate = endMonth(vm.emissionSlider.maxValue);
                if(startDate instanceof Date){
                    vm.criteria.fechaEmisionInicial = startDate;
                }
                if(endDate instanceof Date){
                    vm.criteria.fechaEmisionFinal = endDate;
                }
            }else{
                startDate = startMonth(vm.publicationSlider.minValue);
                endDate = endMonth(vm.publicationSlider.maxValue);
                if(startDate instanceof Date){
                    vm.criteria.fechaPublicacionInicial = startDate;
                }
                if(endDate instanceof Date){
                    vm.criteria.fechaPublicacionFinal = endDate;
                }
            }
        };

        function endMonth(inputDate){
          var tmp = vm.fulldates[inputDate];
          var fulldate = new Date(tmp);
          var year = fulldate.getFullYear();
          var month = fulldate.getMonth();
          var lastDay = new Date(year, month + 1, 0);
          return lastDay;
        }

        function startMonth(inputDate){
          var tmp = vm.fulldates[inputDate];
          var fulldate = new Date(tmp);
          fulldate.setDate(1);
          return fulldate;
        }

        function date_sort_asc(date1, date2) {
          if (date1 > date2) return 1;
          if (date1 < date2) return -1;
          return 0;
        };

        function date_sort_desc(date1, date2) {
          if (date1 > date2) return -1;
          if (date1 < date2) return 1;
          return 0;
        };

        function clearEmissionDate(){
            vm.criteria.fechaEmisionInicial = null;
            vm.criteria.fechaEmisionFinal = null;
            runSearch();
        };

        function clearPublicationDate(){
            vm.criteria.fechaPublicacionInicial = null;
            vm.criteria.fechaPublicacionFinal = null;
            runSearch();
        }

        function disableEmission(){
            if(vm.criteria.fechaEmisionInicial==null && vm.criteria.fechaEmisionFinal==null){
                return false;
            }
            return true;
        }

        function disablePublication(){
            if(vm.criteria.fechaPublicacionInicial==null && vm.criteria.fechaPublicacionFinal==null){
                return false;
            }
            return true;
        }

        function denominacionFormat(denom_text){
            return $sce.trustAsHtml($filter('scjnHighlight')(denom_text, vm.criteria.query));
        }

        function toggle(ctrl, value) {
            if (ctrl['max-height'] === value) {
                ctrl['max-height'] = 'auto';
            } else {
                ctrl['max-height'] = value;
            }
        }

        function toggleWords(index) {
            vm.normas[index]['height'] = !vm.normas[index]['height'];
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .controller('TipoOrdenamientoDialogController', TipoOrdenamientoDialogController);

    TipoOrdenamientoDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'TipoOrdenamiento', 'Norma'];

    function TipoOrdenamientoDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, TipoOrdenamiento, Norma) {
        var vm = this;

        vm.tipoOrdenamiento = entity;
        vm.clear = clear;
        vm.save = save;
        vm.normas = Norma.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.tipoOrdenamiento.id !== null) {
                TipoOrdenamiento.update(vm.tipoOrdenamiento, onSaveSuccess, onSaveError);
            } else {
                TipoOrdenamiento.save(vm.tipoOrdenamiento, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('sgnmrApp:tipoOrdenamientoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .controller('TipoOrdenamientoDetailController', TipoOrdenamientoDetailController);

    TipoOrdenamientoDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'TipoOrdenamiento', 'Norma'];

    function TipoOrdenamientoDetailController($scope, $rootScope, $stateParams, previousState, entity, TipoOrdenamiento, Norma) {
        var vm = this;

        vm.tipoOrdenamiento = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('sgnmrApp:tipoOrdenamientoUpdate', function(event, result) {
            vm.tipoOrdenamiento = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .controller('TipoOrdenamientoDeleteController',TipoOrdenamientoDeleteController);

    TipoOrdenamientoDeleteController.$inject = ['$uibModalInstance', 'entity', 'TipoOrdenamiento'];

    function TipoOrdenamientoDeleteController($uibModalInstance, entity, TipoOrdenamiento) {
        var vm = this;

        vm.tipoOrdenamiento = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            TipoOrdenamiento.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('tipo-ordenamiento', {
            parent: 'entity',
            url: '/tipo-ordenamiento?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sgnmrApp.tipoOrdenamiento.home.title'
            },
            views: {
                'content@private': {
                    templateUrl: 'app/entities/tipo-ordenamiento/tipo-ordenamientos.html',
                    controller: 'TipoOrdenamientoController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tipoOrdenamiento');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('tipo-ordenamiento-detail', {
            parent: 'tipo-ordenamiento',
            url: '/tipo-ordenamiento/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sgnmrApp.tipoOrdenamiento.detail.title'
            },
            views: {
                'content@private': {
                    templateUrl: 'app/entities/tipo-ordenamiento/tipo-ordenamiento-detail.html',
                    controller: 'TipoOrdenamientoDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tipoOrdenamiento');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'TipoOrdenamiento', function($stateParams, TipoOrdenamiento) {
                    return TipoOrdenamiento.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'tipo-ordenamiento',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('tipo-ordenamiento-detail.edit', {
            parent: 'tipo-ordenamiento-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tipo-ordenamiento/tipo-ordenamiento-dialog.html',
                    controller: 'TipoOrdenamientoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TipoOrdenamiento', function(TipoOrdenamiento) {
                            return TipoOrdenamiento.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('tipo-ordenamiento.new', {
            parent: 'tipo-ordenamiento',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tipo-ordenamiento/tipo-ordenamiento-dialog.html',
                    controller: 'TipoOrdenamientoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nombre: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('tipo-ordenamiento', null, { reload: 'tipo-ordenamiento' });
                }, function() {
                    $state.go('tipo-ordenamiento');
                });
            }]
        })
        .state('tipo-ordenamiento.edit', {
            parent: 'tipo-ordenamiento',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tipo-ordenamiento/tipo-ordenamiento-dialog.html',
                    controller: 'TipoOrdenamientoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TipoOrdenamiento', function(TipoOrdenamiento) {
                            return TipoOrdenamiento.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('tipo-ordenamiento', null, { reload: 'tipo-ordenamiento' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('tipo-ordenamiento.delete', {
            parent: 'tipo-ordenamiento',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tipo-ordenamiento/tipo-ordenamiento-delete-dialog.html',
                    controller: 'TipoOrdenamientoDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['TipoOrdenamiento', function(TipoOrdenamiento) {
                            return TipoOrdenamiento.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('tipo-ordenamiento', null, { reload: 'tipo-ordenamiento' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('sgnmrApp')
        .factory('TipoOrdenamiento', TipoOrdenamiento);

    TipoOrdenamiento.$inject = ['$resource'];

    function TipoOrdenamiento ($resource) {
        var resourceUrl =  'api/tipo-ordenamientos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .factory('TipoOrdenamientoSearch', TipoOrdenamientoSearch);

    TipoOrdenamientoSearch.$inject = ['$resource'];

    function TipoOrdenamientoSearch($resource) {
        var resourceUrl =  'api/_search/tipo-ordenamientos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .controller('TipoOrdenamientoController', TipoOrdenamientoController);

    TipoOrdenamientoController.$inject = ['$state', 'TipoOrdenamiento', 'TipoOrdenamientoSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function TipoOrdenamientoController($state, TipoOrdenamiento, TipoOrdenamientoSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                TipoOrdenamientoSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                TipoOrdenamiento.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.tipoOrdenamientos = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .controller('PalabraClaveDialogController', PalabraClaveDialogController);

    PalabraClaveDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PalabraClave', 'Norma'];

    function PalabraClaveDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, PalabraClave, Norma) {
        var vm = this;

        vm.palabraClave = entity;
        vm.clear = clear;
        vm.save = save;
        vm.normas = Norma.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.palabraClave.id !== null) {
                PalabraClave.update(vm.palabraClave, onSaveSuccess, onSaveError);
            } else {
                PalabraClave.save(vm.palabraClave, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('sgnmrApp:palabraClaveUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .controller('PalabraClaveDetailController', PalabraClaveDetailController);

    PalabraClaveDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'PalabraClave', 'Norma'];

    function PalabraClaveDetailController($scope, $rootScope, $stateParams, previousState, entity, PalabraClave, Norma) {
        var vm = this;

        vm.palabraClave = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('sgnmrApp:palabraClaveUpdate', function(event, result) {
            vm.palabraClave = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .controller('PalabraClaveDeleteController',PalabraClaveDeleteController);

    PalabraClaveDeleteController.$inject = ['$uibModalInstance', 'entity', 'PalabraClave'];

    function PalabraClaveDeleteController($uibModalInstance, entity, PalabraClave) {
        var vm = this;

        vm.palabraClave = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            PalabraClave.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('palabra-clave', {
            parent: 'entity',
            url: '/palabra-clave?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sgnmrApp.palabraClave.home.title'
            },
            views: {
                'content@private': {
                    templateUrl: 'app/entities/palabra-clave/palabra-claves.html',
                    controller: 'PalabraClaveController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('palabraClave');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('palabra-clave-detail', {
            parent: 'palabra-clave',
            url: '/palabra-clave/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sgnmrApp.palabraClave.detail.title'
            },
            views: {
                'content@private': {
                    templateUrl: 'app/entities/palabra-clave/palabra-clave-detail.html',
                    controller: 'PalabraClaveDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('palabraClave');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'PalabraClave', function($stateParams, PalabraClave) {
                    return PalabraClave.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'palabra-clave',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('palabra-clave-detail.edit', {
            parent: 'palabra-clave-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/palabra-clave/palabra-clave-dialog.html',
                    controller: 'PalabraClaveDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PalabraClave', function(PalabraClave) {
                            return PalabraClave.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('palabra-clave.new', {
            parent: 'palabra-clave',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/palabra-clave/palabra-clave-dialog.html',
                    controller: 'PalabraClaveDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                palabra: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('palabra-clave', null, { reload: 'palabra-clave' });
                }, function() {
                    $state.go('palabra-clave');
                });
            }]
        })
        .state('palabra-clave.edit', {
            parent: 'palabra-clave',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/palabra-clave/palabra-clave-dialog.html',
                    controller: 'PalabraClaveDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PalabraClave', function(PalabraClave) {
                            return PalabraClave.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('palabra-clave', null, { reload: 'palabra-clave' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('palabra-clave.delete', {
            parent: 'palabra-clave',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/palabra-clave/palabra-clave-delete-dialog.html',
                    controller: 'PalabraClaveDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PalabraClave', function(PalabraClave) {
                            return PalabraClave.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('palabra-clave', null, { reload: 'palabra-clave' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('sgnmrApp')
        .factory('PalabraClave', PalabraClave);

    PalabraClave.$inject = ['$resource'];

    function PalabraClave ($resource) {
        var resourceUrl =  'api/palabra-claves/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .factory('PalabraClaveSearch', PalabraClaveSearch);

    PalabraClaveSearch.$inject = ['$resource'];

    function PalabraClaveSearch($resource) {
        var resourceUrl =  'api/_search/palabra-claves/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .controller('PalabraClaveController', PalabraClaveController);

    PalabraClaveController.$inject = ['$state', 'PalabraClave', 'PalabraClaveSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function PalabraClaveController($state, PalabraClave, PalabraClaveSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                PalabraClaveSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                PalabraClave.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.palabraClaves = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('sgnmrApp')
        .factory('OrganoRelevanteNorma', OrganoRelevanteNorma);

    OrganoRelevanteNorma.$inject = ['$resource'];

    function OrganoRelevanteNorma ($resource) {
        var resourceUrl =  'api/organo-relevantes/norma/:id';

        return $resource(resourceUrl, {}, {
            
            'get': {
                method: 'GET', isArray: true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .controller('OrganoRelevanteDialogController', OrganoRelevanteDialogController);

    OrganoRelevanteDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'OrganoRelevante', 'Norma', 'Organo'];

    function OrganoRelevanteDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, OrganoRelevante, Norma, Organo) {
        var vm = this;

        vm.organoRelevante = entity;
        vm.clear = clear;
        vm.save = save;
        vm.normas = Norma.query();
        vm.organos = Organo.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.organoRelevante.id !== null) {
                OrganoRelevante.update(vm.organoRelevante, onSaveSuccess, onSaveError);
            } else {
                OrganoRelevante.save(vm.organoRelevante, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('sgnmrApp:organoRelevanteUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .controller('OrganoRelevanteDetailController', OrganoRelevanteDetailController);

    OrganoRelevanteDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'OrganoRelevante', 'Norma', 'Organo'];

    function OrganoRelevanteDetailController($scope, $rootScope, $stateParams, previousState, entity, OrganoRelevante, Norma, Organo) {
        var vm = this;

        vm.organoRelevante = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('sgnmrApp:organoRelevanteUpdate', function(event, result) {
            vm.organoRelevante = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .controller('OrganoRelevanteDeleteController',OrganoRelevanteDeleteController);

    OrganoRelevanteDeleteController.$inject = ['$uibModalInstance', 'entity', 'OrganoRelevante'];

    function OrganoRelevanteDeleteController($uibModalInstance, entity, OrganoRelevante) {
        var vm = this;

        vm.organoRelevante = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            OrganoRelevante.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('organo-relevante', {
            parent: 'entity',
            url: '/organo-relevante?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sgnmrApp.organoRelevante.home.title'
            },
            views: {
                'content@private': {
                    templateUrl: 'app/entities/organo-relevante/organo-relevantes.html',
                    controller: 'OrganoRelevanteController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('organoRelevante');
                    $translatePartialLoader.addPart('tipoOrganoRelevante');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('organo-relevante-detail', {
            parent: 'organo-relevante',
            url: '/organo-relevante/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sgnmrApp.organoRelevante.detail.title'
            },
            views: {
                'content@private': {
                    templateUrl: 'app/entities/organo-relevante/organo-relevante-detail.html',
                    controller: 'OrganoRelevanteDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('organoRelevante');
                    $translatePartialLoader.addPart('tipoOrganoRelevante');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'OrganoRelevante', function($stateParams, OrganoRelevante) {
                    return OrganoRelevante.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'organo-relevante',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('organo-relevante-detail.edit', {
            parent: 'organo-relevante-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/organo-relevante/organo-relevante-dialog.html',
                    controller: 'OrganoRelevanteDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['OrganoRelevante', function(OrganoRelevante) {
                            return OrganoRelevante.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('organo-relevante.new', {
            parent: 'organo-relevante',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/organo-relevante/organo-relevante-dialog.html',
                    controller: 'OrganoRelevanteDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                tipo: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('organo-relevante', null, { reload: 'organo-relevante' });
                }, function() {
                    $state.go('organo-relevante');
                });
            }]
        })
        .state('organo-relevante.edit', {
            parent: 'organo-relevante',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/organo-relevante/organo-relevante-dialog.html',
                    controller: 'OrganoRelevanteDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['OrganoRelevante', function(OrganoRelevante) {
                            return OrganoRelevante.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('organo-relevante', null, { reload: 'organo-relevante' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('organo-relevante.delete', {
            parent: 'organo-relevante',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/organo-relevante/organo-relevante-delete-dialog.html',
                    controller: 'OrganoRelevanteDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['OrganoRelevante', function(OrganoRelevante) {
                            return OrganoRelevante.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('organo-relevante', null, { reload: 'organo-relevante' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('sgnmrApp')
        .factory('OrganoRelevante', OrganoRelevante);

    OrganoRelevante.$inject = ['$resource'];

    function OrganoRelevante ($resource) {
        var resourceUrl =  'api/organo-relevantes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'delete': {method:'DELETE'}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .factory('OrganoRelevanteSearch', OrganoRelevanteSearch);

    OrganoRelevanteSearch.$inject = ['$resource'];

    function OrganoRelevanteSearch($resource) {
        var resourceUrl =  'api/_search/organo-relevantes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .controller('OrganoRelevanteController', OrganoRelevanteController);

    OrganoRelevanteController.$inject = ['$state', 'OrganoRelevante', 'OrganoRelevanteSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function OrganoRelevanteController($state, OrganoRelevante, OrganoRelevanteSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                OrganoRelevanteSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                OrganoRelevante.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.organoRelevantes = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .controller('OrganoDialogController', OrganoDialogController);

    OrganoDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Organo', 'OrganoRelevante','OrganoSearch'];

    function OrganoDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Organo, OrganoRelevante, OrganoSearch) {
        var vm = this;

        vm.organo = entity;
        vm.clear = clear;
        vm.save = save;
        vm.organorelevantes = OrganoRelevante.query();
        vm.autocompleteOrgano = autocompleteOrgano;
        vm.responseOrganos = [];
        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            console.log(vm.organo)
            vm.isSaving = true;
            if (vm.organo.id !== null) {
                Organo.update(vm.organo, onSaveSuccess, onSaveError);
            } else {
                Organo.save(vm.organo, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('sgnmrApp:organoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
        function autocompleteOrgano(input_query) {
            return OrganoSearch.query({
                query: formatInputQuery(input_query),
                page: 0,
                size: 100,
                sort: 'id,asc'
            }).$promise.then(function(data) {
                vm.responseOrganos = data;
                return data;
            }).catch(function() {
                console.error("error autocompleteOrgano");
                return $q.reject("error");
            });

        }
        function formatInputQuery(input_query) {
            var query = "";
            var aux_input = formatInput(input_query);
            if (aux_input != null) {
                query = "\"^" + aux_input + "\"$";
                if (query.indexOf(" ") < 0) {
                    query = query + " and " + aux_input + "*";
                }
            }
            return query;
        }

        function formatInput(input_query) {
            var output = "";
            if (input_query != null) {
                input_query.toUpperCase();
                output = input_query.replace("/", "?");
            }
            return output.trim();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .controller('OrganoDetailController', OrganoDetailController);

    OrganoDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Organo', 'OrganoRelevante'];

    function OrganoDetailController($scope, $rootScope, $stateParams, previousState, entity, Organo, OrganoRelevante) {
        var vm = this;

        vm.organo = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('sgnmrApp:organoUpdate', function(event, result) {
            vm.organo = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .controller('OrganoDeleteController',OrganoDeleteController);

    OrganoDeleteController.$inject = ['$uibModalInstance', 'entity', 'Organo'];

    function OrganoDeleteController($uibModalInstance, entity, Organo) {
        var vm = this;

        vm.organo = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Organo.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('organo', {
            parent: 'entity',
            url: '/organo?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sgnmrApp.organo.home.title'
            },
            views: {
                'content@private': {
                    templateUrl: 'app/entities/organo/organos.html',
                    controller: 'OrganoController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('organo');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('organo-detail', {
            parent: 'organo',
            url: '/organo/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sgnmrApp.organo.detail.title'
            },
            views: {
                'content@private': {
                    templateUrl: 'app/entities/organo/organo-detail.html',
                    controller: 'OrganoDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('organo');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Organo', function($stateParams, Organo) {
                    return Organo.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'organo',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('organo-detail.edit', {
            parent: 'organo-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/organo/organo-dialog.html',
                    controller: 'OrganoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Organo', function(Organo) {
                            return Organo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('organo.new', {
            parent: 'organo',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/organo/organo-dialog.html',
                    controller: 'OrganoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nombre: null,
                                nombreUnificado: null,
                                esVisible: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('organo', null, { reload: 'organo' });
                }, function() {
                    $state.go('organo');
                });
            }]
        })
        .state('organo.edit', {
            parent: 'organo',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/organo/organo-dialog.html',
                    controller: 'OrganoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Organo', function(Organo) {
                            return Organo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('organo', null, { reload: 'organo' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('organo.delete', {
            parent: 'organo',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/organo/organo-delete-dialog.html',
                    controller: 'OrganoDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Organo', function(Organo) {
                            return Organo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('organo', null, { reload: 'organo' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('sgnmrApp')
        .factory('Organo', Organo);

    Organo.$inject = ['$resource'];

    function Organo ($resource) {
        var resourceUrl =  'api/organos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .factory('OrganoSearch', OrganoSearch);

    OrganoSearch.$inject = ['$resource'];

    function OrganoSearch($resource) {
        var resourceUrl =  'api/_search/organos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('sgnmrApp')
        .factory('OrganoHierarchy', OrganoHierarchy);

    OrganoHierarchy.$inject = ['$resource'];

    function OrganoHierarchy ($resource) {
        var resourceUrl =  'public/api/aggs/organos';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',isArray: true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .controller('OrganoController', OrganoController);

    OrganoController.$inject = ['$state', 'Organo', 'OrganoSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function OrganoController($state, Organo, OrganoSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                OrganoSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Organo.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.organos = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('sgnmrApp')
        .factory('PublicNorma', PublicNorma);

    PublicNorma.$inject = ['$resource', 'DateUtils'];

    function PublicNorma ($resource, DateUtils) {
        var resourceUrl =  'public/api/normas/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',isArray: true,
                transformResponse: function (data,headers) {

                    var data_response = {};
                    if (data) {
                        data = angular.fromJson(data);
                        data.fechaEmision = DateUtils.convertDateTimeFromServer(data.fechaEmision);
                        data.fechaPublicacion = DateUtils.convertDateTimeFromServer(data.fechaPublicacion);

                    }

                    return data;
                }
            },
            'getDocuments': {
                url: resourceUrl + '/documentos',
                method: 'GET',
                isArray: true
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .controller('NormaDialogCompleteController', NormaDialogCompleteController);

    NormaDialogCompleteController.$inject = ['$q', '$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entityNorma', 'organosResponse', 'documentosResponse', 'Norma', 'Documento', 'OrganoRelevante', 'Organo', 'PalabraClave', 'Materia', 'PalabraClaveSearch', 'OrganoSearch', 'TipoOrdenamientoSearch', 'NormaSearch'];

    function NormaDialogCompleteController($q, $timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entityNorma, organosResponse, documentosResponse, Norma, Documento, OrganoRelevante, Organo, PalabraClave, Materia, PalabraClaveSearch, OrganoSearch, TipoOrdenamientoSearch, NormaSearch) {
        var vm = this;

        vm.norma = entityNorma;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;

        vm.materias = Materia.query();

        vm.uploadStart = uploadStart;
        vm.successUpload = successUpload;
        vm.removeFiles = removeFiles;
        vm.loading = false;
        vm.error = false;
        vm.completeUpload = completeUpload;
        vm.errorUpload = errorUpload;
        vm.flow = null;

        vm.numPalabras = 200;
        vm.responsePalabras = [];
        vm.responseOrganos = [];
        vm.responseOrdenamientos = [];
        vm.responseNormas = [];
        vm.addWord = addWord;
        vm.removeWord = removeWord;
        vm.autocompletePalabra = autocompletePalabra;
        vm.autocompleteOrgano = autocompleteOrgano;
        vm.autocompleteOrdenamiento = autocompleteOrdenamiento;
        vm.autocompleteNormas = autocompleteNormas;
        vm.promisesPalabra = [];
        vm.promisesOrgano = [];
        vm.organos = [];
        vm.addOrgano = addOrgano;
        vm.removeOrgano = removeOrgano;
        vm.tipoOrdenamiento;
        vm.addOrdenamiento = addOrdenamiento;
        vm.addDepurado = addDepurado;
        vm.removeDepurado = removeDepurado;
        vm.addAbrogado = addAbrogado;
        vm.removeAbrogado = removeAbrogado;
        vm.documentosResponse = documentosResponse;
        vm.deleteFile = deleteFile;
        vm.filesToRemove = [];
        ini();

        function ini() {
            if (vm.norma.tipoOrdenamientoId !== undefined && vm.norma.tipoOrdenamientoId !== null) {
                vm.modelOrdenamiento = {};
                vm.modelOrdenamiento.id = vm.norma.tipoOrdenamientoId;
                vm.modelOrdenamiento.nombre = vm.norma.tipoOrdenamientoNombre;
            }
            if (organosResponse !== null) {
                for (var i = 0; i < organosResponse.length; i++) {
                    var organo = {};
                    organo.id = organosResponse[i].organoId;
                    organo.nombre = organosResponse[i].organoNombre;
                    vm.organos.push(organo);
                };
            }
        }
        $timeout(function() {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }
        /*No se habilita save en el proceso de carga de los archivos*/
        function save() {
            vm.isSaving = true;
            createPalabrasClave();
            createOrganos();
            $q.all(vm.promisesPalabra.concat(vm.promisesOrgano)).then(function() {
                console.log("Solved all the promises");
                if (vm.norma.id !== null) {
                    Norma.update(vm.norma, onSaveNormaSuccess, onSaveNormaError);

                } else {
                    Norma.save(vm.norma, onSaveNormaSuccess, onSaveNormaError);

                }

            }).catch(function() {
                console.error("error at exec all the promises");
                return $q.reject("error");
            });

        }

        function onSaveNormaSuccess(result) {

            vm.resultNormaEntity = result;
            createDocumento();
            createOrganosRelevantes();
            removeLoadedFiles();
            $scope.$emit('sgnmrApp:normaUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;

        }

        function onSaveNormaError() {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.fechaEmision = false;
        vm.datePickerOpenStatus.fechaPublicacion = false;

        vm.setAbstractoConcreto = function($file, norma) {
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        norma.abstractoConcreto = base64Data;
                        norma.abstractoConcretoContentType = $file.type;
                    });
                });
            }
        };

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }
        ///-------------------------------
        function uploadStart($flow) {
            vm.loading = true;
            $flow.opts.headers = {
                'X-XSRF-TOKEN': getCSRF()
            };
            vm.error = false;
        }

        function getCSRF() {
            var name = "XSRF-TOKEN=";
            var ca = document.cookie.split(';');
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == ' ') c = c.substring(1);
                if (c.indexOf(name) != -1) return c.substring(name.length, c.length);
            }
            return "";
        }

        function successUpload($flow) {
            console.log("size total: " + $flow.sizeUploaded());
        }

        function removeFiles($flow, index) {
            $flow.removeFile($flow.files[index]);
        }

        function deleteFile(file) {
            vm.filesToRemove.push(file);
            for (var i = 0; i < vm.documentosResponse.length; i++) {
                if (vm.documentosResponse[i].id == file.id) {
                    vm.documentosResponse.splice(i, 1);
                    break;
                }
            }
        }

        function removeLoadedFiles() {

            for (var i = 0; i < vm.filesToRemove.length; i++) {
                console.log(vm.filesToRemove[i].nombre);
                Documento.delete({
                    id: vm.filesToRemove[i].id
                }, onDeleteDocumentSuccess, onDeleteDocumentError);
            };
        }

        function onDeleteDocumentSuccess() {
            console.log("onDeleteDocumentSuccess");
        }

        function onDeleteDocumentError() {
            console.log("onDeleteDocumentError");
        }

        function errorUpload($file, $message, $flow) {
            vm.isSaving = false;
            $flow.removeFile($file);
            vm.error = true;
            var data = angular.fromJson($message);
            vm.error_message = data.error + ". Archivo:" + $file.name + ". Intente cargar nuevamente.";
            vm.loading = false;
        }

        function completeUpload($flow) {
            vm.flow = $flow;
            vm.loading = false;

        }

        function createDocumento() {
            if (vm.flow != null) {
                var documento = null;
                for (var i = 0; i < vm.flow.files.length; i++) {
                    var doc = {};
                    documento = vm.flow.files[i];
                    doc.mimeType = documento.getType();
                    doc.nombre = documento.name;
                    doc.length = documento.size;
                    doc.path = "/files/" + documento.relativePath;
                    doc.normaId = vm.resultNormaEntity.id;
                    console.log(vm.resultNormaEntity.denominacion);
                    doc.normaDenominacion = vm.resultNormaEntity.denominacion;
                    if (documento.getType() == "pdf") {
                        doc.mimeType = "application/pdf";
                    }
                    if (doc.id == null) {
                        
                        Documento.save(doc, onSaveDocumentSuccess, onSaveDocumentError);
                    }

                }
            }
        }

        function onSaveDocumentSuccess(result) {
            console.log("onSaveDocumentSuccess");
            console.log(result);

        }

        function onSaveDocumentError() {
            console.log("onSaveDocumentError");
        }

        function autocompletePalabra(input_query) {

            return PalabraClaveSearch.query({
                query: formatInputQuery(input_query),
                page: 0,
                size: vm.numPalabras,
                sort: 'id,asc'
            }).$promise.then(function(data) {
                vm.responsePalabras = data;
                return data;
            }).catch(function() {
                console.error("error autocompletePalabra");
                return $q.reject("error");
            });
        }

        function addWord() {
            var word = {};
            var flag = false;
            if (vm.modelPalabra != null) {
                // Cuando se selecciona un elemento de la lista desplegable
                if (vm.modelPalabra.palabra != undefined) {
                    word.palabra = vm.modelPalabra.palabra;
                    word.id = vm.modelPalabra.id;
                } else { // Si no se encuentra coindicendia
                    word.palabra = vm.modelPalabra.trim();
                    word.palabra = word.palabra.toUpperCase();
                    word.id = null;
                    // En el caso de que se le "agregar" en lugar de la lista desplegada
                    for (var i = 0; i < vm.responsePalabras.length; i++) {
                            if(vm.responsePalabras[i].palabra.toUpperCase() == word.palabra){
                                 word.id = vm.responsePalabras[i].id;
                                 break;
                            }
                    };
                }
                for (var i = 0; i < vm.norma.palabrasClaves.length; i++) {
                    if (vm.norma.palabrasClaves[i].palabra == word.palabra) {
                        flag = true;
                        break;
                    }
                }
                if (!flag && word !== null) {
                    if (word.palabra.trim().length > 0) {
                        vm.norma.palabrasClaves.push(word);
                    }
                }
                vm.modelPalabra = null;
            }

        }

        function createPalabrasClave() {
            console.log(vm.norma.palabrasClaves);
            var flag = false;
            if (vm.norma.palabrasClaves !== null && vm.norma.palabrasClaves.length > 0) {

                for (var i = 0; i < vm.norma.palabrasClaves.length; i++) {
                    var palabraEntity = vm.norma.palabrasClaves[i];
                    if (palabraEntity.id === null) {
                        vm.promisesPalabra.push(promisePalabra(palabraEntity));
                    }
                }


            }
        }

        function promisePalabra(palabraEntity) {
            return PalabraClave.save(palabraEntity).$promise.then(function(result) {
                for (var i = 0; i < vm.norma.palabrasClaves.length; i++) {
                    if (vm.norma.palabrasClaves[i].palabra === result.palabra) {
                        vm.norma.palabrasClaves[i].id = result.id;
                        break;
                    }
                }
            }).catch(function() {
                console.error("error promisePalabra");
                return $q.reject("error");
            });
        }

        function autocompleteOrgano(input_query) {
            return OrganoSearch.query({
                query: formatInputQuery(input_query),
                page: 0,
                size: vm.numPalabras,
                sort: 'id,asc'
            }).$promise.then(function(data) {
                vm.responseOrganos = data;
                return data;
            }).catch(function() {
                console.error("error autocompleteOrgano");
                return $q.reject("error");
            });

        }

        function removeWord(palabra) {
            for (var i = 0; i < vm.norma.palabrasClaves.length; i++) {
                if (vm.norma.palabrasClaves[i].palabra === palabra.palabra) {
                    vm.norma.palabrasClaves.splice(i, 1);
                    break;
                }
            }
        }

        function addOrgano() {
            var organo = {};
            var flag = false;
            if (vm.modelOrgano != null) {
                if (vm.modelOrgano.nombre != undefined) {
                    organo.nombre = vm.modelOrgano.nombre;
                    organo.id = vm.modelOrgano.id;
                } else {
                    organo.nombre = vm.modelOrgano.trim();
                    organo.nombre = organo.nombre.toUpperCase();
                    organo.id = null;
                    // En el caso de que se le "agregar" en lugar de la lista desplegada
                    for (var i = 0; i < vm.responseOrganos.length; i++) {
                        if (vm.responseOrganos[i].nombre.toUpperCase() == organo.nombre) {
                            organo.id = vm.responseOrganos[i].id;
                            break;
                        }
                    };
                }
                for (var i = 0; i < vm.organos.length; i++) {
                    if (vm.organos[i].nombre == organo.nombre) {
                        flag = true;
                        break;
                    }
                }
                if (flag == false && organo != null) {
                    if (organo.nombre.trim().length > 0) {
                        vm.organos.push(organo);
                    }
                }
                vm.modelOrgano = null;
            }

        }

        function createOrganos() {
            console.log(vm.organos);
            var flag = false;
            if (vm.organos != null && vm.organos.length > 0) {

                for (var i = 0; i < vm.organos.length; i++) {
                    var organoEntity = vm.organos[i];
                    if (organoEntity.id == null) {
                        vm.promisesOrgano.push(promiseOrgano(organoEntity));
                    }
                }


            }
        }

        function promiseOrgano(organoEntity) {
            return Organo.save(organoEntity).$promise.then(function(result) {
                for (var i = 0; i < vm.organos.length; i++) {
                    if (vm.organos[i].nombre === result.nombre) {
                        vm.organos[i].id = result.id;
                        break;
                    }
                }
            }).catch(function() {
                console.error("error promiseOrgano");
                return $q.reject("error");
            });
        }

        function createOrganosRelevantes() {

            var inResponse = false;
            var inOrganos = false;

            if (vm.organos != null) {
                for (var i = 0; i < vm.organos.length; i++) {

                    if (vm.organos[i].id != null) {
                        if (organosResponse != null) {
                            for (var j = 0; j < organosResponse.length; j++) {

                                if (vm.organos[i].id == organosResponse[j].organoId) {

                                    inResponse = true;
                                    break;
                                }
                            }
                        }
                        if (inResponse == false) {
                            inResponse = false;

                            var organoRelevante = {};
                            organoRelevante.id = null;
                            organoRelevante.tipo = "EMISOR";
                            organoRelevante.normaId = vm.resultNormaEntity.id;
                            organoRelevante.normaDenominacion = vm.resultNormaEntity.denominacion;
                            organoRelevante.organoId = vm.organos[i].id;
                            organoRelevante.organoNombre = vm.organos[i].nombre;
                            console.log("save organoRelevante" + organoRelevante.organoId);
                            OrganoRelevante.save(organoRelevante, onSaveOrganoRelevanteSuccess, onSaveOrganoRelevanteError);
                        } else {
                            inResponse = false;
                        }
                    }
                }
            }
            if (organosResponse != null) {
                for (var i = 0; i < organosResponse.length; i++) {
                    if (vm.organos != null) {
                        for (var j = 0; j < vm.organos.length; j++) {
                            if (vm.organos[j].id == organosResponse[i].organoId) {
                                inOrganos = true;
                                break;
                            }
                        };
                    }
                    if (inOrganos == false) { // delete
                        inResponse = false;
                        console.log("delete organoRelevante" + organosResponse[i].organoId);
                        OrganoRelevante.delete({
                            id: organosResponse[i].id
                        }, onDeleteOrganoRelevanteSuccess, onDeleteOrganoRelevanteError);
                    } else {
                        inOrganos = false;
                    }
                };

            }

        }

        function onSaveOrganoRelevanteSuccess(result) {
            console.log("onSaveOrganoRelevanteSuccess");
            console.log(result);
        }

        function onSaveOrganoRelevanteError() {
            console.error("error onSaveOrganoRelevanteError");
        }

        function onDeleteOrganoRelevanteSuccess() {
            console.log("onDeleteOrganoRelevanteSuccess");
        }

        function onDeleteOrganoRelevanteError() {
            console.error("onDeleteOrganoRelevanteError");
        }

        function autocompleteOrdenamiento(input_query) {

            return TipoOrdenamientoSearch.query({
                query: formatInputQuery(input_query),
                page: 0,
                size: vm.numPalabras,
                sort: 'id,asc'
            }).$promise.then(function(data) {
                vm.responseOrdenamientos = data;
                return data;
            }).catch(function() {
                console.error("error autocompleteOrdenamiento");
                return $q.reject("error");
            });
        }

        function removeOrgano(organo) {

            for (var i = 0; i < vm.organos.length; i++) {
                if (vm.organos[i].nombre == organo.nombre) {
                    vm.organos.splice(i, 1);
                    break;
                }
            }
        }

        function addOrdenamiento() {
            if (vm.modelOrdenamiento != null) {
                if (vm.modelOrdenamiento.nombre != undefined) {
                    vm.norma.tipoOrdenamientoId = vm.modelOrdenamiento.id;
                    vm.norma.tipoOrdenamientoNombre = vm.modelOrdenamiento.nombre;

                } else {
                    for (var i = 0; i < vm.responseOrdenamientos.length; i++) {
                        if (vm.responseOrdenamientos[i].nombre.toUpperCase() == vm.modelOrdenamiento.toUpperCase()) {
                            console.log("añadir id Ordenamiento");
                            vm.norma.tipoOrdenamientoId = vm.responseOrdenamientos[i].id;
                            vm.norma.tipoOrdenamientoNombre = vm.responseOrdenamientos[i].nombre;
                            break;
                        }
                    };
                }
            }
        }

        function formatInputQuery(input_query) {
            var query = "";
            var aux_input = formatInput(input_query);
            if (aux_input != null) {
                query = "\"^" + aux_input + "\"$";
                if (query.indexOf(" ") < 0) {
                    query = query + " and " + aux_input + "*";
                }
            }
            return query;
        }

        function formatInput(input_query) {
            var output = "";
            if (input_query != null) {
                input_query.toUpperCase();
                output = input_query.replace("/", "?");
            }
            return output.trim();
        }

        function autocompleteNormas(input_query) {

            return NormaSearch.query({
                query: formatInputQuery(input_query),
                page: 0,
                size: "100",
                sort: 'id,asc'
            }).$promise.then(function(data) {
                vm.responseNormas = data;
                return data;
            }).catch(function() {
                console.error("error autocompleteOrdenamiento");
                return $q.reject("error");
            });
        }

        function addDepurado() {
            console.log("addDepurado");
            var depurado = {};
            var flag = false;
            if (vm.modelDepuradoNorma != null) {
                if (vm.modelDepuradoNorma.denominacion != undefined) {
                    //depurado.denominacion =  vm.modelDepuradoNorma.denominacion;
                    //depurado.id   =  vm.modelDepuradoNorma.id;
                    depurado = vm.modelDepuradoNorma;
                } else {
                    depurado.denominacion = vm.modelDepuradoNorma.trim();
                    depurado.denominacion = depurado.denominacion.toUpperCase();
                    depurado.id = null;
                    for (var i = 0; i < vm.responseNormas.length; i++) {
                        if (vm.responseNormas[i].denominacion.toUpperCase() == depurado.denominacion) {
                            depurado = vm.responseNormas[i];
                            break;
                        }
                    };
                }
                for (var i = 0; i < vm.norma.depuradoPors.length; i++) {
                    if (vm.norma.depuradoPors[i].denominacion == depurado.denominacion) {
                        flag = true;
                        break;
                    }
                }
                if (flag == false && depurado != null) {
                    if (depurado.denominacion.trim().length > 0) {

                        vm.norma.depuradoPors.push(depurado);
                    }
                }
                vm.modelDepuradoNorma = null;
            }
        }

        function removeDepurado(norma) {
            for (var i = 0; i < vm.norma.depuradoPors.length; i++) {
                if (vm.norma.depuradoPors[i].denominacion == norma.denominacion) {
                    vm.norma.depuradoPors.splice(i, 1);
                    break;
                }
            }
        }

        function addAbrogado() {
            console.log("addAbrogado");
            var abrogado = {};
            var flag = false;
            if (vm.modelAbrogadoNorma != null) {
                if (vm.modelAbrogadoNorma.denominacion != undefined) {
                    //abrogado.denominacion =  vm.modelAbrogadoNorma.denominacion;
                    //abrogado.id   =  vm.modelAbrogadoNorma.id;
                    abrogado = vm.modelAbrogadoNorma;
                } else {
                    abrogado.denominacion = vm.modelAbrogadoNorma.trim();
                    abrogado.denominacion = abrogado.denominacion.toUpperCase();
                    abrogado.id = null;
                    for (var i = 0; i < vm.responseNormas.length; i++) {
                        if (vm.responseNormas[i].denominacion.toUpperCase() == abrogado.denominacion) {
                            abrogado = vm.responseNormas[i];
                            break;
                        }
                    };
                }
                for (var i = 0; i < vm.norma.abrogadoPors.length; i++) {
                    if (vm.norma.abrogadoPors[i].denominacion == abrogado.denominacion) {
                        flag = true;
                        break;
                    }
                }
                if (flag == false && abrogado != null) {
                    if (abrogado.denominacion.trim().length > 0) {

                        vm.norma.abrogadoPors.push(abrogado);
                    }
                }
                vm.modelAbrogadoNorma = null;
            }
        }

        function removeAbrogado(norma) {
            for (var i = 0; i < vm.norma.abrogadoPors.length; i++) {
                if (vm.norma.abrogadoPors[i].denominacion == norma.denominacion) {
                    vm.norma.abrogadoPors.splice(i, 1);
                    break;
                }
            }
        }

    }

})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .controller('NormaDialogController', NormaDialogController);

    NormaDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'Norma', 'IntrumentoRelacionado', 'Documento', 'OrganoRelevante', 'PalabraClave', 'TipoOrdenamiento', 'Materia'];

    function NormaDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, Norma, IntrumentoRelacionado, Documento, OrganoRelevante, PalabraClave, TipoOrdenamiento, Materia) {
        var vm = this;

        vm.norma = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.intrumentorelacionados = IntrumentoRelacionado.query();
        vm.documentos = Documento.query();
        vm.organorelevantes = OrganoRelevante.query();
        vm.normas = Norma.query();
        vm.palabraclaves = PalabraClave.query();
        vm.tipoordenamientos = TipoOrdenamiento.query();
        vm.materias = Materia.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.norma.id !== null) {
                Norma.update(vm.norma, onSaveSuccess, onSaveError);
            } else {
                Norma.save(vm.norma, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('sgnmrApp:normaUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.fechaEmision = false;
        vm.datePickerOpenStatus.fechaPublicacion = false;
        vm.datePickerOpenStatus.fechaSJFYG = false;
        vm.datePickerOpenStatus.fechaSJFGaceta = false;
        vm.datePickerOpenStatus.fechaDOF = false;

        vm.setAbstractoConcreto = function ($file, norma) {
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        norma.abstractoConcreto = base64Data;
                        norma.abstractoConcretoContentType = $file.type;
                    });
                });
            }
        };

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .controller('NormaDetailController', NormaDetailController);

    NormaDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'Norma', 'IntrumentoRelacionado', 'Documento', 'OrganoRelevante', 'PalabraClave', 'TipoOrdenamiento', 'Materia'];

    function NormaDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, Norma, IntrumentoRelacionado, Documento, OrganoRelevante, PalabraClave, TipoOrdenamiento, Materia) {
        var vm = this;

        vm.norma = entity;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        var unsubscribe = $rootScope.$on('sgnmrApp:normaUpdate', function(event, result) {
            vm.norma = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .controller('NormaDeleteController',NormaDeleteController);

    NormaDeleteController.$inject = ['$q','$uibModalInstance', 'entity', 'organosResponse','documentosResponse', 'Norma', 'OrganoRelevante','Documento'];

    function NormaDeleteController($q, $uibModalInstance, entity, organosResponse,documentosResponse, Norma, OrganoRelevante,Documento) {
        var vm = this;

        vm.norma = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        vm.promises = [];
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
        
        function confirmDelete (id) {
                
            if(organosResponse!=null && organosResponse!=undefined && organosResponse.length>0){
                for (var i = 0; i < organosResponse.length; i++) {
                    vm.promises.push(OrganoRelevante.delete({id : organosResponse[i].id}).$promise);
                };
            }
            if(documentosResponse!=null && documentosResponse!=undefined && documentosResponse.length>0){
                for (var i = 0; i < documentosResponse.length; i++) {
                    vm.promises.push(Documento.delete({id : documentosResponse[i].id}).$promise);
                };
            }
            $q.all(vm.promises).then(function () {
                    Norma.delete({id: id},
                        function () {
                            $uibModalInstance.close(true);
                    });

            }).catch(function() {
                console.error("error at exec all the promises");
            }); 
            
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('norma', {
            parent: 'entity',
            url: '/norma?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sgnmrApp.norma.home.title'
            },
            views: {
                'content@private': {
                    templateUrl: 'app/entities/norma/normas.html',
                    controller: 'NormaController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,desc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('norma');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('norma.nuevo', {
            parent: 'norma',
            url: '/nuevo',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/norma/norma-dialog-complete.html',
                    controller: 'NormaDialogCompleteController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entityNorma: function () {
                            return {
                                denominacion: null,
                                fechaEmision: null,
                                fechaPublicacion: null,
                                fechaDOF: null,
                                fechaSJFYG: null,
                                fechaSJFGaceta: null,
                                depurado: null,
                                noEsInstrumentoNormativo: null,
                                abstractoConcreto: null,
                                abstractoConcretoContentType: null,
                                validezTemporalFin: null,
                                esCoyuntural: null,
                                estableceMontosEconomicos: null,
                                montosReqAct: null,
                                montosEstFrecAct: null,
                                vigencia: null,
                                showOnlyYear: null,
                                esVisible: true,
                                abrogado: false,
                                id: null,
                                palabrasClaves:[],
                                depuradoPors: [],
                                abrogadoPors:[]
                            };
                        },
                        organosResponse: function(){
                            return null;
                        },
                        documentosResponse:  function(){
                            return null;
                        }
                    }
                }).result.then(function() {
                    $state.go('norma', null, { reload: 'norma' });
                }, function() {
                    $state.go('norma');
                });
            }]
        })

        .state('norma-detail', {
            parent: 'norma',
            url: '/norma/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sgnmrApp.norma.detail.title'
            },
            views: {
                'content@private': {
                    templateUrl: 'app/entities/norma/norma-detail.html',
                    controller: 'NormaDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('norma');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Norma', function($stateParams, Norma) {
                    return Norma.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'norma',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('norma-detail.edit', {
            parent: 'norma-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/norma/norma-dialog-complete.html',
                    controller: 'NormaDialogCompleteController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entityNorma: ['Norma', function(Norma) {
                            return Norma.get({id : $stateParams.id}).$promise;
                        }],
                        organosResponse: ['OrganoRelevanteNorma', function(OrganoRelevanteNorma) {

                            return OrganoRelevanteNorma.get({id : $stateParams.id}).$promise;
                        }],
                        documentosResponse: ['DocumentoNorma', function(DocumentoNorma) {
                            return DocumentoNorma.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('norma.new', {
            parent: 'norma',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/norma/norma-dialog.html',
                    controller: 'NormaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                denominacion: null,
                                fechaEmision: null,
                                fechaPublicacion: null,
                                fechaDOF: null,
                                fechaSJFYG: null,
                                fechaSJFGaceta: null,
                                depurado: null,
                                noEsInstrumentoNormativo: null,
                                abstractoConcreto: null,
                                abstractoConcretoContentType: null,
                                validezTemporalFin: null,
                                esCoyuntural: null,
                                estableceMontosEconomicos: null,
                                montosReqAct: null,
                                montosEstFrecAct: null,
                                vigencia: null,
                                showOnlyYear: null,
                                esVisible: null,
                                abrogado: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('norma', null, { reload: 'norma' });
                }, function() {
                    $state.go('norma');
                });
            }]
        })
        .state('norma.edit', {
            parent: 'norma',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/norma/norma-dialog-complete.html',
                    controller: 'NormaDialogCompleteController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entityNorma: ['Norma', function(Norma) {
                            return Norma.get({id : $stateParams.id}).$promise;
                        }],
                        organosResponse: ['OrganoRelevanteNorma', function(OrganoRelevanteNorma) {

                            return OrganoRelevanteNorma.get({id : $stateParams.id}).$promise;
                        }],
                        documentosResponse: ['DocumentoNorma', function(DocumentoNorma) {
                            return DocumentoNorma.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('norma', null, { reload: 'norma' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('norma.delete', {
            parent: 'norma',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/norma/norma-delete-dialog.html',
                    controller: 'NormaDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Norma', function(Norma) {
                            return Norma.get({id : $stateParams.id}).$promise;
                        }],
                        organosResponse: ['OrganoRelevanteNorma', function(OrganoRelevanteNorma) {

                            return OrganoRelevanteNorma.get({id : $stateParams.id}).$promise;
                        }],
                        documentosResponse: ['DocumentoNorma', function(DocumentoNorma) {
                            return DocumentoNorma.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('norma', null, { reload: 'norma' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('sgnmrApp')
        .factory('Norma', Norma);

    Norma.$inject = ['$resource', 'DateUtils'];

    function Norma ($resource, DateUtils) {
        var resourceUrl =  'api/normas/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.fechaEmision = DateUtils.convertDateTimeFromServer(data.fechaEmision);
                        data.fechaPublicacion = DateUtils.convertDateTimeFromServer(data.fechaPublicacion);
                        data.fechaDOF = DateUtils.convertDateTimeFromServer(data.fechaDOF);
                        data.fechaSJFYG = DateUtils.convertDateTimeFromServer(data.fechaSJFYG);
                        data.fechaSJFGaceta = DateUtils.convertDateTimeFromServer(data.fechaSJFGaceta);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'delete': {method: 'DELETE'},
            'index': {
                url: 'api/normas/index/:id',
                method: 'GET'
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .factory('NormaSearch', NormaSearch);

    NormaSearch.$inject = ['$resource'];

    function NormaSearch($resource) {
        var resourceUrl =  'public/api/_search/normas/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .controller('NormaController', NormaController);

    NormaController.$inject = ['$state', 'DataUtils', 'Norma', 'NormaSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function NormaController($state, DataUtils, Norma, NormaSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;
        vm.normaIndex = normaIndex;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                NormaSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Norma.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.normas = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

        function normaIndex(id) {
            Norma.index({
                id: id
            }, onSuccess, onError);

            function onSuccess(data, headers) {
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .controller('MateriaDialogController', MateriaDialogController);

    MateriaDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Materia', 'Norma'];

    function MateriaDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Materia, Norma) {
        var vm = this;

        vm.materia = entity;
        vm.clear = clear;
        vm.save = save;
        vm.normas = Norma.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.materia.id !== null) {
                Materia.update(vm.materia, onSaveSuccess, onSaveError);
            } else {
                Materia.save(vm.materia, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('sgnmrApp:materiaUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .controller('MateriaDetailController', MateriaDetailController);

    MateriaDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Materia', 'Norma'];

    function MateriaDetailController($scope, $rootScope, $stateParams, previousState, entity, Materia, Norma) {
        var vm = this;

        vm.materia = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('sgnmrApp:materiaUpdate', function(event, result) {
            vm.materia = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .controller('MateriaDeleteController',MateriaDeleteController);

    MateriaDeleteController.$inject = ['$uibModalInstance', 'entity', 'Materia'];

    function MateriaDeleteController($uibModalInstance, entity, Materia) {
        var vm = this;

        vm.materia = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Materia.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('materia', {
            parent: 'entity',
            url: '/entityMateria?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sgnmrApp.materia.home.title'
            },
            views: {
                'content@private': {
                    templateUrl: 'app/entities/materia/materias.html',
                    controller: 'MateriaController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('materia');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('materia-detail', {
            parent: 'materia',
            url: '/entityMateria/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sgnmrApp.materia.detail.title'
            },
            views: {
                'content@private': {
                    templateUrl: 'app/entities/materia/materia-detail.html',
                    controller: 'MateriaDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('materia');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Materia', function($stateParams, Materia) {
                    return Materia.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'materia',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('materia-detail.edit', {
            parent: 'materia-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/materia/materia-dialog.html',
                    controller: 'MateriaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Materia', function(Materia) {
                            return Materia.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('materia.new', {
            parent: 'materia',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/materia/materia-dialog.html',
                    controller: 'MateriaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nombre: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('materia', null, { reload: 'materia' });
                }, function() {
                    $state.go('materia');
                });
            }]
        })
        .state('materia.edit', {
            parent: 'materia',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/materia/materia-dialog.html',
                    controller: 'MateriaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Materia', function(Materia) {
                            return Materia.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('materia', null, { reload: 'materia' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('materia.delete', {
            parent: 'materia',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/materia/materia-delete-dialog.html',
                    controller: 'MateriaDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Materia', function(Materia) {
                            return Materia.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('materia', null, { reload: 'materia' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('sgnmrApp')
        .factory('Materia', Materia);

    Materia.$inject = ['$resource'];

    function Materia ($resource) {
        var resourceUrl =  'api/materias/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .factory('MateriaSearch', MateriaSearch);

    MateriaSearch.$inject = ['$resource'];

    function MateriaSearch($resource) {
        var resourceUrl =  'api/_search/materias/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .controller('MateriaController', MateriaController);

    MateriaController.$inject = ['$state', 'Materia', 'MateriaSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function MateriaController($state, Materia, MateriaSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                MateriaSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Materia.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.materias = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .controller('IntrumentoRelacionadoDialogController', IntrumentoRelacionadoDialogController);

    IntrumentoRelacionadoDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'entity', 'IntrumentoRelacionado', 'Norma'];

    function IntrumentoRelacionadoDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $q, entity, IntrumentoRelacionado, Norma) {
        var vm = this;

        vm.intrumentoRelacionado = entity;
        vm.clear = clear;
        vm.save = save;
        vm.normarelacionadas = Norma.query({filter: 'relacionado-is-null'});
        $q.all([vm.intrumentoRelacionado.$promise, vm.normarelacionadas.$promise]).then(function() {
            if (!vm.intrumentoRelacionado.normaRelacionadaId) {
                return $q.reject();
            }
            return Norma.get({id : vm.intrumentoRelacionado.normaRelacionadaId}).$promise;
        }).then(function(normaRelacionada) {
            vm.normarelacionadas.push(normaRelacionada);
        });
        vm.normas = Norma.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.intrumentoRelacionado.id !== null) {
                IntrumentoRelacionado.update(vm.intrumentoRelacionado, onSaveSuccess, onSaveError);
            } else {
                IntrumentoRelacionado.save(vm.intrumentoRelacionado, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('sgnmrApp:intrumentoRelacionadoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .controller('IntrumentoRelacionadoDetailController', IntrumentoRelacionadoDetailController);

    IntrumentoRelacionadoDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'IntrumentoRelacionado', 'Norma'];

    function IntrumentoRelacionadoDetailController($scope, $rootScope, $stateParams, previousState, entity, IntrumentoRelacionado, Norma) {
        var vm = this;

        vm.intrumentoRelacionado = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('sgnmrApp:intrumentoRelacionadoUpdate', function(event, result) {
            vm.intrumentoRelacionado = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .controller('IntrumentoRelacionadoDeleteController',IntrumentoRelacionadoDeleteController);

    IntrumentoRelacionadoDeleteController.$inject = ['$uibModalInstance', 'entity', 'IntrumentoRelacionado'];

    function IntrumentoRelacionadoDeleteController($uibModalInstance, entity, IntrumentoRelacionado) {
        var vm = this;

        vm.intrumentoRelacionado = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            IntrumentoRelacionado.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('intrumento-relacionado', {
            parent: 'entity',
            url: '/intrumento-relacionado?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sgnmrApp.intrumentoRelacionado.home.title'
            },
            views: {
                'content@private': {
                    templateUrl: 'app/entities/intrumento-relacionado/intrumento-relacionados.html',
                    controller: 'IntrumentoRelacionadoController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('intrumentoRelacionado');
                    $translatePartialLoader.addPart('tipoRelacionInstrumento');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('intrumento-relacionado-detail', {
            parent: 'intrumento-relacionado',
            url: '/intrumento-relacionado/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sgnmrApp.intrumentoRelacionado.detail.title'
            },
            views: {
                'content@private': {
                    templateUrl: 'app/entities/intrumento-relacionado/intrumento-relacionado-detail.html',
                    controller: 'IntrumentoRelacionadoDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('intrumentoRelacionado');
                    $translatePartialLoader.addPart('tipoRelacionInstrumento');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'IntrumentoRelacionado', function($stateParams, IntrumentoRelacionado) {
                    return IntrumentoRelacionado.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'intrumento-relacionado',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('intrumento-relacionado-detail.edit', {
            parent: 'intrumento-relacionado-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/intrumento-relacionado/intrumento-relacionado-dialog.html',
                    controller: 'IntrumentoRelacionadoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['IntrumentoRelacionado', function(IntrumentoRelacionado) {
                            return IntrumentoRelacionado.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('intrumento-relacionado.new', {
            parent: 'intrumento-relacionado',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/intrumento-relacionado/intrumento-relacionado-dialog.html',
                    controller: 'IntrumentoRelacionadoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                denominacion: null,
                                tipo: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('intrumento-relacionado', null, { reload: 'intrumento-relacionado' });
                }, function() {
                    $state.go('intrumento-relacionado');
                });
            }]
        })
        .state('intrumento-relacionado.edit', {
            parent: 'intrumento-relacionado',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/intrumento-relacionado/intrumento-relacionado-dialog.html',
                    controller: 'IntrumentoRelacionadoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['IntrumentoRelacionado', function(IntrumentoRelacionado) {
                            return IntrumentoRelacionado.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('intrumento-relacionado', null, { reload: 'intrumento-relacionado' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('intrumento-relacionado.delete', {
            parent: 'intrumento-relacionado',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/intrumento-relacionado/intrumento-relacionado-delete-dialog.html',
                    controller: 'IntrumentoRelacionadoDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['IntrumentoRelacionado', function(IntrumentoRelacionado) {
                            return IntrumentoRelacionado.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('intrumento-relacionado', null, { reload: 'intrumento-relacionado' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('sgnmrApp')
        .factory('IntrumentoRelacionado', IntrumentoRelacionado);

    IntrumentoRelacionado.$inject = ['$resource'];

    function IntrumentoRelacionado ($resource) {
        var resourceUrl =  'api/intrumento-relacionados/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .factory('IntrumentoRelacionadoSearch', IntrumentoRelacionadoSearch);

    IntrumentoRelacionadoSearch.$inject = ['$resource'];

    function IntrumentoRelacionadoSearch($resource) {
        var resourceUrl =  'api/_search/intrumento-relacionados/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .controller('IntrumentoRelacionadoController', IntrumentoRelacionadoController);

    IntrumentoRelacionadoController.$inject = ['$state', 'IntrumentoRelacionado', 'IntrumentoRelacionadoSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function IntrumentoRelacionadoController($state, IntrumentoRelacionado, IntrumentoRelacionadoSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                IntrumentoRelacionadoSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                IntrumentoRelacionado.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.intrumentoRelacionados = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('entity', {
            abstract: true,
            parent: 'private'
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('sgnmrApp')
        .factory('DocumentoNorma', DocumentoNorma);

    DocumentoNorma.$inject = ['$resource'];

    function DocumentoNorma ($resource) {
        var resourceUrl =  'api/documentos/norma/:id';

        return $resource(resourceUrl, {}, {
            
            'get': {
                method: 'GET',isArray: true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }

        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .controller('DocumentoDialogController', DocumentoDialogController);

    DocumentoDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Documento', 'Norma'];

    function DocumentoDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Documento, Norma) {
        var vm = this;

        vm.documento = entity;
        vm.clear = clear;
        vm.save = save;
        vm.normas = Norma.query();
        vm.uploadStart =uploadStart;
        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.documento.id !== null) {
                Documento.update(vm.documento, onSaveSuccess, onSaveError);
            } else {
                Documento.save(vm.documento, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('sgnmrApp:documentoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
        function uploadStart($flow){   
            //X-XSRF-TOKEN
            $flow.opts.headers =  {'X-XSRF-TOKEN' : getCSRF()};
        }
        function getCSRF() {
            var name = "XSRF-TOKEN=";
            var ca = document.cookie.split(';');
            for(var i=0; i<ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0)==' ') c = c.substring(1);
                if (c.indexOf(name) != -1) return c.substring(name.length,c.length);
            }
            return "";
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .controller('DocumentoDetailController', DocumentoDetailController);

    DocumentoDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Documento', 'Norma'];

    function DocumentoDetailController($scope, $rootScope, $stateParams, previousState, entity, Documento, Norma) {
        var vm = this;

        vm.documento = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('sgnmrApp:documentoUpdate', function(event, result) {
            vm.documento = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .controller('DocumentoDeleteController',DocumentoDeleteController);

    DocumentoDeleteController.$inject = ['$uibModalInstance', 'entity', 'Documento'];

    function DocumentoDeleteController($uibModalInstance, entity, Documento) {
        var vm = this;

        vm.documento = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Documento.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('documento', {
            parent: 'entity',
            url: '/documento?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sgnmrApp.documento.home.title'
            },
            views: {
                'content@private': {
                    templateUrl: 'app/entities/documento/documentos.html',
                    controller: 'DocumentoController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('documento');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('documento-detail', {
            parent: 'documento',
            url: '/documento/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sgnmrApp.documento.detail.title'
            },
            views: {
                'content@private': {
                    templateUrl: 'app/entities/documento/documento-detail.html',
                    controller: 'DocumentoDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('documento');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Documento', function($stateParams, Documento) {
                    return Documento.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'documento',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('documento-detail.edit', {
            parent: 'documento-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/documento/documento-dialog.html',
                    controller: 'DocumentoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Documento', function(Documento) {
                            return Documento.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('documento.new', {
            parent: 'documento',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/documento/documento-dialog.html',
                    controller: 'DocumentoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nombre: null,
                                descripcion: null,
                                mimeType: null,
                                length: null,
                                path: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('documento', null, { reload: 'documento' });
                }, function() {
                    $state.go('documento');
                });
            }]
        })
        .state('documento.edit', {
            parent: 'documento',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/documento/documento-dialog.html',
                    controller: 'DocumentoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Documento', function(Documento) {
                            return Documento.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('documento', null, { reload: 'documento' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('documento.delete', {
            parent: 'documento',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/documento/documento-delete-dialog.html',
                    controller: 'DocumentoDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Documento', function(Documento) {
                            return Documento.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('documento', null, { reload: 'documento' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('sgnmrApp')
        .factory('Documento', Documento);

    Documento.$inject = ['$resource'];

    function Documento ($resource) {
        var resourceUrl =  'api/documentos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'delete': { method:'DELETE' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .factory('DocumentoSearch', DocumentoSearch);

    DocumentoSearch.$inject = ['$resource'];

    function DocumentoSearch($resource) {
        var resourceUrl =  'api/_search/documentos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .controller('DocumentoController', DocumentoController);

    DocumentoController.$inject = ['$state', 'Documento', 'DocumentoSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function DocumentoController($state, Documento, DocumentoSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                DocumentoSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Documento.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.documentos = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .filter('words', words);

    function words() {
        return wordsFilter;

        function wordsFilter(input, words) {
            if (isNaN(words)) {
                return input;
            }
            if (words <= 0) {
                return '';
            }
            if (input) {
                var inputWords = input.split(/\s+/);
                if (inputWords.length > words) {
                    input = inputWords.slice(0, words).join(' ') + '...';
                }
            }
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .filter('characters', characters);

    function characters () {
        return charactersFilter;

        function charactersFilter(input, chars, breakOnWord) {
            if (isNaN(chars)) {
                return input;
            }
            if (chars <= 0) {
                return '';
            }
            if (input && input.length > chars) {
                input = input.substring(0, chars);

                if (!breakOnWord) {
                    var lastspace = input.lastIndexOf(' ');
                    // Get last space
                    if (lastspace !== -1) {
                        input = input.substr(0, lastspace);
                    }
                } else {
                    while (input.charAt(input.length-1) === ' ') {
                        input = input.substr(0, input.length - 1);
                    }
                }
                return input + '...';
            }
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .directive('jhSortBy', jhSortBy);

    function jhSortBy() {
        var directive = {
            restrict: 'A',
            scope: false,
            require: '^jhSort',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs, parentCtrl) {
            element.bind('click', function () {
                parentCtrl.sort(attrs.jhSortBy);
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .directive('jhSort', jhSort);

    function jhSort () {
        var directive = {
            restrict: 'A',
            scope: {
                predicate: '=jhSort',
                ascending: '=',
                callback: '&'
            },
            controller: SortController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;
    }

    SortController.$inject = ['$scope', '$element'];

    function SortController ($scope, $element) {
        var vm = this;

        vm.applyClass = applyClass;
        vm.resetClasses = resetClasses;
        vm.sort = sort;
        vm.triggerApply = triggerApply;

        $scope.$watchGroup(['vm.predicate', 'vm.ascending'], vm.triggerApply);
        vm.triggerApply();

        function applyClass (element) {
            var thisIcon = element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt',
                remove = sortIcon + ' ' + sortDesc,
                add = sortAsc;
            if (!vm.ascending) {
                remove = sortIcon + ' ' + sortAsc;
                add = sortDesc;
            }
            vm.resetClasses();
            thisIcon.removeClass(remove);
            thisIcon.addClass(add);
        }

        function resetClasses () {
            var allThIcons = $element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt';
            allThIcons.removeClass(sortAsc + ' ' + sortDesc);
            allThIcons.addClass(sortIcon);
        }

        function sort (field) {
            if (field !== vm.predicate) {
                vm.ascending = true;
            } else {
                vm.ascending = !vm.ascending;
            }
            vm.predicate = field;
            $scope.$apply();
            vm.callback();
        }

        function triggerApply (values)  {
            vm.resetClasses();
            if (values && values[0] !== 'id') {
                vm.applyClass($element.find('th[jh-sort-by=\'' + values[0] + '\']'));
            }
        }
    }
})();

(function(){
    'use strict';

    angular
        .module('sgnmrApp')
        .factory('ParseLinks', ParseLinks);

    function ParseLinks () {

        var service = {
            parse : parse
        };

        return service;

        function parse(header) {
            if (header.length === 0) {
                throw new Error('input must not be of zero length');
            }

            // Split parts by comma
            var parts = header.split(',');
            var links = {};
            // Parse each part into a named link
            angular.forEach(parts, function(p) {
                var section = p.split('>;');
                if (section.length !== 2) {
                    throw new Error('section could not be split on ">;"');
                }
                var url = section[0].replace(/<(.*)/, '$1').trim();
                var queryString = {};
                url.replace(
                    new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
                    function($0, $1, $2, $3) { queryString[$1] = $3; }
                );
                var page = queryString.page;
                if (angular.isString(page)) {
                    page = parseInt(page);
                }
                var name = section[1].replace(/rel="(.*)"/, '$1').trim();
                links[name] = page;
            });
            return links;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('sgnmrApp')
        .factory('PaginationUtil', PaginationUtil);

    function PaginationUtil () {

        var service = {
            parseAscending : parseAscending,
            parsePage : parsePage,
            parsePredicate : parsePredicate
        };

        return service;

        function parseAscending (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                return sort.split(',').slice(-1)[0] === 'asc';
            } else {
                // default to true if no sort defined
                return true;
            }
        }

        // query params are strings, and need to be parsed
        function parsePage (page) {
            return parseInt(page);
        }

        // sort can be in the format `id,asc` or `id`
        function parsePredicate (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                sortArray.pop();
            }
            return sortArray.join(',');
        }
    }
})();

(function() {
    'use strict';

    var jhiItemCount = {
        template: '<div class="info" data-translate="global.item-count" ' +
        'translate-value-first="{{(($ctrl.page - 1) * $ctrl.itemsPerPage) == 0 ? 1 : (($ctrl.page - 1) * $ctrl.itemsPerPage + 1)}}" ' +
        'translate-value-second="{{($ctrl.page * $ctrl.itemsPerPage) < $ctrl.queryCount ? ($ctrl.page * $ctrl.itemsPerPage) : $ctrl.queryCount}}" ' +
        'translate-value-total="{{$ctrl.queryCount}}">' +
        'Showing {{(($ctrl.page - 1) * $ctrl.itemsPerPage) == 0 ? 1 : (($ctrl.page - 1) * $ctrl.itemsPerPage + 1)}} - ' +
        '{{($ctrl.page * $ctrl.itemsPerPage) < $ctrl.queryCount ? ($ctrl.page * $ctrl.itemsPerPage) : $ctrl.queryCount}} ' +
        'of {{$ctrl.queryCount}} items.' +
        '</div>',
        bindings: {
            page: '<',
            queryCount: '<total',
            itemsPerPage: '<'
        }
    };

    angular
        .module('sgnmrApp')
        .component('jhiItemCount', jhiItemCount);
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .factory('DateUtils', DateUtils);

    DateUtils.$inject = ['$filter'];

    function DateUtils($filter) {

        var service = {
            convertDateTimeFromServer: convertDateTimeFromServer,
            convertLocalDateFromServer: convertLocalDateFromServer,
            convertLocalDateToServer: convertLocalDateToServer,
            dateformat: dateformat
        };

        return service;

        function convertDateTimeFromServer(date) {
            if (date) {
                return new Date(date);
            } else {
                return null;
            }
        }

        function convertLocalDateFromServer(date) {
            if (date) {
                var dateString = date.split('-');
                return new Date(dateString[0], dateString[1] - 1, dateString[2]);
            }
            return null;
        }

        function convertLocalDateToServer(date) {
            if (date) {
                return $filter('date')(date, 'yyyy-MM-dd');
            } else {
                return null;
            }
        }

        function dateformat() {
            return 'yyyy-MM-dd';
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .factory('DataUtils', DataUtils);

    DataUtils.$inject = ['$window'];

    function DataUtils ($window) {

        var service = {
            abbreviate: abbreviate,
            byteSize: byteSize,
            openFile: openFile,
            toBase64: toBase64
        };

        return service;

        function abbreviate (text) {
            if (!angular.isString(text)) {
                return '';
            }
            if (text.length < 30) {
                return text;
            }
            return text ? (text.substring(0, 15) + '...' + text.slice(-10)) : '';
        }

        function byteSize (base64String) {
            if (!angular.isString(base64String)) {
                return '';
            }

            function endsWith(suffix, str) {
                return str.indexOf(suffix, str.length - suffix.length) !== -1;
            }

            function paddingSize(base64String) {
                if (endsWith('==', base64String)) {
                    return 2;
                }
                if (endsWith('=', base64String)) {
                    return 1;
                }
                return 0;
            }

            function size(base64String) {
                return base64String.length / 4 * 3 - paddingSize(base64String);
            }

            function formatAsBytes(size) {
                return size.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' bytes';
            }

            return formatAsBytes(size(base64String));
        }

        function openFile (type, data) {
            $window.open('data:' + type + ';base64,' + data, '_blank', 'height=300,width=400');
        }

        function toBase64 (file, cb) {
            var fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = function (e) {
                var base64Data = e.target.result.substr(e.target.result.indexOf('base64,') + 'base64,'.length);
                cb(base64Data);
            };
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .filter('capitalize', capitalize);

    function capitalize() {
        return capitalizeFilter;

        function capitalizeFilter (input) {
            if (input !== null) {
                input = input.toLowerCase();
                input = input.substring(0, 1).toUpperCase() + input.substring(1);
            }
            return input;
        }
    }
})();

(function() {
    /*jshint bitwise: false*/
    'use strict';

    angular
        .module('sgnmrApp')
        .factory('Base64', Base64);

    function Base64 () {
        var keyStr = 'ABCDEFGHIJKLMNOP' +
            'QRSTUVWXYZabcdef' +
            'ghijklmnopqrstuv' +
            'wxyz0123456789+/' +
            '=';

        var service = {
            decode : decode,
            encode : encode
        };

        return service;

        function encode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            while (i < input.length) {
                chr1 = input.charCodeAt(i++);
                chr2 = input.charCodeAt(i++);
                chr3 = input.charCodeAt(i++);

                enc1 = chr1 >> 2;
                enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                enc4 = chr3 & 63;

                if (isNaN(chr2)) {
                    enc3 = enc4 = 64;
                } else if (isNaN(chr3)) {
                    enc4 = 64;
                }

                output = output +
                    keyStr.charAt(enc1) +
                    keyStr.charAt(enc2) +
                    keyStr.charAt(enc3) +
                    keyStr.charAt(enc4);
            }

            return output;
        }

        function decode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
            input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

            while (i < input.length) {
                enc1 = keyStr.indexOf(input.charAt(i++));
                enc2 = keyStr.indexOf(input.charAt(i++));
                enc3 = keyStr.indexOf(input.charAt(i++));
                enc4 = keyStr.indexOf(input.charAt(i++));

                chr1 = (enc1 << 2) | (enc2 >> 4);
                chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
                chr3 = ((enc3 & 3) << 6) | enc4;

                output = output + String.fromCharCode(chr1);

                if (enc3 !== 64) {
                    output = output + String.fromCharCode(chr2);
                }
                if (enc4 !== 64) {
                    output = output + String.fromCharCode(chr3);
                }
            }

            return output;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .factory('LoginService', LoginService);

    LoginService.$inject = ['$uibModal'];

    function LoginService ($uibModal) {
        var service = {
            open: open
        };

        var modalInstance = null;
        var resetModal = function () {
            modalInstance = null;
        };

        return service;

        function open () {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/components/login/login.html',
                controller: 'LoginController',
                controllerAs: 'vm',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('login');
                        return $translate.refresh();
                    }]
                }
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .controller('LoginController', LoginController);

    LoginController.$inject = ['$rootScope', '$state', '$timeout', 'Auth', '$uibModalInstance'];

    function LoginController ($rootScope, $state, $timeout, Auth, $uibModalInstance) {
        var vm = this;

        vm.authenticationError = false;
        vm.cancel = cancel;
        vm.credentials = {};
        vm.login = login;
        vm.password = null;
        vm.register = register;
        vm.rememberMe = true;
        vm.requestResetPassword = requestResetPassword;
        vm.username = null;

        $timeout(function (){angular.element('#username').focus();});

        function cancel () {
            vm.credentials = {
                username: null,
                password: null,
                rememberMe: true
            };
            vm.authenticationError = false;
            $uibModalInstance.dismiss('cancel');
        }

        function login (event) {
            event.preventDefault();
            Auth.login({
                username: vm.username,
                password: vm.password,
                rememberMe: vm.rememberMe
            }).then(function () {
                vm.authenticationError = false;
                $uibModalInstance.close();
                if ($state.current.name === 'register' || $state.current.name === 'activate' ||
                    $state.current.name === 'finishReset' || $state.current.name === 'requestReset') {
                    $state.go('home');
                }

                $rootScope.$broadcast('authenticationSuccess');

                // previousState was set in the authExpiredInterceptor before being redirected to login modal.
                // since login is successful, go to stored previousState and clear previousState
                if (Auth.getPreviousState()) {
                    var previousState = Auth.getPreviousState();
                    Auth.resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }
            }).catch(function () {
                vm.authenticationError = true;
            });
        }

        function register () {
            $uibModalInstance.dismiss('cancel');
            $state.go('register');
        }

        function requestResetPassword () {
            $uibModalInstance.dismiss('cancel');
            $state.go('requestReset');
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('sgnmrApp')
        .factory('JhiLanguageService', JhiLanguageService);

    JhiLanguageService.$inject = ['$q', '$http', '$translate', 'LANGUAGES'];

    function JhiLanguageService ($q, $http, $translate, LANGUAGES) {
        var service = {
            getAll: getAll,
            getCurrent: getCurrent
        };

        return service;

        function getAll () {
            var deferred = $q.defer();
            deferred.resolve(LANGUAGES);
            return deferred.promise;
        }

        function getCurrent () {
            var deferred = $q.defer();
            var language = $translate.storage().get('NG_TRANSLATE_LANG_KEY');

            deferred.resolve(language);

            return deferred.promise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .filter('findLanguageFromKey', findLanguageFromKey)
        .filter('findLanguageRtlFromKey', findLanguageRtlFromKey);

    var languages = {
        'en': { name: 'English' },
        'es': { name: 'Español' }
        // jhipster-needle-i18n-language-key-pipe - JHipster will add/remove languages in this object
    };

    function findLanguageFromKey() {
        return findLanguageFromKeyFilter;

        function findLanguageFromKeyFilter(lang) {
            return languages[lang].name;
        }
    }

    function findLanguageRtlFromKey() {
        return findLanguageRtlFromKeyFilter;

        function findLanguageRtlFromKeyFilter(lang) {
            return languages[lang].rtl;
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .controller('JhiLanguageController', JhiLanguageController);

    JhiLanguageController.$inject = ['$translate', 'JhiLanguageService', 'tmhDynamicLocale'];

    function JhiLanguageController ($translate, JhiLanguageService, tmhDynamicLocale) {
        var vm = this;

        vm.changeLanguage = changeLanguage;
        vm.languages = null;

        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function changeLanguage (languageKey) {
            $translate.use(languageKey);
            tmhDynamicLocale.set(languageKey);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('sgnmrApp')

        /*
         Languages codes are ISO_639-1 codes, see http://en.wikipedia.org/wiki/List_of_ISO_639-1_codes
         They are written in English to avoid character encoding issues (not a perfect solution)
         */
        .constant('LANGUAGES', [
            'es',
            'en'
            // jhipster-needle-i18n-language-constant - JHipster will add/remove languages in this array
        ]
    );
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .directive('showValidation', showValidation);

    function showValidation () {
        var directive = {
            restrict: 'A',
            require: 'form',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, formCtrl) {
            element.find('.form-group').each(function() {
                var $formGroup = angular.element(this);
                var $inputs = $formGroup.find('input[ng-model],textarea[ng-model],select[ng-model]');

                if ($inputs.length > 0) {
                    $inputs.each(function() {
                        var $input = angular.element(this);
                        var inputName = $input.attr('name');
                        scope.$watch(function() {
                            return formCtrl[inputName].$invalid && formCtrl[inputName].$dirty;
                        }, function(isInvalid) {
                            $formGroup.toggleClass('has-error', isInvalid);
                        });
                    });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .constant('paginationConstants', {
            'itemsPerPage': 10
        });
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .directive('minbytes', minbytes);

    function minbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.minbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) >= attrs.minbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .directive('maxbytes', maxbytes);

    function maxbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.maxbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) <= attrs.maxbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }

})();

(function() {
    'use strict';

    var jhiAlertError = {
        template: '<div class="alerts" ng-cloak="" role="alert">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre>{{ alert.msg }}</pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertErrorController
    };

    angular
        .module('sgnmrApp')
        .component('jhiAlertError', jhiAlertError);

    jhiAlertErrorController.$inject = ['$scope', 'AlertService', '$rootScope', '$translate'];

    function jhiAlertErrorController ($scope, AlertService, $rootScope, $translate) {
        var vm = this;

        vm.alerts = [];

        function addErrorAlert (message, key, data) {
            key = key ? key : message;
            vm.alerts.push(
                AlertService.add(
                    {
                        type: 'danger',
                        msg: key,
                        params: data,
                        timeout: 5000,
                        toast: AlertService.isToast(),
                        scoped: true
                    },
                    vm.alerts
                )
            );
        }

        var cleanHttpErrorListener = $rootScope.$on('sgnmrApp.httpError', function (event, httpResponse) {
            var i;
            event.stopPropagation();
            switch (httpResponse.status) {
            // connection refused, server not reachable
            case 0:
                addErrorAlert('Server not reachable','error.server.not.reachable');
                break;

            case 400:
                var headers = Object.keys(httpResponse.headers()).filter(function (header) {
                    return header.indexOf('app-error', header.length - 'app-error'.length) !== -1 || header.indexOf('app-params', header.length - 'app-params'.length) !== -1;
                }).sort();
                var errorHeader = httpResponse.headers(headers[0]);
                var entityKey = httpResponse.headers(headers[1]);
                if (angular.isString(errorHeader)) {
                    var entityName = $translate.instant('global.menu.entities.' + entityKey);
                    addErrorAlert(errorHeader, errorHeader, {entityName: entityName});
                } else if (httpResponse.data && httpResponse.data.fieldErrors) {
                    for (i = 0; i < httpResponse.data.fieldErrors.length; i++) {
                        var fieldError = httpResponse.data.fieldErrors[i];
                        // convert 'something[14].other[4].id' to 'something[].other[].id' so translations can be written to it
                        var convertedField = fieldError.field.replace(/\[\d*\]/g, '[]');
                        var fieldName = $translate.instant('sgnmrApp.' + fieldError.objectName + '.' + convertedField);
                        addErrorAlert('Field ' + fieldName + ' cannot be empty', 'error.' + fieldError.message, {fieldName: fieldName});
                    }
                } else if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message, httpResponse.data.message, httpResponse.data);
                } else {
                    addErrorAlert(httpResponse.data);
                }
                break;

            case 404:
                addErrorAlert('Not found','error.url.not.found');
                break;

            default:
                if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message);
                } else {
                    addErrorAlert(angular.toJson(httpResponse));
                }
            }
        });

        $scope.$on('$destroy', function () {
            if(angular.isDefined(cleanHttpErrorListener) && cleanHttpErrorListener !== null){
                cleanHttpErrorListener();
                vm.alerts = [];
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .provider('AlertService', AlertService);

    function AlertService () {
        this.toast = false;
        /*jshint validthis: true */
        this.$get = getService;

        this.showAsToast = function(isToast) {
            this.toast = isToast;
        };

        getService.$inject = ['$timeout', '$sce', '$translate'];

        function getService ($timeout, $sce,$translate) {
            var toast = this.toast,
                alertId = 0, // unique id for each alert. Starts from 0.
                alerts = [],
                timeout = 5000; // default timeout

            return {
                factory: factory,
                isToast: isToast,
                add: addAlert,
                closeAlert: closeAlert,
                closeAlertByIndex: closeAlertByIndex,
                clear: clear,
                get: get,
                success: success,
                error: error,
                info: info,
                warning : warning
            };

            function isToast() {
                return toast;
            }

            function clear() {
                alerts = [];
            }

            function get() {
                return alerts;
            }

            function success(msg, params, position) {
                return this.add({
                    type: 'success',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function error(msg, params, position) {
                return this.add({
                    type: 'danger',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function warning(msg, params, position) {
                return this.add({
                    type: 'warning',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function info(msg, params, position) {
                return this.add({
                    type: 'info',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function factory(alertOptions) {
                var alert = {
                    type: alertOptions.type,
                    msg: $sce.trustAsHtml(alertOptions.msg),
                    id: alertOptions.alertId,
                    timeout: alertOptions.timeout,
                    toast: alertOptions.toast,
                    position: alertOptions.position ? alertOptions.position : 'top right',
                    scoped: alertOptions.scoped,
                    close: function (alerts) {
                        return closeAlert(this.id, alerts);
                    }
                };
                if(!alert.scoped) {
                    alerts.push(alert);
                }
                return alert;
            }

            function addAlert(alertOptions, extAlerts) {
                alertOptions.alertId = alertId++;
                alertOptions.msg = $translate.instant(alertOptions.msg, alertOptions.params);
                var that = this;
                var alert = this.factory(alertOptions);
                if (alertOptions.timeout && alertOptions.timeout > 0) {
                    $timeout(function () {
                        that.closeAlert(alertOptions.alertId, extAlerts);
                    }, alertOptions.timeout);
                }
                return alert;
            }

            function closeAlert(id, extAlerts) {
                var thisAlerts = extAlerts ? extAlerts : alerts;
                return closeAlertByIndex(thisAlerts.map(function(e) { return e.id; }).indexOf(id), thisAlerts);
            }

            function closeAlertByIndex(index, thisAlerts) {
                return thisAlerts.splice(index, 1);
            }
        }
    }
})();

(function() {
    'use strict';

    var jhiAlert = {
        template: '<div class="alerts" ng-cloak="" role="alert">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre ng-bind-html="alert.msg"></pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertController
    };

    angular
        .module('sgnmrApp')
        .component('jhiAlert', jhiAlert);

    jhiAlertController.$inject = ['$scope', 'AlertService'];

    function jhiAlertController($scope, AlertService) {
        var vm = this;

        vm.alerts = AlertService.get();
        $scope.$on('$destroy', function () {
            vm.alerts = [];
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .factory('notificationInterceptor', notificationInterceptor);

    notificationInterceptor.$inject = ['$q', 'AlertService'];

    function notificationInterceptor ($q, AlertService) {
        var service = {
            response: response
        };

        return service;

        function response (response) {
            var headers = Object.keys(response.headers()).filter(function (header) {
                return header.indexOf('app-alert', header.length - 'app-alert'.length) !== -1 || header.indexOf('app-params', header.length - 'app-params'.length) !== -1;
            }).sort();
            var alertKey = response.headers(headers[0]);
            if (angular.isString(alertKey)) {
                AlertService.success(alertKey, { param : response.headers(headers[1])});
            }
            return response;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .factory('errorHandlerInterceptor', errorHandlerInterceptor);

    errorHandlerInterceptor.$inject = ['$q', '$rootScope'];

    function errorHandlerInterceptor ($q, $rootScope) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError (response) {
            if (!(response.status === 401 && (response.data === '' || (response.data.path && response.data.path.indexOf('/api/account') === 0 )))) {
                $rootScope.$emit('sgnmrApp.httpError', response);
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .factory('authExpiredInterceptor', authExpiredInterceptor);

    authExpiredInterceptor.$inject = ['$rootScope', '$q', '$injector', '$localStorage', '$sessionStorage'];

    function authExpiredInterceptor($rootScope, $q, $injector, $localStorage, $sessionStorage) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError(response) {
            if (response.status === 401) {
                delete $localStorage.authenticationToken;
                delete $sessionStorage.authenticationToken;
                var Principal = $injector.get('Principal');
                if (Principal.isAuthenticated()) {
                    var Auth = $injector.get('Auth');
                    Auth.authorize(true);
                }
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .factory('authInterceptor', authInterceptor);

    authInterceptor.$inject = ['$rootScope', '$q', '$location', '$localStorage', '$sessionStorage'];

    function authInterceptor ($rootScope, $q, $location, $localStorage, $sessionStorage) {
        var service = {
            request: request
        };

        return service;

        function request (config) {
            /*jshint camelcase: false */
            config.headers = config.headers || {};
            var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;
            if (token) {
                config.headers.Authorization = 'Bearer ' + token;
            }
            return config;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .factory('translationHandler', translationHandler);

    translationHandler.$inject = ['$rootScope', '$window', '$state', '$translate'];

    function translationHandler($rootScope, $window, $state, $translate) {
        return {
            initialize: initialize,
            updateTitle: updateTitle
        };

        function initialize() {
            // if the current translation changes, update the window title
            var translateChangeSuccess = $rootScope.$on('$translateChangeSuccess', function() {
                updateTitle();
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(translateChangeSuccess) && translateChangeSuccess !== null){
                    translateChangeSuccess();
                }
            });
        }


        // update the window title using params in the following
        // precedence
        // 1. titleKey parameter
        // 2. $state.$current.data.pageTitle (current state page title)
        // 3. 'global.title'
        function updateTitle(titleKey) {
            if (!titleKey && $state.$current.data && $state.$current.data.pageTitle) {
                titleKey = $state.$current.data.pageTitle;
            }
            $translate(titleKey || 'global.title').then(function (title) {
                $window.document.title = title;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .factory('stateHandler', stateHandler);

    stateHandler.$inject = ['$rootScope', '$state', '$sessionStorage', '$translate', 'JhiLanguageService', 'translationHandler', '$window',
        'Auth', 'Principal', 'VERSION'];

    function stateHandler($rootScope, $state, $sessionStorage, $translate, JhiLanguageService, translationHandler, $window,
        Auth, Principal, VERSION) {
        return {
            initialize: initialize
        };

        function initialize() {
            $rootScope.VERSION = VERSION;

            var stateChangeStart = $rootScope.$on('$stateChangeStart', function (event, toState, toStateParams, fromState) {
                $rootScope.toState = toState;
                $rootScope.toStateParams = toStateParams;
                $rootScope.fromState = fromState;
                $rootScope.$pageFinishedLoading = false;

                // Redirect to a state with an external URL (http://stackoverflow.com/a/30221248/1098564)
                if (toState.external) {
                    event.preventDefault();
                    $window.open(toState.url, '_self');
                }

                if (Principal.isIdentityResolved()) {
                    Auth.authorize();
                }

                // Update the language
                JhiLanguageService.getCurrent().then(function (language) {
                    $translate.use(language);
                });
            });

            var stateChangeSuccess = $rootScope.$on('$stateChangeSuccess',  function(event, toState, toParams, fromState, fromParams) {
                var titleKey = 'global.title' ;
                $rootScope.$pageFinishedLoading = true;
                
                // Set the page title key to the one configured in state or use default one
                if (toState.data.pageTitle) {
                    titleKey = toState.data.pageTitle;
                }
                translationHandler.updateTitle(titleKey);
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(stateChangeStart) && stateChangeStart !== null){
                    stateChangeStart();
                }
                if(angular.isDefined(stateChangeSuccess) && stateChangeSuccess !== null){
                    stateChangeSuccess();
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .config(paginationConfig);

    paginationConfig.$inject = ['uibPaginationConfig', 'paginationConstants'];

    function paginationConfig(uibPaginationConfig, paginationConstants) {
        uibPaginationConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPaginationConfig.maxSize = 5;
        uibPaginationConfig.boundaryLinks = true;
        uibPaginationConfig.firstText = '«';
        uibPaginationConfig.previousText = '‹';
        uibPaginationConfig.nextText = '›';
        uibPaginationConfig.lastText = '»';
    }
})();

(function () {
    'use strict';

    angular
        .module('sgnmrApp')
        .config(pagerConfig);

    pagerConfig.$inject = ['uibPagerConfig', 'paginationConstants'];

    function pagerConfig(uibPagerConfig, paginationConstants) {
        uibPagerConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPagerConfig.previousText = '«';
        uibPagerConfig.nextText = '»';
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .factory('translationStorageProvider', translationStorageProvider);

    translationStorageProvider.$inject = ['$cookies', '$log', 'LANGUAGES'];

    function translationStorageProvider($cookies, $log, LANGUAGES) {
        return {
            get: get,
            put: put
        };

        function get(name) {
            if (LANGUAGES.indexOf($cookies.getObject(name)) === -1) {
                $log.info('Resetting invalid cookie language "' + $cookies.getObject(name) + '" to preferred language "es"');
                $cookies.putObject(name, 'es');
            }
            return $cookies.getObject(name);
        }

        function put(name, value) {
            $cookies.putObject(name, value);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .config(translationConfig);

    translationConfig.$inject = ['$translateProvider', 'tmhDynamicLocaleProvider', 'BUILD_TIMESTAMP'];

    function translationConfig($translateProvider, tmhDynamicLocaleProvider, BUILD_TIMESTAMP) {
        // Initialize angular-translate
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: 'i18n/{lang}/{part}.json' + (BUILD_TIMESTAMP ? '?build=' + BUILD_TIMESTAMP : '')
        });

        $translateProvider.preferredLanguage('es');
        $translateProvider.useStorage('translationStorageProvider');
        $translateProvider.useSanitizeValueStrategy('escaped');
        $translateProvider.addInterpolation('$translateMessageFormatInterpolation');

        tmhDynamicLocaleProvider.localeLocationPattern('i18n/angular-locale_{{locale}}.js');
        tmhDynamicLocaleProvider.useCookieStorage();
        tmhDynamicLocaleProvider.storageKey('NG_TRANSLATE_LANG_KEY');
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .config(localStorageConfig);

    localStorageConfig.$inject = ['$localStorageProvider', '$sessionStorageProvider'];

    function localStorageConfig($localStorageProvider, $sessionStorageProvider) {
        $localStorageProvider.setKeyPrefix('jhi-');
        $sessionStorageProvider.setKeyPrefix('jhi-');
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .config(httpConfig);

    httpConfig.$inject = ['$urlRouterProvider', '$httpProvider', 'httpRequestInterceptorCacheBusterProvider', '$urlMatcherFactoryProvider'];

    function httpConfig($urlRouterProvider, $httpProvider, httpRequestInterceptorCacheBusterProvider, $urlMatcherFactoryProvider) {
        //Cache everything except rest api requests
        httpRequestInterceptorCacheBusterProvider.setMatchlist([/.*api.*/, /.*protected.*/], true);

        $urlRouterProvider.otherwise('/');

        $httpProvider.interceptors.push('errorHandlerInterceptor');
        $httpProvider.interceptors.push('authExpiredInterceptor');
        $httpProvider.interceptors.push('authInterceptor');
        $httpProvider.interceptors.push('notificationInterceptor');
        // jhipster-needle-angularjs-add-interceptor JHipster will add new application http interceptor here

        $urlMatcherFactoryProvider.type('boolean', {
            name : 'boolean',
            decode: function(val) { return val === true || val === 'true'; },
            encode: function(val) { return val ? 1 : 0; },
            equals: function(a, b) { return this.is(a) && a === b; },
            is: function(val) { return [true,false,0,1].indexOf(val) >= 0; },
            pattern: /bool|true|0|1/
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .config(compileServiceConfig);

    compileServiceConfig.$inject = ['$compileProvider','DEBUG_INFO_ENABLED'];

    function compileServiceConfig($compileProvider,DEBUG_INFO_ENABLED) {
        // disable debug data on prod profile to improve performance
        $compileProvider.debugInfoEnabled(DEBUG_INFO_ENABLED);

        /*
        If you wish to debug an application with this information
        then you should open up a debug console in the browser
        then call this method directly in this console:

		angular.reloadWithDebugInfo();
		*/
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .config(alertServiceConfig);

    alertServiceConfig.$inject = ['AlertServiceProvider'];

    function alertServiceConfig(AlertServiceProvider) {
        // set below to true to make alerts look like toast
        AlertServiceProvider.showAsToast(false);
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider','flowFactoryProvider'];

    function stateConfig($stateProvider, flowFactoryProvider) {
        flowFactoryProvider.defaults = {
            target : 'upload',
            permanentErrors : [ 500, 501 ],
            maxChunkRetries : 3,
            chunkRetryInterval : 5000,
            forceChunkSize : true,
            simultaneousUploads : 4,
            progressCallbacksInterval : 1,
            withCredentials : true,
            method : "octet"
        };

        flowFactoryProvider.on('catchAll', function(event) {
            console.log('catchAll', arguments);
        });
        $stateProvider.state('app', {
            abstract: true,
            views: {
                'navbar@public': {
                    templateUrl: 'app/layouts/navbar/navbar.html',
                    controller: 'NavbarController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                authorize: ['Auth',
                    function (Auth) {
                        return Auth.authorize();
                    }
                ],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                }]
            }
        });
    }
})();

(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('sgnmrApp')
        .constant('VERSION', "4.9.0v1.0")
        .constant('DEBUG_INFO_ENABLED', false)
        .constant('BUILD_TIMESTAMP', 1713986537922)
;
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .controller('UserManagementDialogController',UserManagementDialogController);

    UserManagementDialogController.$inject = ['$stateParams', '$uibModalInstance', 'entity', 'User', 'JhiLanguageService'];

    function UserManagementDialogController ($stateParams, $uibModalInstance, entity, User, JhiLanguageService) {
        var vm = this;

        vm.authorities = ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_PUBLISHER', 'ROLE_SGA', 'ROLE_SJP'];
        vm.clear = clear;
        vm.languages = null;
        vm.save = save;
        vm.user = entity;

        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function onSaveSuccess (result) {
            vm.isSaving = false;
            $uibModalInstance.close(result);
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function save () {
            vm.isSaving = true;
            if (vm.user.id !== null) {
                User.update(vm.user, onSaveSuccess, onSaveError);
            } else {
                User.save(vm.user, onSaveSuccess, onSaveError);
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .controller('UserManagementDetailController', UserManagementDetailController);

    UserManagementDetailController.$inject = ['$stateParams', 'User'];

    function UserManagementDetailController($stateParams, User) {
        var vm = this;

        vm.load = load;
        vm.user = {};

        vm.load($stateParams.login);

        function load(login) {
            User.get({login: login}, function(result) {
                vm.user = result;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .controller('UserManagementDeleteController', UserManagementDeleteController);

    UserManagementDeleteController.$inject = ['$uibModalInstance', 'entity', 'User'];

    function UserManagementDeleteController ($uibModalInstance, entity, User) {
        var vm = this;

        vm.user = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (login) {
            User.delete({login: login},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('user-management', {
            parent: 'admin',
            url: '/user-management?page&sort',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'userManagement.home.title'
            },
            views: {
                'content@private': {
                    templateUrl: 'app/admin/user-management/user-management.html',
                    controller: 'UserManagementController',
                    controllerAs: 'vm'
                }
            },            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort)
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('user-management');
                    return $translate.refresh();
                }]

            }        })
        .state('user-management.new', {
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null, login: null, firstName: null, lastName: null, email: null,
                                activated: true, langKey: null, createdBy: null, createdDate: null,
                                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                                resetKey: null, authorities: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('user-management');
                });
            }]
        })
        .state('user-management.edit', {
            url: '/{login}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('user-management-detail', {
            parent: 'user-management',
            url: '/{login}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'user-management.detail.title'
            },
            views: {
                'content@private': {
                    templateUrl: 'app/admin/user-management/user-management-detail.html',
                    controller: 'UserManagementDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('user-management');
                    return $translate.refresh();
                }]
            }
        })
        .state('user-management.delete', {
            url: '/{login}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-delete-dialog.html',
                    controller: 'UserManagementDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .controller('UserManagementController', UserManagementController);

    UserManagementController.$inject = ['Principal', 'User', 'ParseLinks', 'AlertService', '$state', 'pagingParams', 'paginationConstants', 'JhiLanguageService'];

    function UserManagementController(Principal, User, ParseLinks, AlertService, $state, pagingParams, paginationConstants, JhiLanguageService) {
        var vm = this;

        vm.authorities = ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_PUBLISHER'];
        vm.currentAccount = null;
        vm.languages = null;
        vm.loadAll = loadAll;
        vm.setActive = setActive;
        vm.users = [];
        vm.page = 1;
        vm.totalItems = null;
        vm.clear = clear;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.transition = transition;

        vm.loadAll();
        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });
        Principal.identity().then(function(account) {
            vm.currentAccount = account;
        });

        function setActive (user, isActivated) {
            user.activated = isActivated;
            User.update(user, function () {
                vm.loadAll();
                vm.clear();
            });
        }

        function loadAll () {
            User.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
        }

        function onSuccess(data, headers) {
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;
            vm.page = pagingParams.page;
            vm.users = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function clear () {
            vm.user = {
                id: null, login: null, firstName: null, lastName: null, email: null,
                activated: null, langKey: null, createdBy: null, createdDate: null,
                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                resetKey: null, authorities: null
            };
        }

        function sort () {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-metrics', {
            parent: 'admin',
            url: '/metrics',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'metrics.title'
            },
            views: {
                'content@private': {
                    templateUrl: 'app/admin/metrics/metrics.html',
                    controller: 'JhiMetricsMonitoringController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('metrics');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .factory('JhiMetricsService', JhiMetricsService);

    JhiMetricsService.$inject = ['$rootScope', '$http'];

    function JhiMetricsService ($rootScope, $http) {
        var service = {
            getMetrics: getMetrics,
            threadDump: threadDump
        };

        return service;

        function getMetrics () {
            return $http.get('management/metrics').then(function (response) {
                return response.data;
            });
        }

        function threadDump () {
            return $http.get('management/dump').then(function (response) {
                return response.data;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .controller('JhiMetricsMonitoringModalController', JhiMetricsMonitoringModalController);

    JhiMetricsMonitoringModalController.$inject = ['$uibModalInstance', 'threadDump'];

    function JhiMetricsMonitoringModalController ($uibModalInstance, threadDump) {
        var vm = this;

        vm.cancel = cancel;
        vm.getLabelClass = getLabelClass;
        vm.threadDump = threadDump;
        vm.threadDumpAll = 0;
        vm.threadDumpBlocked = 0;
        vm.threadDumpRunnable = 0;
        vm.threadDumpTimedWaiting = 0;
        vm.threadDumpWaiting = 0;

        angular.forEach(threadDump, function(value) {
            if (value.threadState === 'RUNNABLE') {
                vm.threadDumpRunnable += 1;
            } else if (value.threadState === 'WAITING') {
                vm.threadDumpWaiting += 1;
            } else if (value.threadState === 'TIMED_WAITING') {
                vm.threadDumpTimedWaiting += 1;
            } else if (value.threadState === 'BLOCKED') {
                vm.threadDumpBlocked += 1;
            }
        });

        vm.threadDumpAll = vm.threadDumpRunnable + vm.threadDumpWaiting +
            vm.threadDumpTimedWaiting + vm.threadDumpBlocked;

        function cancel () {
            $uibModalInstance.dismiss('cancel');
        }

        function getLabelClass (threadState) {
            if (threadState === 'RUNNABLE') {
                return 'label-success';
            } else if (threadState === 'WAITING') {
                return 'label-info';
            } else if (threadState === 'TIMED_WAITING') {
                return 'label-warning';
            } else if (threadState === 'BLOCKED') {
                return 'label-danger';
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .controller('JhiMetricsMonitoringController', JhiMetricsMonitoringController);

    JhiMetricsMonitoringController.$inject = ['$scope','JhiMetricsService', '$uibModal'];

    function JhiMetricsMonitoringController ($scope, JhiMetricsService, $uibModal) {
        var vm = this;

        vm.cachesStats = {};
        vm.metrics = {};
        vm.refresh = refresh;
        vm.refreshThreadDumpData = refreshThreadDumpData;
        vm.servicesStats = {};
        vm.updatingMetrics = true;

        vm.refresh();

        $scope.$watch('vm.metrics', function (newValue) {
            vm.servicesStats = {};
            angular.forEach(newValue.timers, function (value, key) {
                if (key.indexOf('web.rest') !== -1 || key.indexOf('service') !== -1) {
                    vm.servicesStats[key] = value;
                }
            });

            vm.cachesStats = {};
            angular.forEach(newValue.gauges, function (value, key) {
                if (key.indexOf('jcache.statistics') !== -1) {
                    // remove gets or puts
                    var index = key.lastIndexOf('.');
                    var newKey = key.substr(0, index);

                    // Keep the name of the domain
                    vm.cachesStats[newKey] = {
                        'name': newKey.substr(18),
                        'value': value
                    };
                }
            });
        });

        function refresh () {
            vm.updatingMetrics = true;
            JhiMetricsService.getMetrics().then(function (promise) {
                vm.metrics = promise;
                vm.updatingMetrics = false;
            }, function (promise) {
                vm.metrics = promise.data;
                vm.updatingMetrics = false;
            });
        }

        function refreshThreadDumpData () {
            JhiMetricsService.threadDump().then(function(data) {
                $uibModal.open({
                    templateUrl: 'app/admin/metrics/metrics.modal.html',
                    controller: 'JhiMetricsMonitoringModalController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        threadDump: function() {
                            return data;
                        }

                    }
                });
            });
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('logs', {
            parent: 'admin',
            url: '/logs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'logs.title'
            },
            views: {
                'content@private': {
                    templateUrl: 'app/admin/logs/logs.html',
                    controller: 'LogsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('logs');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .factory('LogsService', LogsService);

    LogsService.$inject = ['$resource'];

    function LogsService ($resource) {
        var service = $resource('management/logs', {}, {
            'findAll': { method: 'GET', isArray: true},
            'changeLevel': { method: 'PUT'}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .controller('LogsController', LogsController);

    LogsController.$inject = ['LogsService'];

    function LogsController (LogsService) {
        var vm = this;

        vm.changeLevel = changeLevel;
        vm.loggers = LogsService.findAll();

        function changeLevel (name, level) {
            LogsService.changeLevel({name: name, level: level}, function () {
                vm.loggers = LogsService.findAll();
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-health', {
            parent: 'admin',
            url: '/health',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'health.title'
            },
            views: {
                'content@private': {
                    templateUrl: 'app/admin/health/health.html',
                    controller: 'JhiHealthCheckController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('health');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .factory('JhiHealthService', JhiHealthService);

    JhiHealthService.$inject = ['$rootScope', '$http'];

    function JhiHealthService ($rootScope, $http) {
        var separator = '.';
        var service = {
            checkHealth: checkHealth,
            transformHealthData: transformHealthData,
            getBaseName: getBaseName,
            getSubSystemName: getSubSystemName
        };

        return service;

        function checkHealth () {
            return $http.get('management/health').then(function (response) {
                return response.data;
            });
        }

        function transformHealthData (data) {
            var response = [];
            flattenHealthData(response, null, data);
            return response;
        }

        function getBaseName (name) {
            if (name) {
                var split = name.split('.');
                return split[0];
            }
        }

        function getSubSystemName (name) {
            if (name) {
                var split = name.split('.');
                split.splice(0, 1);
                var remainder = split.join('.');
                return remainder ? ' - ' + remainder : '';
            }
        }

        /* private methods */
        function flattenHealthData (result, path, data) {
            angular.forEach(data, function (value, key) {
                if (isHealthObject(value)) {
                    if (hasSubSystem(value)) {
                        addHealthObject(result, false, value, getModuleName(path, key));
                        flattenHealthData(result, getModuleName(path, key), value);
                    } else {
                        addHealthObject(result, true, value, getModuleName(path, key));
                    }
                }
            });
            return result;
        }

        function addHealthObject (result, isLeaf, healthObject, name) {

            var healthData = {
                'name': name
            };
            var details = {};
            var hasDetails = false;

            angular.forEach(healthObject, function (value, key) {
                if (key === 'status' || key === 'error') {
                    healthData[key] = value;
                } else {
                    if (!isHealthObject(value)) {
                        details[key] = value;
                        hasDetails = true;
                    }
                }
            });

            // Add the of the details
            if (hasDetails) {
                angular.extend(healthData, { 'details': details});
            }

            // Only add nodes if they provide additional information
            if (isLeaf || hasDetails || healthData.error) {
                result.push(healthData);
            }
            return healthData;
        }

        function getModuleName (path, name) {
            var result;
            if (path && name) {
                result = path + separator + name;
            }  else if (path) {
                result = path;
            } else if (name) {
                result = name;
            } else {
                result = '';
            }
            return result;
        }

        function hasSubSystem (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value) {
                if (value && value.status) {
                    result = true;
                }
            });
            return result;
        }

        function isHealthObject (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value, key) {
                if (key === 'status') {
                    result = true;
                }
            });
            return result;
        }

    }
})();

(function() {
    'use strict';

    angular.module('sgnmrApp')
        .controller('HealthModalController', HealthModalController);

    HealthModalController.$inject = ['$uibModalInstance', 'currentHealth', 'baseName', 'subSystemName'];

    function HealthModalController ($uibModalInstance, currentHealth, baseName, subSystemName) {
        var vm = this;

        vm.cancel = cancel;
        vm.currentHealth = currentHealth;
        vm.baseName = baseName;
        vm.subSystemName = subSystemName;

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .controller('JhiHealthCheckController', JhiHealthCheckController);

    JhiHealthCheckController.$inject = ['JhiHealthService', '$uibModal'];

    function JhiHealthCheckController (JhiHealthService, $uibModal) {
        var vm = this;

        vm.updatingHealth = true;
        vm.getLabelClass = getLabelClass;
        vm.refresh = refresh;
        vm.showHealth = showHealth;
        vm.baseName = JhiHealthService.getBaseName;
        vm.subSystemName = JhiHealthService.getSubSystemName;

        vm.refresh();

        function getLabelClass (statusState) {
            if (statusState === 'UP') {
                return 'label-success';
            } else {
                return 'label-danger';
            }
        }

        function refresh () {
            vm.updatingHealth = true;
            JhiHealthService.checkHealth().then(function (response) {
                vm.healthData = JhiHealthService.transformHealthData(response);
                vm.updatingHealth = false;
            }, function (response) {
                vm.healthData =  JhiHealthService.transformHealthData(response.data);
                vm.updatingHealth = false;
            });
        }

        function showHealth (health) {
            $uibModal.open({
                templateUrl: 'app/admin/health/health.modal.html',
                controller: 'HealthModalController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    currentHealth: function() {
                        return health;
                    },
                    baseName: function() {
                        return vm.baseName;
                    },
                    subSystemName: function() {
                        return vm.subSystemName;
                    }

                }
            });
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('entity-audit', {
            parent: 'admin',
            url: '/entity-audits',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Audits'
            },
            views: {
                'content@private': {
                    templateUrl: 'app/admin/entity-audit/entity-audits.html',
                    controller: 'EntityAuditController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('entity-audit');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .factory('EntityAuditService', EntityAuditService);

    EntityAuditService.$inject = ['$http'];

    function EntityAuditService ($http) {

        var service = {
            findAllAudited: findAllAudited,
            findByEntity: findByEntity,
            getPrevVersion: getPrevVersion
        };

        return service;

        function findAllAudited() {
            return $http.get('api/audits/entity/all').then(function (response) {
                return response.data;
            });
        }

        function findByEntity(entityType, limit) {
            return $http.get('api/audits/entity/changes', {
                params: {
                    entityType: entityType,
                    limit: limit
                }
            }).then(function (response) {
                return response.data;
            });
        }

        function getPrevVersion(qualifiedName, entityId, commitVersion) {
            return $http.get('api/audits/entity/changes/version/previous', {
                params: {
                    qualifiedName: qualifiedName,
                    entityId: entityId,
                    commitVersion: commitVersion
                }
            }).then(function (response) {
                return response.data;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .controller('AuditDetailModalCtrl', AuditDetailModalCtrl);

    AuditDetailModalCtrl.$inject = ['$scope', '$uibModalInstance', 'ObjectDiff', 'diff', 'audit'];

    function AuditDetailModalCtrl($scope, $uibModalInstance, ObjectDiff, diff, audit) {
        var vm = this;
        
        vm.diffValue = ObjectDiff.toJsonView(diff);
        vm.diffValueChanges = ObjectDiff.toJsonDiffView(diff);
        vm.audit = audit;
        vm.cancel = cancel;

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        };
    };
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .controller('EntityAuditController', EntityAuditController);

    EntityAuditController.$inject = ['$scope', '$filter', '$uibModal', 'EntityAuditService', 'AlertService', 'ObjectDiff'];

    function EntityAuditController ($scope, $filter, $uibModal, EntityAuditService, AlertService, ObjectDiff) {
        var vm = this;

        vm.entities = [];
        vm.audits = [];
        vm.limits = [25, 50, 100, 200];
        vm.limit = 25;
        vm.loading = false;
        vm.loadChanges = loadChanges;
        vm.findAllAudited = findAllAudited;
        vm.getEntityName = getEntityName;
        vm.format = format;
        vm.isObject = isObject;
        vm.isDate = isDate;
        vm.openChange = openChange;

        vm.findAllAudited();

        function findAllAudited() {
            EntityAuditService.findAllAudited().then(function (data) {
                vm.entities = data;
            });
        }

        function loadChanges() {
            vm.loading = true;
            var entityType = vm.qualifiedName;
            EntityAuditService.findByEntity(entityType, vm.limit).then(function (data) {
                vm.audits = data.map(function(it){
                    return it;
                });
                vm.loading = false;
            }, function(){
                vm.loading = false;
            });
        };

        function getEntityName(qualifiedName) {
            if (qualifiedName) {
                var splits = qualifiedName.split(".");
                return splits[splits.length - 1];
            }
            else return null;
        };

        function format(val){
            if(val)
                return ObjectDiff.objToJsonView(val);
            else return '';
        };

        function isObject(val){
            return (val && (typeof val) == 'object');
        };

        function isDate(key){
            return (key && key.indexOf("Date") != -1);
        };

        function openChange(audit){

            if(audit.commitVersion < 2){
                AlertService.warning("entityAudit.result.firstAuditEntry");

            } else {
                EntityAuditService.getPrevVersion(audit.entityType, audit.entityId, audit.commitVersion).then(function (data) {
                    var previousVersion = JSON.stringify(data.entityValue),
                        currentVersion = audit.entityValue;
                    // enable below to have the dates formatted
                    //previousVersion = convertDates(previousVersion);
                    //currentVersion = convertDates(currentVersion);
                    var diff = ObjectDiff.diffOwnProperties(previousVersion, currentVersion);

                    $uibModal.open({
                        templateUrl: 'app/admin/entity-audit/entity-audit.detail.html',
                        controller: 'AuditDetailModalCtrl',
                        controllerAs: 'vm',
                        size: 'lg',
                        resolve: {
                            diff: function () {
                                return diff;
                            },
                            audit: function () {
                                return audit;
                            }
                        }
                    });
                });
            }
        };

        function convertDates(obj) {
            for(var key in obj) {
                if (obj.hasOwnProperty(key) && obj[key]) {
                    if (key.indexOf("Date") != -1 && (obj[key] instanceof Date || Object.prototype.toString.call(obj[key]) === '[object Date]' || (new Date(obj[key]) !== "Invalid Date" && !isNaN(new Date(obj[key]))))) {
                        obj[key] = $filter('date')(obj[key]);
                    }
                }
            }
            return obj;
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('sgnmrApp')
        .controller('ElasticsearchReindexDialogController', ElasticsearchReindexDialogController);

    ElasticsearchReindexDialogController.$inject = ['$uibModalInstance', 'ElasticsearchReindex'];

    function ElasticsearchReindexDialogController($uibModalInstance, ElasticsearchReindex) {
        var vm = this;

        vm.clear = clear;
        vm.confirmReindex = confirmReindex;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmReindex() {
            ElasticsearchReindex.reindex(function () {
                $uibModalInstance.close(true);
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('sgnmrApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('elasticsearch-reindex', {
            parent: 'admin',
            url: '/elasticsearch-reindex',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'elasticsearch.reindex.title'
            },
            views: {
                'content@private': {
                    templateUrl: 'app/admin/elasticsearch-reindex/elasticsearch-reindex.html',
                    controller: 'ElasticsearchReindexController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('elasticsearch-reindex');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        }).state('elasticsearch-reindex.dialog', {
            parent: 'elasticsearch-reindex',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/elasticsearch-reindex/elasticsearch-reindex-dialog.html',
                    controller: 'ElasticsearchReindexDialogController',
                    controllerAs: 'vm',
                    size: 'sm'
                }).result.finally(function () {
                    $state.go('^');
                });
            }]
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('sgnmrApp')
        .factory('ElasticsearchReindex', ElasticsearchReindex);

    ElasticsearchReindex.$inject = ['$resource'];

    function ElasticsearchReindex($resource) {
        var service = $resource('api/elasticsearch/index', {}, {
            'reindex': {method: 'POST'}
        });

        return service;
    }
})();

(function () {
    'use strict';

    angular
        .module('sgnmrApp')
        .controller('ElasticsearchReindexController', ElasticsearchReindexController);

    ElasticsearchReindexController.$inject = [];

    function ElasticsearchReindexController() {
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('docs', {
            parent: 'admin',
            url: '/docs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'global.menu.admin.apidocs'
            },
            views: {
                'content@private': {
                    templateUrl: 'app/admin/docs/docs.html'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', function ($translate) {
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-configuration', {
            parent: 'admin',
            url: '/configuration',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'configuration.title'
            },
            views: {
                'content@private': {
                    templateUrl: 'app/admin/configuration/configuration.html',
                    controller: 'JhiConfigurationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('configuration');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .factory('JhiConfigurationService', JhiConfigurationService);

    JhiConfigurationService.$inject = ['$filter', '$http'];

    function JhiConfigurationService ($filter, $http) {
        var service = {
            get: get,
            getEnv: getEnv
        };

        return service;

        function get () {
            return $http.get('management/configprops').then(getConfigPropsComplete);

            function getConfigPropsComplete (response) {
                var properties = [];
                angular.forEach(response.data, function (data) {
                    properties.push(data);
                });
                var orderBy = $filter('orderBy');
                return orderBy(properties, 'prefix');
            }
        }

        function getEnv () {
            return $http.get('management/env').then(getEnvComplete);

            function getEnvComplete (response) {
                var properties = {};
                angular.forEach(response.data, function (val,key) {
                    var vals = [];
                    angular.forEach(val, function (v,k) {
                        vals.push({ key:k, val:v });
                    });
                    properties[key] = vals;
                });
                return properties;
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .controller('JhiConfigurationController', JhiConfigurationController);

    JhiConfigurationController.$inject = ['$filter','JhiConfigurationService'];

    function JhiConfigurationController (filter,JhiConfigurationService) {
        var vm = this;

        vm.allConfiguration = null;
        vm.configuration = null;

        JhiConfigurationService.get().then(function(configuration) {
            vm.configuration = configuration;
        });
        JhiConfigurationService.getEnv().then(function (configuration) {
            vm.allConfiguration = configuration;
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('audits', {
            parent: 'admin',
            url: '/audits',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'audits.title'
            },
            views: {
                'content@private': {
                    templateUrl: 'app/admin/audits/audits.html',
                    controller: 'AuditsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('audits');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .factory('AuditsService', AuditsService);

    AuditsService.$inject = ['$resource'];

    function AuditsService ($resource) {
        var service = $resource('management/audits/:id', {}, {
            'get': {
                method: 'GET',
                isArray: true
            },
            'query': {
                method: 'GET',
                isArray: true,
                params: {fromDate: null, toDate: null}
            }
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .controller('AuditsController', AuditsController);

    AuditsController.$inject = ['$filter', 'AuditsService', 'ParseLinks'];

    function AuditsController ($filter, AuditsService, ParseLinks) {
        var vm = this;

        vm.audits = null;
        vm.fromDate = null;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.onChangeDate = onChangeDate;
        vm.page = 1;
        vm.previousMonth = previousMonth;
        vm.toDate = null;
        vm.today = today;
        vm.totalItems = null;

        vm.today();
        vm.previousMonth();
        vm.onChangeDate();

        function onChangeDate () {
            var dateFormat = 'yyyy-MM-dd';
            var fromDate = $filter('date')(vm.fromDate, dateFormat);
            var toDate = $filter('date')(vm.toDate, dateFormat);

            AuditsService.query({page: vm.page -1, size: 20, fromDate: fromDate, toDate: toDate}, function(result, headers){
                vm.audits = result;
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
            });
        }

        // Date picker configuration
        function today () {
            // Today + 1 day - needed if the current day must be included
            var today = new Date();
            vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
        }

        function previousMonth () {
            var fromDate = new Date();
            if (fromDate.getMonth() === 0) {
                fromDate = new Date(fromDate.getFullYear() - 1, 11, fromDate.getDate());
            } else {
                fromDate = new Date(fromDate.getFullYear(), fromDate.getMonth() - 1, fromDate.getDate());
            }

            vm.fromDate = fromDate;
        }

        function loadPage (page) {
            vm.page = page;
            vm.onChangeDate();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('sgnmrApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('admin', {
            abstract: true,
            parent: 'private'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('settings', {
            parent: 'account',
            url: '/settings',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.menu.account.settings'
            },
            views: {
                'content@private': {
                    templateUrl: 'app/account/settings/settings.html',
                    controller: 'SettingsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('settings');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .controller('SettingsController', SettingsController);

    SettingsController.$inject = ['Principal', 'Auth', 'JhiLanguageService', '$translate'];

    function SettingsController (Principal, Auth, JhiLanguageService, $translate) {
        var vm = this;

        vm.error = null;
        vm.save = save;
        vm.settingsAccount = null;
        vm.success = null;

        /**
         * Store the "settings account" in a separate variable, and not in the shared "account" variable.
         */
        var copyAccount = function (account) {
            return {
                activated: account.activated,
                email: account.email,
                firstName: account.firstName,
                langKey: account.langKey,
                lastName: account.lastName,
                login: account.login
            };
        };

        Principal.identity().then(function(account) {
            vm.settingsAccount = copyAccount(account);
        });

        function save () {
            Auth.updateAccount(vm.settingsAccount).then(function() {
                vm.error = null;
                vm.success = 'OK';
                Principal.identity(true).then(function(account) {
                    vm.settingsAccount = copyAccount(account);
                });
                JhiLanguageService.getCurrent().then(function(current) {
                    if (vm.settingsAccount.langKey !== current) {
                        $translate.use(vm.settingsAccount.langKey);
                    }
                });
            }).catch(function() {
                vm.success = null;
                vm.error = 'ERROR';
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('requestReset', {
            parent: 'account',
            url: '/reset/request',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/request/reset.request.html',
                    controller: 'RequestResetController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .controller('RequestResetController', RequestResetController);

    RequestResetController.$inject = ['$timeout', 'Auth'];

    function RequestResetController ($timeout, Auth) {
        var vm = this;

        vm.error = null;
        vm.errorEmailNotExists = null;
        vm.requestReset = requestReset;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#email').focus();});

        function requestReset () {

            vm.error = null;
            vm.errorEmailNotExists = null;

            Auth.resetPasswordInit(vm.resetAccount.email).then(function () {
                vm.success = 'OK';
            }).catch(function (response) {
                vm.success = null;
                if (response.status === 400 && response.data === 'email address not registered') {
                    vm.errorEmailNotExists = 'ERROR';
                } else {
                    vm.error = 'ERROR';
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('finishReset', {
            parent: 'account',
            url: '/reset/finish?key',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/finish/reset.finish.html',
                    controller: 'ResetFinishController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .controller('ResetFinishController', ResetFinishController);

    ResetFinishController.$inject = ['$stateParams', '$timeout', 'Auth', 'LoginService'];

    function ResetFinishController ($stateParams, $timeout, Auth, LoginService) {
        var vm = this;

        vm.keyMissing = angular.isUndefined($stateParams.key);
        vm.confirmPassword = null;
        vm.doNotMatch = null;
        vm.error = null;
        vm.finishReset = finishReset;
        vm.login = LoginService.open;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#password').focus();});

        function finishReset() {
            vm.doNotMatch = null;
            vm.error = null;
            if (vm.resetAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                Auth.resetPasswordFinish({key: $stateParams.key, newPassword: vm.resetAccount.password}).then(function () {
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('register', {
            parent: 'account',
            url: '/register',
            data: {
                authorities: [],
                pageTitle: 'register.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/register/register.html',
                    controller: 'RegisterController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('register');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .controller('RegisterController', RegisterController);


    RegisterController.$inject = ['$translate', '$timeout', 'Auth', 'LoginService'];

    function RegisterController ($translate, $timeout, Auth, LoginService) {
        var vm = this;

        vm.doNotMatch = null;
        vm.error = null;
        vm.errorUserExists = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.registerAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#login').focus();});

        function register () {
            if (vm.registerAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                vm.registerAccount.langKey = $translate.use();
                vm.doNotMatch = null;
                vm.error = null;
                vm.errorUserExists = null;
                vm.errorEmailExists = null;

                Auth.createAccount(vm.registerAccount).then(function () {
                    vm.success = 'OK';
                }).catch(function (response) {
                    vm.success = null;
                    if (response.status === 400 && response.data === 'login already in use') {
                        vm.errorUserExists = 'ERROR';
                    } else if (response.status === 400 && response.data === 'email address already in use') {
                        vm.errorEmailExists = 'ERROR';
                    } else {
                        vm.error = 'ERROR';
                    }
                });
            }
        }
    }
})();

/* globals $ */
(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .directive('passwordStrengthBar', passwordStrengthBar);

    function passwordStrengthBar () {
        var directive = {
            replace: true,
            restrict: 'E',
            template: '<div id="strength">' +
                '<small data-translate="global.messages.validate.newpassword.strength">Password strength:</small>' +
                '<ul id="strengthBar">' +
                '<li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li>' +
                '</ul>' +
                '</div>',
            scope: {
                passwordToCheck: '='
            },
            link: linkFunc
        };

        return directive;

        /* private helper methods*/

        function linkFunc(scope, iElement) {
            var strength = {
                colors: ['#F00', '#F90', '#FF0', '#9F0', '#0F0'],
                mesureStrength: function (p) {

                    var _force = 0;
                    var _regex = /[$-/:-?{-~!"^_`\[\]]/g; // "

                    var _lowerLetters = /[a-z]+/.test(p);
                    var _upperLetters = /[A-Z]+/.test(p);
                    var _numbers = /[0-9]+/.test(p);
                    var _symbols = _regex.test(p);

                    var _flags = [_lowerLetters, _upperLetters, _numbers, _symbols];
                    var _passedMatches = $.grep(_flags, function (el) {
                        return el === true;
                    }).length;

                    _force += 2 * p.length + ((p.length >= 10) ? 1 : 0);
                    _force += _passedMatches * 10;

                    // penalty (short password)
                    _force = (p.length <= 6) ? Math.min(_force, 10) : _force;

                    // penalty (poor variety of characters)
                    _force = (_passedMatches === 1) ? Math.min(_force, 10) : _force;
                    _force = (_passedMatches === 2) ? Math.min(_force, 20) : _force;
                    _force = (_passedMatches === 3) ? Math.min(_force, 40) : _force;

                    return _force;

                },
                getColor: function (s) {

                    var idx;
                    if (s <= 10) {
                        idx = 0;
                    }
                    else if (s <= 20) {
                        idx = 1;
                    }
                    else if (s <= 30) {
                        idx = 2;
                    }
                    else if (s <= 40) {
                        idx = 3;
                    }
                    else {
                        idx = 4;
                    }

                    return { idx: idx + 1, col: this.colors[idx] };
                }
            };
            scope.$watch('passwordToCheck', function (password) {
                if (password) {
                    var c = strength.getColor(strength.mesureStrength(password));
                    iElement.removeClass('ng-hide');
                    iElement.find('ul').children('li')
                        .css({ 'background-color': '#DDD' })
                        .slice(0, c.idx)
                        .css({ 'background-color': c.col });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('password', {
            parent: 'account',
            url: '/password',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.menu.account.password'
            },
            views: {
                'content@private': {
                    templateUrl: 'app/account/password/password.html',
                    controller: 'PasswordController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('password');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .controller('PasswordController', PasswordController);

    PasswordController.$inject = ['Auth', 'Principal'];

    function PasswordController (Auth, Principal) {
        var vm = this;

        vm.changePassword = changePassword;
        vm.doNotMatch = null;
        vm.error = null;
        vm.success = null;

        Principal.identity().then(function(account) {
            vm.account = account;
        });

        function changePassword () {
            if (vm.password !== vm.confirmPassword) {
                vm.error = null;
                vm.success = null;
                vm.doNotMatch = 'ERROR';
            } else {
                vm.doNotMatch = null;
                Auth.changePassword(vm.password).then(function () {
                    vm.error = null;
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('activate', {
            parent: 'account',
            url: '/activate?key',
            data: {
                authorities: [],
                pageTitle: 'activate.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/activate/activate.html',
                    controller: 'ActivationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('activate');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .controller('ActivationController', ActivationController);

    ActivationController.$inject = ['$stateParams', 'Auth', 'LoginService'];

    function ActivationController ($stateParams, Auth, LoginService) {
        var vm = this;

        Auth.activateAccount({key: $stateParams.key}).then(function () {
            vm.error = null;
            vm.success = 'OK';
        }).catch(function () {
            vm.success = null;
            vm.error = 'ERROR';
        });

        vm.login = LoginService.open;
    }
})();

(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('account', {
            abstract: true,
            parent: 'private'
        });
    }
})();
(function(){angular.module('sgnmrApp').run(['$templateCache', function($templateCache) {$templateCache.put('app/home/home.html','<div class="col-xs-12"><div class="region region-content"><h1 class="title" ng-if="vm.state.name === \'home\'">Marco Normativo Vigente</h1><h1 class="title" ng-if="vm.state.name === \'home-materia\'">Marco Normativo Vigente en Materia <span class="text-capitalize">{{ vm.criteria.materia | lowercase }}</span></h1><h1 class="title" ng-if="vm.state.name === \'materia-abrogado\'">Marco Normativo Abrogado en Materia <span class="text-capitalize">{{ vm.criteria.materia | lowercase }}</span></h1></div></div><div class="col-xs-12"><div class="row"><div class="col-lg-3 col-md-4 col-xs-12 mb-5" ng-if="vm.state.name !== \'materia-abrogado\'"><div class="panel panel-default header-filter"><div class="panel-heading"><h2>Filtrar Resultados</h2></div></div><div class="row"><div class="col-xs-12 col-sm-6 col-md-12"><div class="row"><div class="col-xs-12"><div class="panel panel-default filter" ng-style="vm.theight"><div class="panel-heading"><h3 id="filtro-tipo" class="m-0" aria-label="Filtrar resultados por Tipo.">Tipo</h3></div><div class="panel-body"><div role="group" ng-repeat="(key, count) in vm.aggs.tiposOrdenamientos" ng-click="vm.runSearch()" aria-labelledby="filtro-tipo"><div class="checkbox row"><div class="col-xs-2"><input type="checkbox" ng-model="vm.tipos[key]" id="tipos-{{ $index }}"></div><div class="col-xs-7 pl-0"><label for="tipos-{{ $index }}" class="text-primary">{{ key }}</label></div><div class="col-xs-3 text-right"><span class="text-primary">{{ count }}</span></div></div></div></div></div></div><div class="col-xs-12"><div ng-if="vm.state.name!==\'home-materia\'" class="panel panel-default filter"><div class="panel-heading"><h3 id="filtro-materia" class="m-0" aria-label="Filtrar resultados por Materia.">Materia</h3></div><div class="panel-body"><div role="group" ng-repeat="(key, count) in vm.aggs.materias" ng-click="vm.runSearch()" aria-labelledby="filtro-materia"><div class="checkbox row"><div class="col-xs-2"><input type="checkbox" ng-model="vm.materias[key]" id="materia-{{ $index }}"></div><div class="col-xs-7 pl-0"><label for="materia-{{ $index }}" class="text-primary">{{ key }}</label></div><div class="col-xs-3 text-right"><span class="text-primary">{{ count }}</span></div></div></div></div></div></div><div class="col-xs-12 d-block d-md-none d-lg-block"><div class="panel panel-default filter"><div class="panel-heading"><h3 id="filtro-organo" class="m-0 d-inline-block" aria-label="Filtrar resultados por \xD3rgano.">\xD3rgano</h3><small class="pull-right"><button class="btn btn-filter" ng-click="vm.toggle(vm.orheight, \'500px\');" ng-show="vm.orheight[\'max-height\'] === \'500px\'" aria-label="Mostrar todos las opciones de filtro por \xF3rganos."><i class="icons-vdos icon-mas-simbolo"></i></button> <button class="btn btn-filter" ng-click="vm.toggle(vm.orheight, \'500px\');" ng-show="vm.orheight[\'max-height\'] === \'auto\'" aria-label="Ocultar todos las opciones de filtro por \xF3rganos."><i class="icons-vdos icon-menos-simbolo"></i></button></small></div><div class="panel-body"><div style="overflow: hidden" ng-style="vm.orheight"><div role="group" ng-repeat="(key, count) in vm.aggs.organos" ng-click="vm.runSearch()" aria-labelledby="filtro-organo"><div class="checkbox row"><div class="col-xs-2"><input type="checkbox" ng-model="vm.organos[key]" id="organo-{{ $index }}"></div><div class="col-xs-7 pl-0"><label for="organo-{{ $index }}" class="text-primary">{{ key }}</label></div><div class="col-xs-3 text-right"><span class="text-primary">{{ count }}</span></div></div></div></div></div><div class="panel-footer text-center"><button class="btn btn-scjn-purple" ng-click="vm.toggle(vm.orheight, \'500px\');" ng-show="vm.orheight[\'max-height\'] === \'500px\'" aria-label="Mostrar todos las opciones de filtro por \xF3rganos."><span class="mr-2">Mostrar m\xE1s</span><i class="icons-vdos icon-mas-simbolo"></i></button> <button class="btn btn-scjn-danger" ng-click="vm.toggle(vm.orheight, \'500px\');" ng-show="vm.orheight[\'max-height\'] === \'auto\'" aria-label="Ocultar todos las opciones de filtro por \xF3rganos."><span class="mr-2">Mostrar menos</span><i class="icons-vdos icon-menos-simbolo"></i></button></div></div></div><div class="col-xs-12"><div ng-if="vm.emissionDates.length>0" class="panel panel-default filter"><div class="panel-heading"><h3 id="filtro-fecha-emision" class="m-0" aria-label="Filtrar resultados por fecha de emisi\xF3n.">Fecha de emisi\xF3n</h3></div><div class="panel-body p-2"><div class="row"><div class="col-xs-10 mb-4" select="vm.refreshSlider" aria-labelledby="filtro-fecha-emision"><rzslider rz-slider-model="vm.emissionSlider.minValue" rz-slider-transale="vm.translate" rz-slider-high="vm.emissionSlider.maxValue" rz-slider-options="vm.emissionSlider.options"></rzslider></div><div class="col-xs-2 text-center" id="reset-emission"><button type="button" ng-if="vm.disableEmission()" ng-click="vm.clearEmissionDate()" class="btnt" value="Cancelar filtrado por fecha de emisi\xF3n" aria-label="Cancelar filtrado por fecha de emisi\xF3n."><span class="glyphicon glyphicon-remove"></span></button></div></div></div></div></div><div class="col-xs-12"><div ng-if="vm.publicationDates.length>0" class="panel panel-default filter"><div class="panel-heading"><h3 id="filtro-fecha-red" class="m-0" aria-label="Filtrar resultados por publicaci\xF3n en la Red Jur\xEDdica de la SCJN.">Publicaci\xF3n Red Jur\xEDdica SCJN</h3></div><div class="panel-body p-2"><div class="row"><div class="col-xs-10 mb-4" select="vm.refreshSlider" aria-labelledby="filtro-fecha-red"><rzslider rz-slider-model="vm.publicationSlider.minValue" rz-slider-transale="vm.translate" rz-slider-high="vm.publicationSlider.maxValue" rz-slider-options="vm.publicationSlider.options"></rzslider></div><div class="col-xs-2 text-center" id="reset-publication"><button type="button" ng-if="vm.disablePublication()" ng-click="vm.clearPublicationDate()" class="btn" value="Cancelar filtrado por fecha Red Jur\xEDdica SCJN" aria-label="Cancelar filtrado por publicaci\xF3n Red Jur\xEDdica SCJN"><span class="glyphicon glyphicon-remove"></span></button></div></div></div></div></div></div></div><div class="col-xs-12 col-sm-6 col-md-12 visible-sm"><div class="panel panel-default filter"><div class="panel-heading"><h3 id="filtro-organo-sm" class="m-0 d-inline-block" aria-label="Filtrar resultados por \xD3rgano.">\xD3rgano</h3><small class="pull-right"><button class="btn btn-filter" ng-click="vm.toggle(vm.orheight, \'500px\');" ng-show="vm.orheight[\'max-height\'] === \'500px\'" aria-label="Mostrar todos las opciones de filtro por \xF3rganos."><i class="icons-vdos icon-mas-simbolo"></i></button> <button class="btn btn-filter" ng-click="vm.toggle(vm.orheight, \'500px\');" ng-show="vm.orheight[\'max-height\'] === \'auto\'" aria-label="Ocultar todos las opciones de filtro por \xF3rganos."><i class="icons-vdos icon-menos-simbolo"></i></button></small></div><div class="panel-body"><div style="overflow: hidden" ng-style="vm.orheight"><div role="group" ng-repeat="(key, count) in vm.aggs.organos" ng-click="vm.runSearch()" aria-labelledby="filtro-organo-sm"><div class="checkbox row"><div class="col-xs-2"><input type="checkbox" ng-model="vm.organos[key]" id="organo-sm-{{ $index }}"></div><div class="col-xs-7 pl-0"><label for="organo-sm-{{ $index }}" class="text-primary">{{ key }}</label></div><div class="col-xs-3 text-right"><span class="text-primary">{{ count }}</span></div></div></div></div></div><div class="panel-footer text-center"><button class="btn btn-scjn-purple" ng-click="vm.toggle(vm.orheight, \'500px\');" ng-show="vm.orheight[\'max-height\'] === \'500px\'" aria-label="Mostrar todos las opciones de filtro por \xF3rganos."><span class="mr-2">Mostrar m\xE1s</span><i class="icons-vdos icon-mas-simbolo"></i></button> <button class="btn btn-scjn-purple" ng-click="vm.toggle(vm.orheight, \'500px\');" ng-show="vm.orheight[\'max-height\'] === \'auto\'" aria-label="Ocultar todos las opciones de filtro por \xF3rganos."><span class="mr-2">Mostrar menos</span><i class="icons-vdos icon-menos-simbolo"></i></button></div></div></div></div><div id="abrogado-route" ng-if="vm.criteria.materia == \'ADMINISTRATIVA\'"><button ui-sref="materia-abrogado({materia:vm.criteria.materia})" class="btn-abrogado">Consultar el Marco Normativo Abrogado en Materia Administrativa</button></div></div><div ng-class="vm.state.name !== \'materia-abrogado\' ? \'col-lg-9 col-md-8 col-xs-12\' : \'col-xs-12\'"><form ng-submit="vm.runSearch()" class="form-inline mb-4" id="search"><div class="d-block d-sm-flex align-items-center"><div class="align-self-center mr-3"><label for="search-input font-weight-bold">Ingresar consulta:</label></div><div class="col mb-3 mb-sm-0"><input id="search-input" type="text" class="form-control w-100" ng-model="vm.criteria.query" typeahead-loading="" typeahead-no-results="" aria-expanded="false" aria-autocomplete="both" aria-activedescendant="" aria-selected="true" ng-disabled="" autocomplete="off"></div><div class="ml-0 ml-sm-3"><button id="buscarBtn" class="btn btn-scjn" type="submit" aria-label="Realizar una b\xFAsqueda" value="Realizar una b\xFAsqueda." ng-disabled="loading"><span>Buscar</span></button></div></div></form><div class="result" ng-repeat="norma in vm.normas track by norma.id"><div class="mb-3" ng-show="vm.isAuthenticated()"><button type="button" ui-sref="norma.edit({id:norma.id})" class="btn btn-primary btn-xs"><span class="fa fa-fw fa-edit"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button></div><div class="result-header d-block d-sm-flex align-items-center"><div class="align-self-start d-none d-md-block mr-3 mr-xs-0"><ul class="nav nav-pills nav-stacked documents-list"><li ng-repeat="doc in norma.documentos"><div ng-switch="doc.mimeType" class="text-center"><a ng-switch-when="application/pdf" ng-href="public/api/download?fileName={{ doc.name }}" rel="noreferrer" class="document d-inline-block" target="_blank" aria-label="{{ norma.denominacion }}. Documento PDF. Se abrir\xE1 en una nueva p\xE1gina."><i class="icons-vdos" ng-class="doc.icon" style="font-size: 48px; color: #ff0000"></i> </a><a ng-switch-when="application/vnd.openxmlformats-officedocument.wordprocessingml.document" ng-href="public/api/download?fileName={{ doc.name }}" rel="noreferrer" class="document d-inline-block" target="_blank" aria-label="{{ norma.denominacion }}. Documento Word. Se abrir\xE1 en una nueva p\xE1gina."><i class="icons-vdos" ng-class="doc.icon" style="font-size: 48px; color: #3B5998"></i> </a><a ng-switch-default ng-href="public/api/download?fileName={{ doc.name }}" rel="noreferrer" class="document d-inline-block" target="_blank" aria-label="{{ norma.denominacion }}"><i class="icons-vdos" ng-class="doc.icon" style="font-size: 48px; color: #003A70"></i></a></div></li></ul></div><div class="col align-self-start mb-sm-0 mb-3"><h2 class="text-left text-primary" ng-bind-html="vm.denominacionFormat(norma.denominacion)"></h2></div><div class="align-self-start d-md-none d-block mt-0 mt-xs-4"><ul class="nav nav-pills nav-stacked documents-list"><li ng-repeat="doc in norma.documentos"><div ng-switch="doc.mimeType" class="text-center"><a ng-switch-when="application/pdf" ng-href="public/api/download?fileName={{ doc.name }}" rel="noreferrer" class="document d-inline-block" target="_blank" aria-label="{{ norma.denominacion }}. Documento PDF. Se abrir\xE1 en una nueva p\xE1gina."><i class="icons-vdos" ng-class="doc.icon" style="font-size: 48px; color: #ff0000"></i> </a><a ng-switch-when="application/vnd.openxmlformats-officedocument.wordprocessingml.document" ng-href="public/api/download?fileName={{ doc.name }}" rel="noreferrer" class="document d-inline-block" target="_blank" aria-label="{{ norma.denominacion }}. Documento Word. Se abrir\xE1 en una nueva p\xE1gina."><i class="icons-vdos" ng-class="doc.icon" style="font-size: 48px; color: #3B5998"></i> </a><a ng-switch-default ng-href="public/api/download?fileName={{ doc.name }}" rel="noreferrer" class="document d-inline-block" target="_blank" aria-label="{{ norma.denominacion }}"><i class="icons-vdos" ng-class="doc.icon" style="font-size: 48px; color: #003A70"></i></a></div></li></ul></div></div><div class="result-body"><div class="row mx-3 mx-xs-0"><div class="col-sm-6 col-xs-12"><dl class="mb-3" ng-show="norma.organoRelevantes.length"><dt class="text-primary">\xD3rgano/\xC1rea emisor:</dt><dd><ul class="nav nav-pills nav-stacked"><li ng-repeat="organorelevante in norma.organoRelevantes"><p class="mb-0">{{ organorelevante }}</p></li></ul></dd></dl><dl class="mb-3"><dt class="text-primary"><span uib-tooltip="Fecha de publicaci\xF3n en el Diario Oficial de la Federaci\xF3n">Publicaci\xF3n DOF:</span></dt><dd><span ng-if="norma.fechaDOF">{{ norma.fechaDOF | date: "dd/MM/yyyy" }}</span> <span ng-if="norma.fechaDOF === null">No aplica</span></dd></dl><dl class="mb-3"><dt class="text-primary"><span uib-tooltip="Fecha de publicaci\xF3n en el Semanario Judicial de la Federaci\xF3n">Publicaci\xF3n SJF:</span></dt><dd><span ng-if="norma.fechaSJFYG">{{ norma.fechaSJFYG | date: "dd/MM/yyyy" }}</span> <span ng-if="norma.fechaSJFYG === null">No aplica</span></dd></dl><dl class="mb-xs-3 mb-0"><dt class="text-primary"><span uib-tooltip="Fecha de publicaci\xF3n en la Gaceta del Semanario Judicial de la Federaci\xF3n">Publicaci\xF3n Gaceta SJF:</span></dt><dd><span ng-if="norma.fechaSJFGaceta">{{ norma.fechaSJFGaceta | date: "LLLL/yyyy" }}</span> <span ng-if="norma.fechaSJFGaceta === null">No aplica</span></dd></dl></div><div class="col-sm-6 col-xs-12"><dl class="mb-3" ng-if="norma.fechaPublicacion"><dt class="text-primary"><span uib-tooltip="Fecha de publicaci\xF3n en la Red Jur\xEDdica de la Suprema Corte de Justicia de la Naci\xF3n">Publicaci\xF3n Red Jur\xEDdica SCJN:</span></dt><dd><span>{{ norma.fechaPublicacion | date: "dd/MM/yyyy "}}</span></dd></dl><dl class="mb-3" ng-if="norma.fechaEmision"><dt class="text-primary">Fecha de emisi\xF3n</dt><dd ng-switch="norma.showOnlyYear"><span ng-switch-when="true">{{ norma.fechaEmision | date: "yyyy" }}</span> <span ng-switch-default>{{ norma.fechaEmision | date: "dd/MM/yyyy" }}</span></dd></dl><dl class="mb-3" ng-if="norma.tipoOrdenamiento"><dt class="text-primary">Tipo:</dt><dd>{{ norma.tipoOrdenamiento }}</dd></dl><dl class="mb-xs-3 mb-0" ng-if="norma.materia"><dt class="text-primary">Materia:</dt><dd>{{ norma.materia }}</dd></dl></div></div></div><div class="result-footer" ng-if="norma.palabrasClaves.length > 0"><div class="row mx-3 mx-xs-0"><div class="col-xs-12"><dl class="mb-0"><dt class="text-primary">Temas relacionados:</dt><dd ng-if="vm.state.name !== \'materia-abrogado\'"><a href="#/?search={{ palabra }}" ng-class="norma.height ? \'hide-tags\' : \'show-tags\'" class="m-1 d-inline-block" ng-repeat="palabra in norma.palabrasClaves"><span class="badge badge-scjn">{{ palabra }}</span></a></dd><dd ng-if="vm.state.name === \'materia-abrogado\'"><span ng-class="norma.height ? \'hide-tags\' : \'show-tags\'" class="m-1 d-inline-block" ng-repeat="palabra in norma.palabrasClaves"><span class="badge badge-scjn">{{ palabra }}</span></span></dd></dl></div></div><div class="text-center mt-2 pt-2"><button class="btn btn-scjn" ng-click="vm.toggleWords($index);" ng-show="norma.height && norma.palabrasClaves.length > 5"><span class="mr-2">Mostrar m\xE1s temas</span><i class="icons-vdos icon-mas-simbolo"></i></button> <button class="btn btn-scjn-danger" ng-click="vm.toggleWords($index);" ng-show="!norma.height && norma.palabrasClaves.length > 5"><span class="mr-2">Mostrar menos temas</span><i class="icons-vdos icon-menos-simbolo"></i></button></div></div></div><div class="row mt-3 d-md-block d-none"><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()" previous-text="&lsaquo; Anterior" next-text="Siguiente &rsaquo;" first-text="&laquo;" last-text="&raquo;" max-size="5"></uib-pagination></div></div><div class="row mt-3 d-md-none d-block"><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()" previous-text="&lsaquo;" next-text="&rsaquo;" max-size="3"></uib-pagination></div></div></div></div></div>');
$templateCache.put('app/account/activate/activate.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1 data-translate="activate.title">Activation</h1><div class="alert alert-success" ng-show="vm.success" data-translate="activate.messages.success" translate-compile><strong>Your user has been activated.</strong> Please <a class="alert-link" href="" ng-click="vm.login()">sign in</a>.</div><div class="alert alert-danger" ng-show="vm.error" data-translate="activate.messages.error"><strong>Your user could not be activated.</strong> Please use the registration form to sign up.</div></div></div></div>');
$templateCache.put('app/account/password/password.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h2 data-translate="password.title" translate-values="{username: \'{{vm.account.login}}\'}">Password for [<b>{{vm.account.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success" data-translate="password.messages.success"><strong>Password changed!</strong></div><div class="alert alert-danger" ng-show="vm.error" data-translate="password.messages.error"><strong>An error has occurred!</strong> The password could not be changed.</div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div><form name="form" role="form" novalidate ng-submit="vm.changePassword()" show-validation><div class="form-group"><label class="control-label" for="password" data-translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your confirmation password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="password.form.button">Save</button></form></div></div></div>');
$templateCache.put('app/account/register/register.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1 data-translate="register.title">Registration</h1><div class="alert alert-success" ng-show="vm.success" data-translate="register.messages.success"><strong>Registration saved!</strong> Please check your email for confirmation.</div><div class="alert alert-danger" ng-show="vm.error" data-translate="register.messages.error.fail"><strong>Registration failed!</strong> Please try again later.</div><div class="alert alert-danger" ng-show="vm.errorUserExists" data-translate="register.messages.error.userexists"><strong>Login name already registered!</strong> Please choose another one.</div><div class="alert alert-danger" ng-show="vm.errorEmailExists" data-translate="register.messages.error.emailexists"><strong>Email is already in use!</strong> Please choose another one.</div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div></div><div class="col-md-8 col-md-offset-2"><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.register()" show-validation><div class="form-group"><label class="control-label" for="login" data-translate="global.form.username">Username</label><input type="text" class="form-control" id="login" name="login" placeholder="{{\'global.form.username.placeholder\' | translate}}" ng-model="vm.registerAccount.login" ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/" required><div ng-show="form.login.$dirty && form.login.$invalid"><p class="help-block" ng-show="form.login.$error.required" data-translate="register.messages.validate.login.required">Your username is required.</p><p class="help-block" ng-show="form.login.$error.minlength" data-translate="register.messages.validate.login.minlength">Your username is required to be at least 1 character.</p><p class="help-block" ng-show="form.login.$error.maxlength" data-translate="register.messages.validate.login.maxlength">Your username cannot be longer than 50 characters.</p><p class="help-block" ng-show="form.login.$error.pattern" data-translate="register.messages.validate.login.pattern">Your username can only contain lower-case letters and digits.</p></div></div><div class="form-group"><label class="control-label" for="email" data-translate="global.form.email">Email</label><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.registerAccount.email" ng-minlength="5" ng-maxlength="100" required><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" data-translate="global.messages.validate.email.required">Your email is required.</p><p class="help-block" ng-show="form.email.$error.email" data-translate="global.messages.validate.email.invalid">Your email is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" data-translate="global.messages.validate.email.minlength">Your email is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" data-translate="global.messages.validate.email.maxlength">Your email cannot be longer than 100 characters.</p></div></div><div class="form-group"><label class="control-label" for="password" data-translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.registerAccount.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.registerAccount.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your confirmation password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="register.form.button">Register</button></form><p></p><div class="alert alert-warning" data-translate="global.messages.info.authenticated" translate-compile>If you want to <a class="alert-link" href="" ng-click="vm.login()">sign in</a>, you can try the default accounts:<br>- Administrator (login="admin" and password="admin")<br>- User (login="user" and password="user").</div></div></div></div>');
$templateCache.put('app/account/settings/settings.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h2 data-translate="settings.title" translate-values="{username: \'{{vm.settingsAccount.login}}\'}">User settings for [<b>{{vm.settingsAccount.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success" data-translate="settings.messages.success"><strong>Settings saved!</strong></div><jhi-alert-error></jhi-alert-error><form name="form" role="form" novalidate ng-submit="vm.save()" show-validation><div class="form-group"><label class="control-label" for="firstName" data-translate="settings.form.firstname">First Name</label><input type="text" class="form-control" id="firstName" name="firstName" placeholder="{{\'settings.form.firstname.placeholder\' | translate}}" ng-model="vm.settingsAccount.firstName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.firstName.$dirty && form.firstName.$invalid"><p class="help-block" ng-show="form.firstName.$error.required" data-translate="settings.messages.validate.firstname.required">Your first name is required.</p><p class="help-block" ng-show="form.firstName.$error.minlength" data-translate="settings.messages.validate.firstname.minlength">Your first name is required to be at least 1 character.</p><p class="help-block" ng-show="form.firstName.$error.maxlength" data-translate="settings.messages.validate.firstname.maxlength">Your first name cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="lastName" data-translate="settings.form.lastname">Last Name</label><input type="text" class="form-control" id="lastName" name="lastName" placeholder="{{\'settings.form.lastname.placeholder\' | translate}}" ng-model="vm.settingsAccount.lastName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.lastName.$dirty && form.lastName.$invalid"><p class="help-block" ng-show="form.lastName.$error.required" data-translate="settings.messages.validate.lastname.required">Your last name is required.</p><p class="help-block" ng-show="form.lastName.$error.minlength" data-translate="settings.messages.validate.lastname.minlength">Your last name is required to be at least 1 character.</p><p class="help-block" ng-show="form.lastName.$error.maxlength" data-translate="settings.messages.validate.lastname.maxlength">Your last name cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="email" data-translate="global.form.email">Email</label><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.settingsAccount.email" ng-minlength="5" ng-maxlength="100" required maxlength="100"><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" data-translate="global.messages.validate.email.required">Your email is required.</p><p class="help-block" ng-show="form.email.$error.email" data-translate="global.messages.validate.email.invalid">Your email is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" data-translate="global.messages.validate.email.minlength">Your email is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" data-translate="global.messages.validate.email.maxlength">Your email cannot be longer than 100 characters.</p></div></div><div class="form-group"><label for="langKey" data-translate="settings.form.language">Language</label><select id="langKey" name="langKey" class="form-control" ng-model="vm.settingsAccount.langKey" ng-controller="JhiLanguageController as languageVm" ng-options="code as (code | findLanguageFromKey) for code in languageVm.languages"></select></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="settings.form.button">Save</button></form></div></div></div>');
$templateCache.put('app/admin/audits/audits.html','<div><h2 data-translate="audits.title">Audits</h2><div class="row"><div class="col-md-5"><h4 data-translate="audits.filter.title">Filter by date</h4><p class="input-group"><span class="input-group-addon" data-translate="audits.filter.from">from</span> <input type="date" class="input-sm form-control" name="start" ng-model="vm.fromDate" ng-change="vm.onChangeDate()" required> <span class="input-group-addon" data-translate="audits.filter.to">to</span> <input type="date" class="input-sm form-control" name="end" ng-model="vm.toDate" ng-change="vm.onChangeDate()" required></p></div></div><table class="table table-condensed table-striped table-bordered table-responsive"><thead><tr><th ng-click="predicate = \'timestamp\'; reverse=!reverse"><span data-translate="audits.table.header.date">Date</span></th><th ng-click="predicate = \'principal\'; reverse=!reverse"><span data-translate="audits.table.header.principal">User</span></th><th ng-click="predicate = \'type\'; reverse=!reverse"><span data-translate="audits.table.header.status">State</span></th><th ng-click="predicate = \'data.message\'; reverse=!reverse"><span data-translate="audits.table.header.data">Extra data</span></th></tr></thead><tr ng-repeat="audit in vm.audits | filter:filter | orderBy:predicate:reverse" ng-hide="audit.filtered"><td><span>{{audit.timestamp| date:\'medium\'}}</span></td><td><small>{{audit.principal}}</small></td><td>{{audit.type}}</td><td><span ng-show="audit.data.message">{{audit.data.message}}</span> <span ng-show="audit.data.remoteAddress"><span data-translate="audits.table.data.remoteAddress">Remote Address</span> {{audit.data.remoteAddress}}</span></td></tr></table><div class="text-center"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.loadPage(vm.page)"></uib-pagination></div></div>');
$templateCache.put('app/admin/configuration/configuration.html','<div><h2 data-translate="configuration.title">Configuration</h2><span data-translate="configuration.filter">Filter (by prefix)</span> <input type="text" ng-model="filter" class="form-control"><h3 ng-hide="filteredConfig.length === 0">Spring configuration</h3><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filteredConfig.length === 0"><thead><tr><th ng-click="predicate = \'prefix\'; reverse=!reverse" class="col-sm-4"><span data-translate="configuration.table.prefix">Prefix</span></th><th data-translate="configuration.table.properties" class="col-sm-8">Properties</th></tr></thead><tr ng-repeat="entry in filtered = (vm.configuration | filter:filter | orderBy:predicate:reverse)"><td><span>{{entry.prefix}}</span></td><td><div class="row" ng-repeat="(key, value) in entry.properties"><div class="col-md-4">{{key}}</div><div class="col-md-8"><span class="pull-right label label-success break">{{value}}</span></div></div></td></tr></table><div ng-repeat="(key, value) in vm.allConfiguration"><h4 ng-hide="filtered.length === 0"><span>{{key}}</span></h4><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filtered.length === 0"><thead><tr><th class="col-sm-4">Property</th><th class="col-sm-8">Value</th></tr></thead><tbody><tr ng-repeat="item in filtered = (value | filter:filter)"><td class="break">{{item.key}}</td><td class="break"><span class="pull-right label label-success break">{{item.val}}</span></td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/docs/docs.html','<iframe src="swagger-ui/index.html" frameborder="0" marginheight="0" marginwidth="0" width="100%" height="900" scrolling="auto" target="_top" title="Swagger UI"></iframe>');
$templateCache.put('app/admin/elasticsearch-reindex/elasticsearch-reindex-dialog.html','<form name="reindexForm" ng-submit="vm.confirmReindex()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="elasticsearch.reindex.dialog.title">Confirm reindex operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="elasticsearch.reindex.dialog.question">Are you sure you want to reindex Elasticsearch? This could take a while!</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp; <span data-translate="elasticsearch.reindex.dialog.cancel">Cancel</span></button> <button type="submit" class="btn btn-danger"><span class="glyphicon glyphicon-exclamation-sign"></span>&nbsp; <span data-translate="elasticsearch.reindex.dialog.confirm">Reindex</span></button></div></form>');
$templateCache.put('app/admin/elasticsearch-reindex/elasticsearch-reindex.html','<div class="clearfix"><h1 data-translate="elasticsearch.reindex.title">Reindex Elasticsearch</h1><jhi-alert></jhi-alert><p data-translate="elasticsearch.reindex.instructions1">This will send a request to reindex all data from your primary datasource into Elasticsearch. This will fix missing data and mapping issues, however you will lose any ES data and mapping that was defined outside of your application. This request will return immediately and the reindexing will run in the background. You will see "Elasticsearch: Successfully performed reindexing" in your logs when this is complete.</p><p data-translate="elasticsearch.reindex.instructions2">This can take a long time and is susceptible to concurrency issues so it should be performed when the number of users is low.</p><button type="button" class="btn btn-primary pull-right" ui-sref="elasticsearch-reindex.dialog"><span class="glyphicon glyphicon-exclamation-sign"></span> <span data-translate="elasticsearch.reindex.go">Go</span></button></div>');
$templateCache.put('app/admin/entity-audit/entity-audit.detail.html','<div class="modal-header"><button aria-label="{{ \'entityAudit.detail.close\' | translate }}" data-dismiss="modal" class="close" type="button" ng-click="vm.cancel()"><span aria-hidden="true">&times;</span></button><h4 class="modal-title" data-translate="entityAudit.detail.title">Audit Details</h4></div><div class="modal-body pad"><div><strong data-translate="entityAudit.detail.action" translate-value-action="{{vm.audit.action}}">{{vm.audit.action}} action was performed on below data</strong><br><br><del class="diff diff-key" data-translate="entityAudit.detail.old">Old/Removed value</del> &nbsp; <ins class="diff diff-key" data-translate="entityAudit.detail.new">New/Added value</ins></div><br><label data-translate="entityAudit.detail.changedFields">Changed Fields</label><pre id="resultChanges" ng-bind-html="vm.diffValueChanges"></pre><label data-translate="entityAudit.detail.allFields">All Fields</label><pre id="result" ng-bind-html="vm.diffValue"></pre></div><div class="modal-footer"><button data-dismiss="modal" class="btn btn-default" type="button" ng-click="vm.cancel()" data-translate="entityAudit.detail.done">Done</button></div>');
$templateCache.put('app/admin/entity-audit/entity-audits.html','<div ng-cloak class="pad"><div class="row"><h3 class="col-sm-12" data-translate="entityAudit.home.title">Entity Audits</h3></div><jhi-alert></jhi-alert><div class="row"><div class="col-md-12 pad"><h4 data-translate="entityAudit.home.filter">Filter</h4><form name="auditForm" role="form" novalidate show-validation><div class="row"><div class="col-md-8 form-group"><label data-translate="entityAudit.home.entityOrTable">Entity/Table</label><select class="input-sm form-control" name="qualifiedName" id="qualifiedName" required ng-options="vm.getEntityName(entity) for entity in vm.entities" ng-model="vm.qualifiedName"></select><div ng-show="auditForm.qualifiedName.$invalid"><p class="help-block" ng-show="auditForm.qualifiedName.$error.required" data-translate="entity.validation.required">This field is required</p></div></div><div class="col-md-4 form-group"><label data-translate="entityAudit.home.limitTo">Limit to</label><select class="input-sm form-control" name="limit" id="limit" required ng-options="option for option in vm.limits" ng-model="vm.limit"></select></div></div><div class="row pad"><button ng-disabled="auditForm.$invalid" class="btn btn-primary pull-right" ng-click="vm.loadChanges()"><i class="glyphicon glyphicon-import"></i>&nbsp; {{\'entityAudit.home.loadChangeList\' | translate}}</button></div></form></div></div><div ng-show="!vm.loading"><div class="table-responsive" ng-if="vm.audits.length > 0"><p ng-if="vm.qualifiedName" data-translate="entityAudit.result.showInfo" translate-value-limit="{{vm.limit}}" translate-value-entity="{{vm.getEntityName(vm.qualifiedName)}}">Last <strong>{{vm.limit}}</strong> Changes for <strong>{{vm.getEntityName(vm.qualifiedName)}}</strong></p><form class="form-inline"><div class="form-group"><label for="searchField" data-translate="entityAudit.result.searchFieldLabel">Filter:</label><input type="text" class="form-control" id="searchField" ng-model="filter.$" placeholder="{{ \'entityAudit.result.globalFilter\' | translate }}"></div><div class="form-group"><input type="text" class="form-control" id="searchFieldEntityId" ng-model="filter.entityId" placeholder="{{ \'entityAudit.result.entityIdFilter\' | translate }}"></div></form><table class="table table-bordered table-hover table-striped"><thead><tr><th data-translate="entityAudit.result.tableHeader.entityId">Entity Id</th><th data-translate="entityAudit.result.tableHeader.action">Action</th><th data-translate="entityAudit.result.tableHeader.version">Version</th><th data-translate="entityAudit.result.tableHeader.value">Value</th><th data-translate="entityAudit.result.tableHeader.modifiedDate">Modified Date</th><th data-translate="entityAudit.result.tableHeader.modifiedBy">Modified By</th><th><i class="glyphicon glyphicon-eye-open"></i></th></tr></thead><tbody><tr ng-repeat="audit in vm.audits | filter:filter"><td>{{audit.entityId}}</td><td>{{audit.action}}</td><td>{{audit.commitVersion}}</td><td><pre class="audit-obj" ng-bind-html="vm.format(audit.entityValue)"></pre></td><!-- comment above line and uncomment below to have Table view of value --><!--td class="no-pad">\n                        <div class="audit-obj">\n                            <table class="table table-bordered table-hover no-margin">\n                                <tr>\n                                    <th data-translate="entityAudit.result.tableBody.field">Field</th>\n                                    <th data-translate="entityAudit.result.tableBody.value">Value</th>\n                                </tr>\n                                <tr ng-repeat="(k,v) in audit.entityValue" ng-if="!vm.isObject(v)">\n                                    <td>{{k}}</td>\n                                    <td>\n                                        <span ng-if="vm.isDate(k)">{{v | date:\'medium\'}}</span>\n                                        <span ng-if="!vm.isDate(k)">{{v}}</span>\n                                    </td>\n                                </tr>\n                            </table>\n                        </div>\n                    </td--><td>{{audit.modifiedDate | date:\'medium\'}}</td><td>{{audit.modifiedBy}}</td><td><button type="button" ng-click="vm.openChange(audit)" uib-tooltip="{{ \'entityAudit.result.tableBody.viewDetails\' | translate }}" uib-tooltip-placement="auto" class="btn btn-info btn-xs"><i class="glyphicon glyphicon-eye-open"></i></button></td></tr></tbody></table></div><p ng-if="vm.displayedChanges.length == 0" data-translate="entityAudit.result.noDataFound">No Data found for the filters</p></div></div>');
$templateCache.put('app/admin/health/health.html','<div><h2 data-translate="health.title">Health Checks</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span data-translate="health.refresh.button">Refresh</span></button></p><table id="healthCheck" class="table table-striped"><thead><tr><th class="col-md-7" data-translate="health.table.service">Service Name</th><th class="col-md-2 text-center" data-translate="health.table.status">Status</th><th class="col-md-2 text-center" data-translate="health.details.details">Details</th></tr></thead><tbody><tr ng-repeat="health in vm.healthData"><td>{{\'health.indicator.\' + vm.baseName(health.name) | translate}} {{vm.subSystemName(health.name)}}</td><td class="text-center"><span class="label" ng-class="vm.getLabelClass(health.status)">{{\'health.status.\' + health.status | translate}}</span></td><td class="text-center"><a class="hand" ng-click="vm.showHealth(health)" ng-show="health.details || health.error"><i class="glyphicon glyphicon-eye-open"></i></a></td></tr></tbody></table></div>');
$templateCache.put('app/admin/health/health.modal.html','<div class="modal-header"><button aria-label="Close" data-dismiss="modal" class="close" type="button" ng-click="vm.cancel()"><span aria-hidden="true">&times;</span></button><h4 class="modal-title" id="showHealthLabel">{{\'health.indicator.\' + vm.baseName(vm.currentHealth.name) | translate}} {{vm.subSystemName(vm.currentHealth.name)}}</h4></div><div class="modal-body pad"><div ng-show="vm.currentHealth.details"><h4 data-translate="health.details.properties">Properties</h4><table class="table table-striped"><thead><tr><th class="col-md-6 text-left" data-translate="health.details.name">Name</th><th class="col-md-6 text-left" data-translate="health.details.value">Value</th></tr></thead><tbody><tr ng-repeat="(k,v) in vm.currentHealth.details"><td class="col-md-6 text-left">{{k}}</td><td class="col-md-6 text-left">{{v}}</td></tr></tbody></table></div><div ng-show="vm.currentHealth.error"><h4 data-translate="health.details.error">Error</h4><pre>{{vm.currentHealth.error}}</pre></div></div><div class="modal-footer"><button data-dismiss="modal" class="btn btn-default pull-left" type="button" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/logs/logs.html','<div class="table-responsive"><h2 data-translate="logs.title">Logs</h2><p data-translate="logs.nbloggers" translate-values="{total: \'{{ vm.loggers.length }}\'}">There are {{ vm.loggers.length }} loggers.</p><span data-translate="logs.filter">Filter</span> <input type="text" ng-model="filter" class="form-control"><table class="table table-condensed table-striped table-bordered"><thead><tr title="click to order"><th ng-click="predicate = \'name\'; reverse=!reverse"><span data-translate="logs.table.name">Name</span></th><th ng-click="predicate = \'level\'; reverse=!reverse"><span data-translate="logs.table.level">Level</span></th></tr></thead><tr ng-repeat="logger in vm.loggers | filter:filter | orderBy:predicate:reverse"><td><small>{{logger.name | characters:140}}</small></td><td><button ng-click="vm.changeLevel(logger.name, \'TRACE\')" ng-class="(logger.level==\'TRACE\') ? \'btn-danger\' : \'btn-default\'" class="btn btn-default btn-xs">TRACE</button> <button ng-click="vm.changeLevel(logger.name, \'DEBUG\')" ng-class="(logger.level==\'DEBUG\') ? \'btn-warning\' : \'btn-default\'" class="btn btn-default btn-xs">DEBUG</button> <button ng-click="vm.changeLevel(logger.name, \'INFO\')" ng-class="(logger.level==\'INFO\') ? \'btn-info\' : \'btn-default\'" class="btn btn-default btn-xs">INFO</button> <button ng-click="vm.changeLevel(logger.name, \'WARN\')" ng-class="(logger.level==\'WARN\') ? \'btn-success\' : \'btn-default\'" class="btn btn-default btn-xs">WARN</button> <button ng-click="vm.changeLevel(logger.name, \'ERROR\')" ng-class="(logger.level==\'ERROR\') ? \'btn-primary\' : \'btn-default\'" class="btn btn-default btn-xs">ERROR</button></td></tr></table></div>');
$templateCache.put('app/admin/metrics/metrics.html','<div><h2 data-translate="metrics.title">Application Metrics</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span data-translate="metrics.refresh.button">Refresh</span></button></p><h3 data-translate="metrics.jvm.title">JVM Metrics</h3><div class="row" ng-hide="vm.updatingMetrics"><div class="col-md-4"><b data-translate="metrics.jvm.memory.title">Memory</b><p><span data-translate="metrics.jvm.memory.total">Total Memory</span> ({{vm.metrics.gauges[\'jvm.memory.total.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.total.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.total.max\'].value" value="vm.metrics.gauges[\'jvm.memory.total.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.total.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.total.max\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.memory.heap">Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.heap.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.heap.max\'].value" value="vm.metrics.gauges[\'jvm.memory.heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.heap.max\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.memory.nonheap">Non-Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value" value="vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b data-translate="metrics.jvm.threads.title">Threads</b> (Total: {{vm.metrics.gauges[\'jvm.threads.count\'].value}}) <a class="hand" ng-click="vm.refreshThreadDumpData()" data-toggle="modal" data-target="#threadDump"><i class="glyphicon glyphicon-eye-open"></i></a><p><span data-translate="metrics.jvm.threads.runnable">Runnable</span> {{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value}}</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.runnable.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.timedwaiting">Timed Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.waiting">Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.blocked">Blocked</span> ({{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.blocked.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b data-translate="metrics.jvm.gc.title">Garbage collections</b><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.marksweepcount">Mark Sweep count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.count\'].value}}</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.marksweeptime">Mark Sweep time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.time\'].value}}ms</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.scavengecount">Scavenge count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.count\'].value}}</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.scavengetime">Scavenge time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.time\'].value}}ms</div></div></div></div><div class="well well-lg" ng-show="vm.updatingMetrics" data-translate="metrics.updating">Updating...</div><h3 data-translate="metrics.jvm.http.title">HTTP requests (events per second)</h3><p><span data-translate="metrics.jvm.http.active">Active requests</span> <b>{{vm.metrics.counters[\'com.codahale.metrics.servlet.InstrumentedFilter.activeRequests\'].count | number:0}}</b> - <span data-translate="metrics.jvm.http.total">Total requests</span> <b>{{vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count | number:0}}</b></p><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="metrics.jvm.http.table.code">Code</th><th data-translate="metrics.jvm.http.table.count">Count</th><th class="text-right" data-translate="metrics.jvm.http.table.mean">Mean</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (1 min)</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (5 min)</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (15 min)</th></tr></thead><tbody><tr><td data-translate="metrics.jvm.http.code.ok">OK</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m15_rate | number:2}}</td></tr><tr><td data-translate="metrics.jvm.http.code.notfound">Not Found</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m15_rate | number:2}}</td></tr><tr><td data-translate="metrics.jvm.http.code.servererror">Server error</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m15_rate | number:2}}</td></tr></tbody></table></div><h3 data-translate="metrics.servicesstats.title">Services statistics (time in millisecond)</h3><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="metrics.servicesstats.table.name">Service name</th><th class="text-right" data-translate="metrics.servicesstats.table.count">Count</th><th class="text-right" data-translate="metrics.servicesstats.table.mean">Mean</th><th class="text-right" data-translate="metrics.servicesstats.table.min">Min</th><th class="text-right" data-translate="metrics.servicesstats.table.p50">p50</th><th class="text-right" data-translate="metrics.servicesstats.table.p75">p75</th><th class="text-right" data-translate="metrics.servicesstats.table.p95">p95</th><th class="text-right" data-translate="metrics.servicesstats.table.p99">p99</th><th class="text-right" data-translate="metrics.servicesstats.table.max">Max</th></tr></thead><tbody><tr ng-repeat="(k, v) in vm.servicesStats"><td>{{k}}</td><td class="text-right">{{v.count}}</td><td class="text-right">{{v.mean * 1000 | number:0}}</td><td class="text-right">{{v.min * 1000 | number:0}}</td><td class="text-right">{{v.p50 * 1000 | number:0}}</td><td class="text-right">{{v.p75 * 1000 | number:0}}</td><td class="text-right">{{v.p95 * 1000 | number:0}}</td><td class="text-right">{{v.p99 * 1000 | number:0}}</td><td class="text-right">{{v.max * 1000 | number:0}}</td></tr></tbody></table></div><h3 data-translate="metrics.cache.title">Cache statistics</h3><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="metrics.cache.cachename">Cache name</th><th class="text-right" data-translate="metrics.cache.hits">Cache Hits</th><th class="text-right" data-translate="metrics.cache.misses">Cache Misses</th><th class="text-right" data-translate="metrics.cache.gets">Cache Gets</th><th class="text-right" data-translate="metrics.cache.puts">Cache Puts</th><th class="text-right" data-translate="metrics.cache.removals">Cache Removals</th><th class="text-right" data-translate="metrics.cache.evictions">Cache Evictions</th><th class="text-right" data-translate="metrics.cache.hitPercent">Cache Hit %</th><th class="text-right" data-translate="metrics.cache.missPercent">Cache Miss %</th><th class="text-right" data-translate="metrics.cache.averageGetTime">Average get time (\xB5s)</th><th class="text-right" data-translate="metrics.cache.averagePutTime">Average put time (\xB5s)</th><th class="text-right" data-translate="metrics.cache.averageRemoveTime">Average remove time (\xB5s)</th></tr></thead><tbody><tr ng-repeat="(k, v) in vm.cachesStats" ng-once><td>{{v.name}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-hits\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-misses\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-gets\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-puts\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-removals\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-evictions\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-hit-percentage\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-miss-percentage\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.average-get-time\'].value | number:2}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.average-put-time\'].value | number:2}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.average-remove-time\'].value | number:2}}</td></tr></tbody></table></div><h3 data-translate="metrics.datasource.title" ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0">DataSource statistics (time in millisecond)</h3><div class="table-responsive" ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0"><table class="table table-striped"><thead><tr><th><span data-translate="metrics.datasource.usage">Usage</span> ({{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value}} / {{vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value}})</th><th class="text-right" data-translate="metrics.datasource.count">Count</th><th class="text-right" data-translate="metrics.datasource.mean">Mean</th><th class="text-right" data-translate="metrics.datasource.min">Min</th><th class="text-right" data-translate="metrics.datasource.p50">p50</th><th class="text-right" data-translate="metrics.datasource.p75">p75</th><th class="text-right" data-translate="metrics.datasource.p95">p95</th><th class="text-right" data-translate="metrics.datasource.p99">p99</th><th class="text-right" data-translate="metrics.datasource.max">Max</th></tr></thead><tbody><tr><td><div class="progress progress-striped"><uib-progressbar min="0" max="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value" value="vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value * 100 / vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value | number:0}}%</span></uib-progressbar></div></td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].count}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].mean | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].min | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p50 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p75 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p95 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p99 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].max | number:2}}</td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/metrics/metrics.modal.html','<!-- Modal used to display the threads dump --><div class="modal-header"><button type="button" class="close" ng-click="vm.cancel()">&times;</button><h4 class="modal-title" data-translate="metrics.jvm.threads.dump.title">Threads dump</h4></div><div class="modal-body pad"><span class="label label-primary" ng-click="threadDumpFilter = {}">All&nbsp;<span class="badge">{{vm.threadDumpAll}}</span></span>&nbsp; <span class="label label-success" ng-click="threadDumpFilter = {threadState: \'RUNNABLE\'}">Runnable&nbsp;<span class="badge">{{vm.threadDumpRunnable}}</span></span>&nbsp; <span class="label label-info" ng-click="threadDumpFilter = {threadState: \'WAITING\'}">Waiting&nbsp;<span class="badge">{{vm.threadDumpWaiting}}</span></span>&nbsp; <span class="label label-warning" ng-click="threadDumpFilter = {threadState: \'TIMED_WAITING\'}">Timed Waiting&nbsp;<span class="badge">{{vm.threadDumpTimedWaiting}}</span></span>&nbsp; <span class="label label-danger" ng-click="threadDumpFilter = {threadState: \'BLOCKED\'}">Blocked&nbsp;<span class="badge">{{vm.threadDumpBlocked}}</span></span>&nbsp;<div class="voffset2">&nbsp;</div>Filter <input type="text" ng-model="threadDumpFilter" class="form-control"><div class="row pad" ng-repeat="(k, v) in vm.threadDump | filter:threadDumpFilter"><h5><span class="label" ng-class="vm.getLabelClass(v.threadState)">{{v.threadState}}</span>&nbsp;{{v.threadName}} (ID {{v.threadId}}) <a ng-click="show = !show"><span ng-show="!show" data-translate="metrics.jvm.threads.dump.show">Show StackTrace</span> <span ng-show="show" data-translate="metrics.jvm.threads.dump.hide">Hide StackTrace</span></a></h5><div class="well" ng-show="show"><div ng-repeat="(stK, stV) in v.stackTrace">{{stV.className}}.{{stV.methodName}}({{stV.fileName}}:{{stV.lineNumber}}) <span class="voffset1"></span></div></div><table class="table table-condensed"><thead><tr><th class="text-right" data-translate="metrics.jvm.threads.dump.blockedtime">Blocked Time</th><th class="text-right" data-translate="metrics.jvm.threads.dump.blockedcount">Blocked Count</th><th class="text-right" data-translate="metrics.jvm.threads.dump.waitedtime">Waited Time</th><th class="text-right" data-translate="metrics.jvm.threads.dump.waitedcount">Waited Count</th><th data-translate="metrics.jvm.threads.dump.lockname">Lock Name</th></tr></thead><tbody><tr><td>{{v.blockedTime}}</td><td>{{v.blockedCount}}</td><td>{{v.waitedTime}}</td><td>{{v.waitedCount}}</td><td>{{v.lockName}}</td></tr></tbody></table></div></div><div class="modal-footer"><button type="button" class="btn btn-default pull-left" data-dismiss="modal" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/user-management/user-management-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.user.login)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="userManagement.delete.question" translate-values="{login: \'{{vm.user.login}}\'}">Are you sure you want to delete this User?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management-detail.html','<div><h2><span data-translate="userManagement.detail.title">User</span> [<b>{{vm.user.login}}</b>]</h2><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="userManagement.login">Login</span></dt><dd><span>{{vm.user.login}}</span> <span class="label label-danger" ng-show="!vm.user.activated" data-translate="userManagement.deactivated">Deactivated</span> <span class="label label-success" ng-show="vm.user.activated" data-translate="userManagement.activated">Activated</span></dd><dt><span data-translate="userManagement.firstName">First Name</span></dt><dd>{{vm.user.firstName}}</dd><dt><span data-translate="userManagement.lastName">Last Name</span></dt><dd>{{vm.user.lastName}}</dd><dt><span data-translate="userManagement.email">Email</span></dt><dd>{{vm.user.email}}</dd><dt><span data-translate="userManagement.langKey">Lang Key</span></dt><dd>{{vm.user.langKey}}</dd><dt><span data-translate="userManagement.createdBy">Created By</span></dt><dd>{{vm.user.createdBy}}</dd><dt><span data-translate="userManagement.createdDate">Created Date</span></dt><dd>{{vm.user.createdDate | date:\'dd/MM/yy HH:mm\' }}</dd><dt><span data-translate="userManagement.lastModifiedBy">Last Modified By</span></dt><dd>{{vm.user.lastModifiedBy}}</dd><dt><span data-translate="userManagement.lastModifiedDate">Last Modified Date</span></dt><dd>{{vm.user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</dd><dt><span data-translate="userManagement.profiles">Profiles</span></dt><dd><ul class="list-unstyled"><li ng-repeat="authority in vm.user.authorities"><span class="label label-info">{{authority}}</span></li></ul></dd></dl><button type="submit" ui-sref="user-management" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button></div>');
$templateCache.put('app/admin/user-management/user-management-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myUserLabel" data-translate="userManagement.home.createOrEditLabel">Create or edit a User</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.user.id"><label data-translate="global.field.id">ID</label><input type="text" class="form-control" name="id" ng-model="vm.user.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="userManagement.login">Login</label><input type="text" class="form-control" name="login" ng-model="vm.user.login" required ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/"><div ng-show="editForm.login.$invalid"><p class="help-block" ng-show="editForm.login.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.login.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="userManagement.firstName">First Name</label><input type="text" class="form-control" name="firstName" ng-model="vm.user.firstName" ng-maxlength="50"><div ng-show="editForm.firstName.$invalid"><p class="help-block" ng-show="editForm.firstName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label data-translate="userManagement.lastName">Last Name</label><input type="text" class="form-control" name="lastName" ng-model="vm.user.lastName" ng-maxlength="50"><div ng-show="editForm.lastName.$invalid"><p class="help-block" ng-show="editForm.lastName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="userManagement.email">Email</label><input type="email" class="form-control" name="email" ng-model="vm.user.email" required ng-maxlength="100"><div ng-show="editForm.email.$invalid"><p class="help-block" ng-show="editForm.email.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.email.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p><p class="help-block" ng-show="editForm.email.$error.email" data-translate="global.messages.validate.email.invalid">Your email is invalid.</p></div></div><div class="form-group"><label for="activated"><input ng-disabled="vm.user.id === null" type="checkbox" id="activated" name="activated" ng-model="vm.user.activated"> <span data-translate="userManagement.activated">Activated</span></label></div><div class="form-group"><label data-translate="userManagement.langKey">Lang Key</label><select class="form-control" name="langKey" ng-model="vm.user.langKey" ng-options="language as language for language in vm.languages track by language"></select></div><div class="form-group"><label data-translate="userManagement.profiles">Profiles</label><select class="form-control" multiple="multiple" name="authority" ng-model="vm.user.authorities" ng-options="authority for authority in vm.authorities"></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management.html','<div><h2 data-translate="userManagement.home.title">Users</h2><jhi-alert></jhi-alert><div class="row"><div class="col-md-4"><button class="btn btn-primary" ui-sref="user-management.new"><span class="glyphicon glyphicon-flash"></span> <span data-translate="userManagement.home.createLabel">Create a new User</span></button></div></div><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span><span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="login"><span data-translate="userManagement.login">Login</span> <span class="glyphicon glyphicon-sort"></span></th><th></th><th jh-sort-by="email"><span data-translate="userManagement.email">Email</span> <span class="glyphicon glyphicon-sort"></span></th><th></th><th jh-sort-by="langKey"><span data-translate="userManagement.langKey">Lang Key</span> <span class="glyphicon glyphicon-sort"></span></th><th><span data-translate="userManagement.profiles">Profiles</span></th><th jh-sort-by="createdDate"><span data-translate="userManagement.createdDate">Created Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastModifiedBy"><span data-translate="userManagement.lastModifiedBy">Last Modified By</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastModifiedDate"><span data-translate="userManagement.lastModifiedDate">Last Modified Date</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="user in vm.users track by user.id"><td><a ui-sref="user-management-detail({login:user.login})">{{user.id}}</a></td><td>{{user.login}}</td><td>{{ user.firstName }} {{user.lastName }}</td><td>{{user.email}}</td><td><button class="btn btn-danger btn-xs" ng-click="vm.setActive(user, true)" ng-show="!user.activated" data-translate="userManagement.deactivated">Deactivated</button> <button class="btn btn-success btn-xs" ng-click="vm.setActive(user, false)" ng-show="user.activated" ng-disabled="vm.currentAccount.login === user.login" data-translate="userManagement.activated">Activated</button></td><td>{{user.langKey}}</td><td><div ng-repeat="authority in user.authorities"><span class="label label-info">{{ authority }}</span></div></td><td>{{user.createdDate | date:\'dd/MM/yy HH:mm\'}}</td><td>{{user.lastModifiedBy}}</td><td>{{user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="user-management-detail({login:user.login})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="user-management.edit({login:user.login})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="user-management.delete({login:user.login})" class="btn btn-danger btn-sm" ng-disabled="vm.currentAccount.login === user.login"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/components/login/login.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.cancel()">&times;</button><h4 class="modal-title" data-translate="login.title">Sign in</h4></div><div class="modal-body"><div class="row"><div class="col-md-4 col-md-offset-4"><h1 data-translate="login.title">Sign in</h1></div><div class="col-md-8 col-md-offset-2"><div class="alert alert-danger" ng-show="vm.authenticationError" data-translate="login.messages.error.authentication"><strong>Failed to sign in!</strong> Please check your credentials and try again.</div></div><div class="col-md-8 col-md-offset-2"><form class="form" role="form" ng-submit="vm.login($event)"><div class="form-group"><label for="username" data-translate="global.form.username">Login</label><input type="text" class="form-control" id="username" placeholder="{{\'global.form.username.placeholder\' | translate}}" ng-model="vm.username"></div><div class="form-group"><label for="password" data-translate="login.form.password">Password</label><input type="password" class="form-control" id="password" placeholder="{{\'login.form.password.placeholder\' | translate}}" ng-model="vm.password"></div><div class="form-group"><label for="rememberMe"><input type="checkbox" id="rememberMe" ng-model="vm.rememberMe" checked="checked"> <span data-translate="login.form.rememberme">Remember me</span></label></div><button type="submit" class="btn btn-primary" data-translate="login.form.button">Sign in</button></form><p></p><div class="alert alert-warning"><a class="alert-link" href="" ng-click="vm.requestResetPassword()" data-translate="login.password.forgot">Did you forget your password?</a></div><div class="alert alert-warning" data-translate="global.messages.info.register" translate-compile>You don\'t have an account yet? <a class="alert-link" href="" ng-click="vm.register()">Register a new account</a></div></div></div></div>');
$templateCache.put('app/entities/documento/documento-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.documento.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="sgnmrApp.documento.delete.question" translate-values="{id: \'{{vm.documento.id}}\'}">Are you sure you want to delete this Documento?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/documento/documento-detail.html','<div><h2><span data-translate="sgnmrApp.documento.detail.title">Documento</span> {{vm.documento.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="sgnmrApp.documento.nombre">Nombre</span></dt><dd><span>{{vm.documento.nombre}}</span></dd><dt><span data-translate="sgnmrApp.documento.descripcion">Descripcion</span></dt><dd><span>{{vm.documento.descripcion}}</span></dd><dt><span data-translate="sgnmrApp.documento.mimeType">Mime Type</span></dt><dd><span>{{vm.documento.mimeType}}</span></dd><dt><span data-translate="sgnmrApp.documento.length">Length</span></dt><dd><span>{{vm.documento.length}}</span></dd><dt><span data-translate="sgnmrApp.documento.path">Path</span></dt><dd><span>{{vm.documento.path}}</span></dd><dt><span data-translate="sgnmrApp.documento.norma">Norma</span></dt><dd><a ui-sref="norma-detail({id:vm.documento.normaId})">{{vm.documento.normaDenominacion}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="documento-detail.edit({id:vm.documento.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/documento/documento-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myDocumentoLabel" data-translate="sgnmrApp.documento.home.createOrEditLabel">Create or edit a Documento</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.documento.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.documento.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="sgnmrApp.documento.nombre" for="field_nombre">Nombre</label><input type="text" class="form-control" name="nombre" id="field_nombre" ng-model="vm.documento.nombre"></div><div class="form-group"><label class="control-label" data-translate="sgnmrApp.documento.descripcion" for="field_descripcion">Descripcion</label><input type="text" class="form-control" name="descripcion" id="field_descripcion" ng-model="vm.documento.descripcion"></div><div class="form-group"><label class="control-label" data-translate="sgnmrApp.documento.mimeType" for="field_mimeType">Mime Type</label><input type="text" class="form-control" name="mimeType" id="field_mimeType" ng-model="vm.documento.mimeType"></div><div class="form-group"><label class="control-label" data-translate="sgnmrApp.documento.length" for="field_length">Length</label><input type="number" class="form-control" name="length" id="field_length" ng-model="vm.documento.length"></div><div class="form-group"><label class="control-label" data-translate="sgnmrApp.documento.path" for="field_path">Path</label><input type="text" class="form-control" name="path" id="field_path" ng-model="vm.documento.path"></div><div class="form-group"><label data-translate="sgnmrApp.documento.norma" for="field_norma">Norma</label><select class="form-control" id="field_norma" name="norma" ng-model="vm.documento.normaId" ng-options="norma.id as norma.denominacion for norma in vm.normas"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/documento/documentos.html','<div><h2 data-translate="sgnmrApp.documento.home.title">Documentos</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="documento.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="sgnmrApp.documento.home.createLabel">Create new Documento</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'sgnmrApp.documento.home.search\' | translate }}"> <span><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nombre"><span data-translate="sgnmrApp.documento.nombre">Nombre</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="descripcion"><span data-translate="sgnmrApp.documento.descripcion">Descripcion</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="mimeType"><span data-translate="sgnmrApp.documento.mimeType">Mime Type</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="length"><span data-translate="sgnmrApp.documento.length">Length</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="path"><span data-translate="sgnmrApp.documento.path">Path</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="normaDenominacion"><span data-translate="sgnmrApp.documento.norma">Norma</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="documento in vm.documentos track by documento.id"><td><a ui-sref="documento-detail({id:documento.id})">{{documento.id}}</a></td><td>{{documento.nombre}}</td><td>{{documento.descripcion}}</td><td>{{documento.mimeType}}</td><td>{{documento.length}}</td><td>{{documento.path}}</td><td><a ui-sref="norma-detail({id:documento.normaId})">{{documento.normaDenominacion}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="documento-detail({id:documento.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="documento.edit({id:documento.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="documento.delete({id:documento.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/intrumento-relacionado/intrumento-relacionado-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.intrumentoRelacionado.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="sgnmrApp.intrumentoRelacionado.delete.question" translate-values="{id: \'{{vm.intrumentoRelacionado.id}}\'}">Are you sure you want to delete this Intrumento Relacionado?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/intrumento-relacionado/intrumento-relacionado-detail.html','<div><h2><span data-translate="sgnmrApp.intrumentoRelacionado.detail.title">Intrumento Relacionado</span> {{vm.intrumentoRelacionado.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="sgnmrApp.intrumentoRelacionado.denominacion">Denominacion</span></dt><dd><span>{{vm.intrumentoRelacionado.denominacion}}</span></dd><dt><span data-translate="sgnmrApp.intrumentoRelacionado.tipo">Tipo</span></dt><dd><span data-translate="{{\'sgnmrApp.TipoRelacionInstrumento.\' + vm.intrumentoRelacionado.tipo}}">{{vm.intrumentoRelacionado.tipo}}</span></dd><dt><span data-translate="sgnmrApp.intrumentoRelacionado.normaRelacionada">Norma Relacionada</span></dt><dd><a ui-sref="norma-detail({id:vm.intrumentoRelacionado.normaRelacionadaId})">{{vm.intrumentoRelacionado.normaRelacionadaId}}</a></dd><dt><span data-translate="sgnmrApp.intrumentoRelacionado.norma">Norma</span></dt><dd><a ui-sref="norma-detail({id:vm.intrumentoRelacionado.normaId})">{{vm.intrumentoRelacionado.normaDenominacion}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="intrumento-relacionado-detail.edit({id:vm.intrumentoRelacionado.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/intrumento-relacionado/intrumento-relacionado-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myIntrumentoRelacionadoLabel" data-translate="sgnmrApp.intrumentoRelacionado.home.createOrEditLabel">Create or edit a Intrumento Relacionado</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.intrumentoRelacionado.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.intrumentoRelacionado.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="sgnmrApp.intrumentoRelacionado.denominacion" for="field_denominacion">Denominacion</label><input type="text" class="form-control" name="denominacion" id="field_denominacion" ng-model="vm.intrumentoRelacionado.denominacion" ng-maxlength="3072"><div ng-show="editForm.denominacion.$invalid"><p class="help-block" ng-show="editForm.denominacion.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="3072">This field cannot be longer than 3072 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="sgnmrApp.intrumentoRelacionado.tipo" for="field_tipo">Tipo</label><select class="form-control" name="tipo" ng-model="vm.intrumentoRelacionado.tipo" id="field_tipo"><option value="DEROGACION" data-translate="sgnmrApp.TipoRelacionInstrumento.DEROGACION">DEROGACION</option><option value="MENCION" data-translate="sgnmrApp.TipoRelacionInstrumento.MENCION">MENCION</option><option value="FUNDAMENTO" data-translate="sgnmrApp.TipoRelacionInstrumento.FUNDAMENTO">FUNDAMENTO</option></select></div><div class="form-group"><label data-translate="sgnmrApp.intrumentoRelacionado.normaRelacionada" for="field_normaRelacionada">Norma Relacionada</label><select class="form-control" id="field_normaRelacionada" name="normaRelacionada" ng-model="vm.intrumentoRelacionado.normaRelacionadaId" ng-options="norma.id as norma.id for norma in vm.normarelacionadas | orderBy:\'id\'"><option value=""></option></select></div><div class="form-group"><label data-translate="sgnmrApp.intrumentoRelacionado.norma" for="field_norma">Norma</label><select class="form-control" id="field_norma" name="norma" ng-model="vm.intrumentoRelacionado.normaId" ng-options="norma.id as norma.denominacion for norma in vm.normas"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/intrumento-relacionado/intrumento-relacionados.html','<div><h2 data-translate="sgnmrApp.intrumentoRelacionado.home.title">Intrumento Relacionados</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="intrumento-relacionado.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="sgnmrApp.intrumentoRelacionado.home.createLabel">Create new Intrumento Relacionado</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'sgnmrApp.intrumentoRelacionado.home.search\' | translate }}"> <span><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="denominacion"><span data-translate="sgnmrApp.intrumentoRelacionado.denominacion">Denominacion</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="tipo"><span data-translate="sgnmrApp.intrumentoRelacionado.tipo">Tipo</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="normaRelacionadaId"><span data-translate="sgnmrApp.intrumentoRelacionado.normaRelacionada">Norma Relacionada</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="normaDenominacion"><span data-translate="sgnmrApp.intrumentoRelacionado.norma">Norma</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="intrumentoRelacionado in vm.intrumentoRelacionados track by intrumentoRelacionado.id"><td><a ui-sref="intrumento-relacionado-detail({id:intrumentoRelacionado.id})">{{intrumentoRelacionado.id}}</a></td><td>{{intrumentoRelacionado.denominacion}}</td><td data-translate="{{\'sgnmrApp.TipoRelacionInstrumento.\' + intrumentoRelacionado.tipo}}">{{intrumentoRelacionado.tipo}}</td><td><a ui-sref="norma-detail({id:intrumentoRelacionado.normaRelacionadaId})">{{intrumentoRelacionado.normaRelacionadaId}}</a></td><td><a ui-sref="norma-detail({id:intrumentoRelacionado.normaId})">{{intrumentoRelacionado.normaDenominacion}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="intrumento-relacionado-detail({id:intrumentoRelacionado.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="intrumento-relacionado.edit({id:intrumentoRelacionado.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="intrumento-relacionado.delete({id:intrumentoRelacionado.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/materia/materia-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.materia.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="sgnmrApp.materia.delete.question" translate-values="{id: \'{{vm.materia.id}}\'}">Are you sure you want to delete this Materia?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/materia/materia-detail.html','<div><h2><span data-translate="sgnmrApp.materia.detail.title">Materia</span> {{vm.materia.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="sgnmrApp.materia.nombre">Nombre</span></dt><dd><span>{{vm.materia.nombre}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="materia-detail.edit({id:vm.materia.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/materia/materia-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myMateriaLabel" data-translate="sgnmrApp.materia.home.createOrEditLabel">Create or edit a Materia</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.materia.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.materia.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="sgnmrApp.materia.nombre" for="field_nombre">Nombre</label><input type="text" class="form-control" name="nombre" id="field_nombre" ng-model="vm.materia.nombre"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/materia/materias.html','<div><h2 data-translate="sgnmrApp.materia.home.title">Materias</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="materia.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="sgnmrApp.materia.home.createLabel">Create new Materia</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'sgnmrApp.materia.home.search\' | translate }}"> <span><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nombre"><span data-translate="sgnmrApp.materia.nombre">Nombre</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="materia in vm.materias track by materia.id"><td><a ui-sref="materia-detail({id:materia.id})">{{materia.id}}</a></td><td>{{materia.nombre}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="materia-detail({id:materia.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="materia.edit({id:materia.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="materia.delete({id:materia.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/norma/norma-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.norma.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="sgnmrApp.norma.delete.question" translate-values="{id: \'{{vm.norma.id}}\'}">Are you sure you want to delete this Norma?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/norma/norma-detail.html','<div><h2><span data-translate="sgnmrApp.norma.detail.title">Norma</span> {{vm.norma.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="sgnmrApp.norma.denominacion">Denominacion</span></dt><dd><span>{{vm.norma.denominacion}}</span></dd><dt><span data-translate="sgnmrApp.norma.fechaEmision">Fecha Emision</span></dt><dd><span>{{vm.norma.fechaEmision | date:\'dd/MM/yyyy\'}}</span></dd><dt><span data-translate="sgnmrApp.norma.fechaPublicacion">Fecha Publicacion</span></dt><dd><span>{{vm.norma.fechaPublicacion | date:\'dd/MM/yyyy\'}}</span></dd><dt><span data-translate="sgnmrApp.norma.fechaDOF">Fecha DOF</span></dt><dd><span>{{vm.norma.fechaDOF | date:\'dd/MM/yyyy\'}}</span></dd><dt><span data-translate="sgnmrApp.norma.fechaSJFYG">Fecha SJFYG</span></dt><dd><span>{{vm.norma.fechaSJFYG | date:\'dd/MM/yyyy\'}}</span></dd><dt><span data-translate="sgnmrApp.norma.fechaSJFGaceta">Fecha SJF Gaceta</span></dt><dd><span>{{vm.norma.fechaSJFGaceta | date:\'LLLL/yyyy\'}}</span></dd><dt><span data-translate="sgnmrApp.norma.depurado">Depurado</span></dt><dd><span ng-if="vm.norma.depurado == true"><span class="fa fa-check"></span></span> <span ng-if="vm.norma.depurado == false"><span class="fa fa-times"></span></span></dd><dt><span data-translate="sgnmrApp.norma.noEsInstrumentoNormativo">No Es Instrumento Normativo</span></dt><dd><span ng-if="vm.norma.noEsInstrumentoNormativo == true"><span class="fa fa-check"></span></span> <span ng-if="vm.norma.noEsInstrumentoNormativo == false"><span class="fa fa-times"></span></span></dd><dt><span data-translate="sgnmrApp.norma.abstractoConcreto">Abstracto Concreto</span></dt><dd><span>{{vm.norma.abstractoConcreto}}</span></dd><dt><span data-translate="sgnmrApp.norma.validezTemporalFin">Validez Temporal Fin</span></dt><dd><span>{{vm.norma.validezTemporalFin}}</span></dd><dt><span data-translate="sgnmrApp.norma.esCoyuntural">Es Coyuntural</span></dt><dd><span ng-if="vm.norma.esCoyuntural == true"><span class="fa fa-check"></span></span> <span ng-if="vm.norma.esCoyuntural == false"><span class="fa fa-times"></span></span></dd><dt><span data-translate="sgnmrApp.norma.estableceMontosEconomicos">Establece Montos Economicos</span></dt><dd><span ng-if="vm.norma.estableceMontosEconomicos == true"><span class="fa fa-check"></span></span> <span ng-if="vm.norma.estableceMontosEconomicos == false"><span class="fa fa-times"></span></span></dd><dt><span data-translate="sgnmrApp.norma.montosReqAct">Montos Req Act</span></dt><dd><span ng-if="vm.norma.montosReqAct == true"><span class="fa fa-check"></span></span> <span ng-if="vm.norma.montosReqAct == false"><span class="fa fa-times"></span></span></dd><dt><span data-translate="sgnmrApp.norma.montosEstFrecAct">Montos Est Frec Act</span></dt><dd><span ng-if="vm.norma.montosEstFrecAct == true"><span class="fa fa-check"></span></span> <span ng-if="vm.norma.montosEstFrecAct == false"><span class="fa fa-times"></span></span></dd><dt><span data-translate="sgnmrApp.norma.vigencia">Vigencia</span></dt><dd><span>{{vm.norma.vigencia}}</span></dd><dt><span data-translate="sgnmrApp.norma.showOnlyYear">Show Only Year</span></dt><dd><span ng-if="vm.norma.showOnlyYear == true"><span class="fa fa-check"></span></span> <span ng-if="vm.norma.showOnlyYear == false"><span class="fa fa-times"></span></span></dd><dt><span data-translate="sgnmrApp.norma.esVisible">Es Visible</span></dt><dd><span ng-if="vm.norma.esVisible == true"><span class="fa fa-check"></span></span> <span ng-if="vm.norma.esVisible == false"><span class="fa fa-times"></span></span></dd><dt><span data-translate="sgnmrApp.norma.abrogado">Abrogado</span></dt><dd><span ng-if="vm.norma.abrogado == true"><span class="fa fa-check"></span></span> <span ng-if="vm.norma.abrogado == false"><span class="fa fa-times"></span></span></dd><dt><span data-translate="sgnmrApp.norma.depuradoPor">Depurado Por</span></dt><dd><span ng-repeat="depuradoPor in vm.norma.depuradoPors"><a ui-sref="norma-detail({id: depuradoPor.id})">{{depuradoPor.denominacion}}</a>{{$last ? \'\' : \', \'}}</span></dd><dt><span data-translate="sgnmrApp.norma.abrogadoPor">Abrogado Por</span></dt><dd><span ng-repeat="abrogadoPor in vm.norma.abrogadoPors"><a ui-sref="norma-detail({id: abrogadoPor.id})">{{abrogadoPor.denominacion}}</a>{{$last ? \'\' : \', \'}}</span></dd><dt><span data-translate="sgnmrApp.norma.palabrasClave">Palabras Clave</span></dt><dd><span ng-repeat="palabrasClave in vm.norma.palabrasClaves"><a ui-sref="palabra-clave-detail({id: palabrasClave.id})">{{palabrasClave.id}}</a>{{$last ? \'\' : \', \'}}</span></dd><dt><span data-translate="sgnmrApp.norma.tipoOrdenamiento">Tipo Ordenamiento</span></dt><dd><a ui-sref="tipo-ordenamiento-detail({id:vm.norma.tipoOrdenamientoId})">{{vm.norma.tipoOrdenamientoNombre}}</a></dd><dt><span data-translate="sgnmrApp.norma.materia">Materia</span></dt><dd><a ui-sref="materia-detail({id:vm.norma.materiaId})">{{vm.norma.materiaNombre}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="norma-detail.edit({id:vm.norma.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/norma/norma-dialog-complete.html','<form name="editForm" role="form" novalidate show-validation flow-init="{testChunks:false}"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myNormaLabel" data-translate="sgnmrApp.norma.home.createOrEditLabel">Create or edit a Norma</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.norma.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.norma.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="sgnmrApp.norma.denominacion" for="field_denominacion">Denominacion</label><textarea class="form-control" name="denominacion" id="field_denominacion" ng-model="vm.norma.denominacion" ng-maxlength="3072" rows="5"></textarea><div ng-show="editForm.denominacion.$invalid"><p class="help-block" ng-show="editForm.denominacion.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="3072">This field cannot be longer than 3072 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="sgnmrApp.norma.fechaEmision" for="field_fechaEmision">Fecha Emision</label><div class="input-group"><input id="field_fechaEmision" type="text" class="form-control" name="fechaEmision" datetime-picker="dd/MM/yyyy" ng-model="vm.norma.fechaEmision" is-open="vm.datePickerOpenStatus.fechaEmision" enable-time="false"> <span><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'fechaEmision\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="sgnmrApp.norma.fechaPublicacion" for="field_fechaPublicacion">Fecha Publicacion</label><div class="input-group"><input id="field_fechaPublicacion" type="text" class="form-control" name="fechaPublicacion" datetime-picker="dd/MM/yyyy" ng-model="vm.norma.fechaPublicacion" is-open="vm.datePickerOpenStatus.fechaPublicacion" enable-time="false"> <span><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'fechaPublicacion\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="sgnmrApp.norma.fechaDOF" for="field_fechaDOF">Fecha DOF</label><div class="input-group"><input id="field_fechaDOF" type="text" class="form-control" name="fechaDOF" datetime-picker="dd/MM/yyyy" ng-model="vm.norma.fechaDOF" is-open="vm.datePickerOpenStatus.fechaDOF" enable-time="false"> <span><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'fechaDOF\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="sgnmrApp.norma.fechaSJFYG" for="field_fechaSJFYG">Fecha SJFYG</label><div class="input-group"><input id="field_fechaSJFYG" type="text" class="form-control" name="fechaSJFYG" datetime-picker="dd/MM/yyyy" ng-model="vm.norma.fechaSJFYG" is-open="vm.datePickerOpenStatus.fechaSJFYG" enable-time="false"> <span><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'fechaSJFYG\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="sgnmrApp.norma.fechaSJFGaceta" for="field_fechaSJFGaceta">Fecha SJF</label><div class="input-group"><input id="field_fechaSJFGaceta" type="text" class="form-control" name="fechaSJFGaceta" datetime-picker="MM/yyyy" ng-model="vm.norma.fechaSJFGaceta" is-open="vm.datePickerOpenStatus.fechaSJFGaceta" enable-time="false"> <span><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'fechaSJFGaceta\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><input type="checkbox" name="depurado" id="field_depurado" ng-model="vm.norma.depurado"><label class="control-label" data-translate="sgnmrApp.norma.depurado" for="field_depurado">Depurado</label></div><div class="form-group"><input type="checkbox" name="noEsInstrumentoNormativo" id="field_noEsInstrumentoNormativo" ng-model="vm.norma.noEsInstrumentoNormativo"><label class="control-label" data-translate="sgnmrApp.norma.noEsInstrumentoNormativo" for="field_noEsInstrumentoNormativo">No Es Instrumento Normativo</label></div><div class="form-group"><input type="checkbox" name="esCoyuntural" id="field_esCoyuntural" ng-model="vm.norma.esCoyuntural"><label class="control-label" data-translate="sgnmrApp.norma.esCoyuntural" for="field_esCoyuntural">Es Coyuntural</label></div><div class="form-group"><input type="checkbox" name="estableceMontosEconomicos" id="field_estableceMontosEconomicos" ng-model="vm.norma.estableceMontosEconomicos"><label class="control-label" data-translate="sgnmrApp.norma.estableceMontosEconomicos" for="field_estableceMontosEconomicos">Establece Montos Economicos</label></div><div class="form-group"><input type="checkbox" name="montosReqAct" id="field_montosReqAct" ng-model="vm.norma.montosReqAct"><label class="control-label" data-translate="sgnmrApp.norma.montosReqAct" for="field_montosReqAct">Montos Req Act</label></div><div class="form-group"><input type="checkbox" name="montosEstFrecAct" id="field_montosEstFrecAct" ng-model="vm.norma.montosEstFrecAct"><label class="control-label" data-translate="sgnmrApp.norma.montosEstFrecAct" for="field_montosEstFrecAct">Montos Est Frec Act</label></div><div class="form-group"><input type="checkbox" name="showOnlyYear" id="field_showOnlyYear" ng-model="vm.norma.showOnlyYear"><label class="control-label" data-translate="sgnmrApp.norma.showOnlyYear" for="field_showOnlyYear">Show Only Year</label></div><hr><div class="form-group"><input type="checkbox" name="esVisible" id="field_esVisible" ng-model="vm.norma.esVisible"><label class="control-label" data-translate="sgnmrApp.norma.esVisible" for="field_esVisible">Es Visible</label></div><div class="form-group"><input type="checkbox" name="abrogado" id="field_abrogado" ng-model="vm.norma.abrogado"><label class="control-label" data-translate="sgnmrApp.norma.abrogado" for="field_abrogado">Abrogado</label></div><hr><div class="form-group"><label class="control-label" data-translate="sgnmrApp.norma.vigencia" for="field_vigencia">Vigencia</label><input type="text" class="form-control" name="vigencia" id="field_vigencia" ng-model="vm.norma.vigencia " ng-maxlength="50"><div ng-show="editForm.vigencia.$invalid"><p class="help-block" ng-show="editForm.vigencia.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="sgnmrApp.norma.validezTemporalFin" for="field_validezTemporalFin">Validez Temporal Fin</label><input type="text" class="form-control" name="validezTemporalFin" id="field_validezTemporalFin" ng-model="vm.norma.validezTemporalFin" ng-maxlength="50"><div ng-show="editForm.validezTemporalFin.$invalid"><p class="help-block" ng-show="editForm.validezTemporalFin.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="field_abstractoConcreto">Documento</label><div class="alert alert-danger" ng-if="vm.error == true"><strong>Error. </strong>{{vm.error_message}}</div><div class="form-group"><div flow-files-submitted="$flow.upload();" flow-upload-started="vm.uploadStart($flow);" flow-file-success="vm.successUpload($flow);" flow-complete="vm.completeUpload($flow);" flow-file-error="vm.errorUpload($file, $message, $flow );"><span class="btn btn-default btn-block" data-translate="entity.action.addblob" flow-btn>Upload File</span><br><div ng-repeat="file in $flow.files"><table><td><p>{{$index+1}} .</p></td><td><p>{{file.name}}</p></td><td><button type="button" ng-disabled="vm.loading" ng-click="vm.removeFiles($flow,$index)" class="btn btn-xs pull-right remove_btn"><span class="glyphicon glyphicon-remove"></span></button></td></table><br><div class="progress progress-striped" ng-class="{active: file.isUploading()}"><div class="progress-bar" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100" ng-style="{width: (file.progress() * 100) + \'%\'}" style="width: 100%"><span class="sr-only ng-binding">1% Complete</span></div></div></div><div ng-repeat="file in vm.documentosResponse"><table><td><p>{{$index+1}} .</p></td><td><p>{{file.nombre}}</p></td><td><button type="button" ng-disabled="vm.loading" ng-click="vm.deleteFile(file)" class="btn btn-xs pull-right remove_btn"><span class="glyphicon glyphicon-remove"></span></button></td></table></div></div></div></div><div class="form-group"><label for="palabras">Palabra Clave</label><div class="input-group"><input name="palabras" id="palabras" type="text" placeholder="Introduce una palabra clave" ng-model="vm.modelPalabra" autocomplete="off" uib-typeahead="palabra as palabra.palabra for palabra in  vm.autocompletePalabra($viewValue) | limitTo:20" typeahead-on-select="vm.addWord()" class="form-control text-uppercase" ng-maxlength="50"> <span><button id="addWordBtn" type="button" class="btn btn-primary" aria-label="" ng-click="vm.addWord()"><span>Agregar palabra</span></button></span></div><div><div><p class="badge medium_badge" ng-repeat="palabra in vm.norma.palabrasClaves">{{palabra.palabra}} <span><button type="button" ng-disabled="" ng-click="vm.removeWord(palabra)" class="btn btn-xs pull-right remove_btn"><span class="glyphicon glyphicon-remove"></span></button></span></p></div></div></div><div class="form-group"><label for="organo">Organo</label><div class="input-group"><input name="organos" id="organos" type="text" placeholder="Introduce un organo" ng-model="vm.modelOrgano" autocomplete="off" uib-typeahead="organo as organo.nombre for organo in  vm.autocompleteOrgano($viewValue) | limitTo:20" typeahead-on-select="vm.addOrgano()" class="form-control text-uppercase" ng-maxlength="200"> <span><button id="addOrganoBtn" type="button" class="btn btn-primary" aria-label="" ng-click="vm.addOrgano()"><span>Agregar Organo</span></button></span></div><div><div><p class="badge medium_badge" ng-repeat="organo in vm.organos">{{organo.nombre}} <span><button type="button" ng-disabled="" ng-click="vm.removeOrgano(organo)" class="btn btn-xs pull-right remove_btn"><span class="glyphicon glyphicon-remove"></span></button></span></p></div></div></div><div class="form-group"><label for="ordenamiento">Ordenamiento</label><div><input name="ordenamientos" id="ordenamientos" type="text" placeholder="Introduce un Ordenamiento" ng-model="vm.modelOrdenamiento" autocomplete="off" uib-typeahead="ordenamiento as ordenamiento.nombre for ordenamiento in  vm.autocompleteOrdenamiento($viewValue) | limitTo:20" typeahead-on-select="vm.addOrdenamiento()" class="form-control text-uppercase"></div></div><div class="form-group"><label for="depurado">Depurado por</label><div><input name="depurado" id="depurado" type="text" placeholder="Introduce una Norma" ng-model="vm.modelDepuradoNorma" autocomplete="off" uib-typeahead="depurado as depurado.denominacion for depurado in  vm.autocompleteNormas($viewValue) | limitTo:20" typeahead-on-select="vm.addDepurado()" class="form-control text-uppercase"></div><div><div><p class="badge large_badge" ng-repeat="depurado in vm.norma.depuradoPors">{{depurado.denominacion}} <span><button type="button" ng-disabled="" ng-click="vm.removeDepurado(depurado)" class="btn btn-xs pull-right remove_btn"><span class="glyphicon glyphicon-remove"></span></button></span></p></div></div></div><div class="form-group"><label for="abrogado">Abrogado por</label><div><input name="abrogado" id="abrogado" type="text" placeholder="Introduce una Norma" ng-model="vm.modelAbrogadoNorma" autocomplete="off" uib-typeahead="abrogado as abrogado.denominacion for abrogado in  vm.autocompleteNormas($viewValue) | limitTo:20" typeahead-on-select="vm.addAbrogado()" class="form-control text-uppercase"></div><div><div><p class="badge large_badge" ng-repeat="abrogado in vm.norma.abrogadoPors">{{abrogado.denominacion}} <span><button type="button" ng-disabled="" ng-click="vm.removeAbrogado(abrogado)" class="btn btn-xs pull-right remove_btn"><span class="glyphicon glyphicon-remove"></span></button></span></p></div></div></div><div class="form-group"><label data-translate="sgnmrApp.norma.materia" for="field_materia">Materia</label><select class="form-control" id="field_materia" name="materia" ng-model="vm.norma.materiaId" ng-options="materia.id as materia.nombre for materia in vm.materias"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" ng-disabled="vm.loading" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="button" ng-disabled="editForm.$invalid || vm.isSaving || vm.loading" class="btn btn-primary" ng-click="vm.save(); "><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/norma/norma-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myNormaLabel" data-translate="sgnmrApp.norma.home.createOrEditLabel">Create or edit a Norma</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.norma.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.norma.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="sgnmrApp.norma.denominacion" for="field_denominacion">Denominacion</label><input type="text" class="form-control" name="denominacion" id="field_denominacion" ng-model="vm.norma.denominacion" ng-maxlength="3072"><div ng-show="editForm.denominacion.$invalid"><p class="help-block" ng-show="editForm.denominacion.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="3072">This field cannot be longer than 3072 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="sgnmrApp.norma.fechaEmision" for="field_fechaEmision">Fecha Emision</label><div class="input-group"><input id="field_fechaEmision" type="text" class="form-control" name="fechaEmision" datetime-picker="{{dateformat}}" ng-model="vm.norma.fechaEmision" is-open="vm.datePickerOpenStatus.fechaEmision"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'fechaEmision\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="sgnmrApp.norma.fechaPublicacion" for="field_fechaPublicacion">Fecha Publicacion</label><div class="input-group"><input id="field_fechaPublicacion" type="text" class="form-control" name="fechaPublicacion" datetime-picker="{{dateformat}}" ng-model="vm.norma.fechaPublicacion" is-open="vm.datePickerOpenStatus.fechaPublicacion"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'fechaPublicacion\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="sgnmrApp.norma.fechaSJFYG" for="field_fechaSJFYG">Fecha SJFYG</label><div class="input-group"><input id="field_fechaSJFYG" type="text" class="form-control" name="fechaSJFYG" datetime-picker="{{dateformat}}" ng-model="vm.norma.fechaSJFYG" is-open="vm.datePickerOpenStatus.fechaSJFYG"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'fechaSJFYG\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="sgnmrApp.norma.fechaSJFGaceta" for="field_fechaSJFGaceta">Fecha SJF Gaceta</label><div class="input-group"><input id="field_fechaSJFGaceta" type="text" class="form-control" name="fechaSJFGaceta" datetime-picker="{{dateformat}}" ng-model="vm.norma.fechaSJFGaceta" is-open="vm.datePickerOpenStatus.fechaSJFGaceta"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'fechaSJFGaceta\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="sgnmrApp.norma.fechaDOF" for="field_fechaDOF">Fecha DOF</label><div class="input-group"><input id="field_fechaDOF" type="text" class="form-control" name="fechaDOF" datetime-picker="{{dateformat}}" ng-model="vm.norma.fechaDOF" is-open="vm.datePickerOpenStatus.fechaDOF"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'fechaDOF\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="sgnmrApp.norma.depurado" for="field_depurado">Depurado</label><input type="checkbox" name="depurado" id="field_depurado" ng-model="vm.norma.depurado"></div><div class="form-group"><label class="control-label" data-translate="sgnmrApp.norma.noEsInstrumentoNormativo" for="field_noEsInstrumentoNormativo">No Es Instrumento Normativo</label><input type="checkbox" name="noEsInstrumentoNormativo" id="field_noEsInstrumentoNormativo" ng-model="vm.norma.noEsInstrumentoNormativo"></div><div class="form-group"><label class="control-label" data-translate="sgnmrApp.norma.abstractoConcreto" for="field_abstractoConcreto">Abstracto Concreto</label><textarea class="form-control" name="abstractoConcreto" id="field_abstractoConcreto" ng-model="vm.norma.abstractoConcreto"></textarea></div><div class="form-group"><label class="control-label" data-translate="sgnmrApp.norma.validezTemporalFin" for="field_validezTemporalFin">Validez Temporal Fin</label><input type="text" class="form-control" name="validezTemporalFin" id="field_validezTemporalFin" ng-model="vm.norma.validezTemporalFin"></div><div class="form-group"><label class="control-label" data-translate="sgnmrApp.norma.esCoyuntural" for="field_esCoyuntural">Es Coyuntural</label><input type="checkbox" name="esCoyuntural" id="field_esCoyuntural" ng-model="vm.norma.esCoyuntural"></div><div class="form-group"><label class="control-label" data-translate="sgnmrApp.norma.estableceMontosEconomicos" for="field_estableceMontosEconomicos">Establece Montos Economicos</label><input type="checkbox" name="estableceMontosEconomicos" id="field_estableceMontosEconomicos" ng-model="vm.norma.estableceMontosEconomicos"></div><div class="form-group"><label class="control-label" data-translate="sgnmrApp.norma.montosReqAct" for="field_montosReqAct">Montos Req Act</label><input type="checkbox" name="montosReqAct" id="field_montosReqAct" ng-model="vm.norma.montosReqAct"></div><div class="form-group"><label class="control-label" data-translate="sgnmrApp.norma.montosEstFrecAct" for="field_montosEstFrecAct">Montos Est Frec Act</label><input type="checkbox" name="montosEstFrecAct" id="field_montosEstFrecAct" ng-model="vm.norma.montosEstFrecAct"></div><div class="form-group"><label class="control-label" data-translate="sgnmrApp.norma.vigencia" for="field_vigencia">Vigencia</label><input type="text" class="form-control" name="vigencia" id="field_vigencia" ng-model="vm.norma.vigencia"></div><div class="form-group"><label class="control-label" data-translate="sgnmrApp.norma.showOnlyYear" for="field_showOnlyYear">Show Only Year</label><input type="checkbox" name="showOnlyYear" id="field_showOnlyYear" ng-model="vm.norma.showOnlyYear"></div><div class="form-group"><label class="control-label" data-translate="sgnmrApp.norma.esVisible" for="field_esVisible">Es Visible</label><input type="checkbox" name="esVisible" id="field_esVisible" ng-model="vm.norma.esVisible"></div><div class="form-group"><label class="control-label" data-translate="sgnmrApp.norma.abrogado" for="field_abrogado">Abrogado</label><input type="checkbox" name="abrogado" id="field_abrogado" ng-model="vm.norma.abrogado"></div><div class="form-group"><label data-translate="sgnmrApp.norma.depuradoPor" for="field_depuradoPor">Depurado Por</label><select class="form-control" id="field_depuradoPor" multiple="multiple" name="depuradoPor" ng-model="vm.norma.depuradoPors" ng-options="norma as norma.denominacion for norma in vm.normas track by norma.id"></select></div><div class="form-group"><label data-translate="sgnmrApp.norma.abrogadoPor" for="field_abrogadoPor">Abrogado Por</label><select class="form-control" id="field_abrogadoPor" multiple="multiple" name="abrogadoPor" ng-model="vm.norma.abrogadoPors" ng-options="norma as norma.denominacion for norma in vm.normas track by norma.id"></select></div><div class="form-group"><label data-translate="sgnmrApp.norma.palabrasClave" for="field_palabrasClave">Palabras Clave</label><select class="form-control" id="field_palabrasClave" multiple="multiple" name="palabrasClave" ng-model="vm.norma.palabrasClaves" ng-options="palabraClave as palabraClave.id for palabraClave in vm.palabraclaves track by palabraClave.id"></select></div><div class="form-group"><label data-translate="sgnmrApp.norma.tipoOrdenamiento" for="field_tipoOrdenamiento">Tipo Ordenamiento</label><select class="form-control" id="field_tipoOrdenamiento" name="tipoOrdenamiento" ng-model="vm.norma.tipoOrdenamientoId" ng-options="tipoOrdenamiento.id as tipoOrdenamiento.nombre for tipoOrdenamiento in vm.tipoordenamientos"><option value=""></option></select></div><div class="form-group"><label data-translate="sgnmrApp.norma.materia" for="field_materia">Materia</label><select class="form-control" id="field_materia" name="materia" ng-model="vm.norma.materiaId" ng-options="materia.id as materia.nombre for materia in vm.materias"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/norma/normas.html','<div><h2 data-translate="sgnmrApp.norma.home.title">Normas</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="norma.nuevo"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="sgnmrApp.norma.home.createLabel">Create new Norma</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'sgnmrApp.norma.home.search\' | translate }}"> <span><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="denominacion"><span data-translate="sgnmrApp.norma.denominacion">Denominacion</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="fechaEmision"><span data-translate="sgnmrApp.norma.fechaEmision">Fecha Emision</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="esVisible"><span data-translate="sgnmrApp.norma.esVisible">Es Visible</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="abrogado"><span data-translate="sgnmrApp.norma.abrogado">Abrogado</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="norma in vm.normas track by norma.id"><td><a ui-sref="norma-detail({id:norma.id})">{{norma.id}}</a></td><td>{{norma.denominacion}}</td><td>{{norma.fechaEmision | date:\'dd/MM/yyyy\'}}</td><td class="text-center"><span ng-if="norma.esVisible == true"><span class="fa fa-check"></span></span> <span ng-if="norma.esVisible == false"><span class="fa fa-times"></span></span></td><td class="text-center"><span ng-if="norma.abrogado == true"><span class="fa fa-check"></span></span> <span ng-if="norma.abrogado == false"><span class="fa fa-times"></span></span></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="norma-detail({id:norma.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ng-click="vm.normaIndex(norma.id)" class="btn btn-secondary btn-sm"><span class="fa fa-cube"></span> <span class="hidden-sm-down" data-translate="entity.action.index"></span></button> <button type="submit" ui-sref="norma.edit({id:norma.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="norma.delete({id:norma.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/organo/organo-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.organo.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="sgnmrApp.organo.delete.question" translate-values="{id: \'{{vm.organo.id}}\'}">Are you sure you want to delete this Organo?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/organo/organo-detail.html','<div><h2><span data-translate="sgnmrApp.organo.detail.title">Organo</span> {{vm.organo.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="sgnmrApp.organo.nombre">Nombre</span></dt><dd><span>{{vm.organo.nombre}}</span></dd><dt><span data-translate="sgnmrApp.organo.nombreUnificado">Nombre Unificado</span></dt><dd><span>{{vm.organo.nombreUnificado}}</span></dd><dt><span data-translate="sgnmrApp.organo.esVisible">Es Visible</span></dt><dd><span>{{vm.organo.esVisible}}</span></dd><dt><span data-translate="sgnmrApp.organo.padre">Padre</span></dt><dd><a ui-sref="organo-detail({id:vm.organo.padreId})">{{vm.organo.padreNombre}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="organo-detail.edit({id:vm.organo.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/organo/organo-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myOrganoLabel" data-translate="sgnmrApp.organo.home.createOrEditLabel">Create or edit a Organo</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.organo.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.organo.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="sgnmrApp.organo.nombre" for="field_nombre">Nombre</label><input type="text" class="form-control" name="nombre" id="field_nombre" ng-model="vm.organo.nombre"></div><div class="form-group"><label class="control-label" data-translate="sgnmrApp.organo.nombreUnificado" for="field_nombreUnificado">Nombre Unificado</label><input type="text" class="form-control" name="nombreUnificado" id="field_nombreUnificado" ng-model="vm.organo.nombreUnificado"></div><div class="form-group"><label class="control-label" data-translate="sgnmrApp.organo.esVisible" for="field_esVisible">Es Visible</label><input type="checkbox" name="esVisible" id="field_esVisible" ng-model="vm.organo.esVisible"></div><div class="form-group"><div><label data-translate="sgnmrApp.organo.padre" for="field_padre">Padre</label><input name="organos" id="organos" type="text" placeholder="Introduce un organo" ng-model="vm.organo.padre" autocomplete="off" uib-typeahead="organo as organo.nombre for organo in  vm.autocompleteOrgano($viewValue) | limitTo:20" class="form-control text-uppercase" ng-maxlength="200"></div><div><div><p class="badge medium_badge" ng-if="vm.organo.padre!=null">{{vm.organo.padre.nombre}} <span><button type="button" ng-disabled="" ng-click="vm.organo.padre=null" class="btn btn-xs pull-right remove_btn"><span class="glyphicon glyphicon-remove"></span></button></span></p></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/organo/organos.html','<div><h2 data-translate="sgnmrApp.organo.home.title">Organos</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="organo.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="sgnmrApp.organo.home.createLabel">Create new Organo</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'sgnmrApp.organo.home.search\' | translate }}"> <span><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nombre"><span data-translate="sgnmrApp.organo.nombre">Nombre</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nombreUnificado"><span data-translate="sgnmrApp.organo.nombreUnificado">Nombre Unificado</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="esVisible"><span data-translate="sgnmrApp.organo.esVisible">Es Visible</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="padreNombre"><span data-translate="sgnmrApp.organo.padre">Padre</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="organo in vm.organos track by organo.id"><td><a ui-sref="organo-detail({id:organo.id})">{{organo.id}}</a></td><td>{{organo.nombre}}</td><td>{{organo.nombreUnificado}}</td><td>{{organo.esVisible}}</td><td><a ui-sref="organo-detail({id:organo.padreId})">{{organo.padreNombre}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="organo-detail({id:organo.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="organo.edit({id:organo.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="organo.delete({id:organo.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/organo-relevante/organo-relevante-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.organoRelevante.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="sgnmrApp.organoRelevante.delete.question" translate-values="{id: \'{{vm.organoRelevante.id}}\'}">Are you sure you want to delete this Organo Relevante?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/organo-relevante/organo-relevante-detail.html','<div><h2><span data-translate="sgnmrApp.organoRelevante.detail.title">Organo Relevante</span> {{vm.organoRelevante.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="sgnmrApp.organoRelevante.tipo">Tipo</span></dt><dd><span data-translate="{{\'sgnmrApp.TipoOrganoRelevante.\' + vm.organoRelevante.tipo}}">{{vm.organoRelevante.tipo}}</span></dd><dt><span data-translate="sgnmrApp.organoRelevante.norma">Norma</span></dt><dd><a ui-sref="norma-detail({id:vm.organoRelevante.normaId})">{{vm.organoRelevante.normaDenominacion}}</a></dd><dt><span data-translate="sgnmrApp.organoRelevante.organo">Organo</span></dt><dd><a ui-sref="organo-detail({id:vm.organoRelevante.organoId})">{{vm.organoRelevante.organoNombre}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="organo-relevante-detail.edit({id:vm.organoRelevante.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/organo-relevante/organo-relevante-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myOrganoRelevanteLabel" data-translate="sgnmrApp.organoRelevante.home.createOrEditLabel">Create or edit a Organo Relevante</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.organoRelevante.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.organoRelevante.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="sgnmrApp.organoRelevante.tipo" for="field_tipo">Tipo</label><select class="form-control" name="tipo" ng-model="vm.organoRelevante.tipo" id="field_tipo"><option value="PARA_EJECUCION" data-translate="sgnmrApp.TipoOrganoRelevante.PARA_EJECUCION">PARA_EJECUCION</option><option value="EMISOR" data-translate="sgnmrApp.TipoOrganoRelevante.EMISOR">EMISOR</option></select></div><div class="form-group"><label data-translate="sgnmrApp.organoRelevante.norma" for="field_norma">Norma</label><select class="form-control" id="field_norma" name="norma" ng-model="vm.organoRelevante.normaId" ng-options="norma.id as norma.denominacion for norma in vm.normas"><option value=""></option></select></div><div class="form-group"><label data-translate="sgnmrApp.organoRelevante.organo" for="field_organo">Organo</label><select class="form-control" id="field_organo" name="organo" ng-model="vm.organoRelevante.organoId" ng-options="organo.id as organo.nombre for organo in vm.organos"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/organo-relevante/organo-relevantes.html','<div><h2 data-translate="sgnmrApp.organoRelevante.home.title">Organo Relevantes</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="organo-relevante.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="sgnmrApp.organoRelevante.home.createLabel">Create new Organo Relevante</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'sgnmrApp.organoRelevante.home.search\' | translate }}"> <span><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="tipo"><span data-translate="sgnmrApp.organoRelevante.tipo">Tipo</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="normaDenominacion"><span data-translate="sgnmrApp.organoRelevante.norma">Norma</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="organoNombre"><span data-translate="sgnmrApp.organoRelevante.organo">Organo</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="organoRelevante in vm.organoRelevantes track by organoRelevante.id"><td><a ui-sref="organo-relevante-detail({id:organoRelevante.id})">{{organoRelevante.id}}</a></td><td data-translate="{{\'sgnmrApp.TipoOrganoRelevante.\' + organoRelevante.tipo}}">{{organoRelevante.tipo}}</td><td><a ui-sref="norma-detail({id:organoRelevante.normaId})">{{organoRelevante.normaDenominacion}}</a></td><td><a ui-sref="organo-detail({id:organoRelevante.organoId})">{{organoRelevante.organoNombre}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="organo-relevante-detail({id:organoRelevante.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="organo-relevante.edit({id:organoRelevante.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="organo-relevante.delete({id:organoRelevante.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/palabra-clave/palabra-clave-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.palabraClave.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="sgnmrApp.palabraClave.delete.question" translate-values="{id: \'{{vm.palabraClave.id}}\'}">Are you sure you want to delete this Palabra Clave?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/palabra-clave/palabra-clave-detail.html','<div><h2><span data-translate="sgnmrApp.palabraClave.detail.title">Palabra Clave</span> {{vm.palabraClave.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="sgnmrApp.palabraClave.palabra">Palabra</span></dt><dd><span>{{vm.palabraClave.palabra}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="palabra-clave-detail.edit({id:vm.palabraClave.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/palabra-clave/palabra-clave-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPalabraClaveLabel" data-translate="sgnmrApp.palabraClave.home.createOrEditLabel">Create or edit a Palabra Clave</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.palabraClave.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.palabraClave.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="sgnmrApp.palabraClave.palabra" for="field_palabra">Palabra</label><input type="text" class="form-control" name="palabra" id="field_palabra" ng-model="vm.palabraClave.palabra"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/palabra-clave/palabra-claves.html','<div><h2 data-translate="sgnmrApp.palabraClave.home.title">Palabra Claves</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="palabra-clave.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="sgnmrApp.palabraClave.home.createLabel">Create new Palabra Clave</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'sgnmrApp.palabraClave.home.search\' | translate }}"> <span><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="palabra"><span data-translate="sgnmrApp.palabraClave.palabra">Palabra</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="palabraClave in vm.palabraClaves track by palabraClave.id"><td><a ui-sref="palabra-clave-detail({id:palabraClave.id})">{{palabraClave.id}}</a></td><td>{{palabraClave.palabra}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="palabra-clave-detail({id:palabraClave.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="palabra-clave.edit({id:palabraClave.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="palabra-clave.delete({id:palabraClave.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/tipo-ordenamiento/tipo-ordenamiento-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.tipoOrdenamiento.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="sgnmrApp.tipoOrdenamiento.delete.question" translate-values="{id: \'{{vm.tipoOrdenamiento.id}}\'}">Are you sure you want to delete this Tipo Ordenamiento?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/tipo-ordenamiento/tipo-ordenamiento-detail.html','<div><h2><span data-translate="sgnmrApp.tipoOrdenamiento.detail.title">Tipo Ordenamiento</span> {{vm.tipoOrdenamiento.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="sgnmrApp.tipoOrdenamiento.nombre">Nombre</span></dt><dd><span>{{vm.tipoOrdenamiento.nombre}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="tipo-ordenamiento-detail.edit({id:vm.tipoOrdenamiento.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/tipo-ordenamiento/tipo-ordenamiento-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myTipoOrdenamientoLabel" data-translate="sgnmrApp.tipoOrdenamiento.home.createOrEditLabel">Create or edit a Tipo Ordenamiento</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.tipoOrdenamiento.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.tipoOrdenamiento.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="sgnmrApp.tipoOrdenamiento.nombre" for="field_nombre">Nombre</label><input type="text" class="form-control" name="nombre" id="field_nombre" ng-model="vm.tipoOrdenamiento.nombre"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/tipo-ordenamiento/tipo-ordenamientos.html','<div><h2 data-translate="sgnmrApp.tipoOrdenamiento.home.title">Tipo Ordenamientos</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="tipo-ordenamiento.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs-down" data-translate="sgnmrApp.tipoOrdenamiento.home.createLabel">Create new Tipo Ordenamiento</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'sgnmrApp.tipoOrdenamiento.home.search\' | translate }}"> <span><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nombre"><span data-translate="sgnmrApp.tipoOrdenamiento.nombre">Nombre</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="tipoOrdenamiento in vm.tipoOrdenamientos track by tipoOrdenamiento.id"><td><a ui-sref="tipo-ordenamiento-detail({id:tipoOrdenamiento.id})">{{tipoOrdenamiento.id}}</a></td><td>{{tipoOrdenamiento.nombre}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="tipo-ordenamiento-detail({id:tipoOrdenamiento.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="tipo-ordenamiento.edit({id:tipoOrdenamiento.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="tipo-ordenamiento.delete({id:tipoOrdenamiento.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/layouts/error/accessdenied.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-8"><h1 data-translate="error.title">Error Page!</h1><div class="alert alert-danger" data-translate="error.http.403">You are not authorized to access this page.</div></div></div></div>');
$templateCache.put('app/layouts/error/error.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-8"><h1 data-translate="error.title">Error Page!</h1><div ng-show="errorMessage"><div class="alert alert-danger">{{errorMessage}}</div></div></div></div></div>');
$templateCache.put('app/layouts/navbar/navbar.html','<nav class="navbar navbar-default" role="navigation" style="margin-bottom: 0"><div class="container-fluid"><div class="navbar-header"><button type="button" class="navbar-toggle" ng-click="vm.toggleNavbar()"><span class="sr-only">Toggle navigation</span> <span class="icon-bar"></span> <span class="icon-bar"></span> <span class="icon-bar"></span></button> <a class="navbar-brand logo" href="#/" ng-click="vm.collapseNavbar()"><i class="icons-vdos icon-scjn-logo" style="font-size: 40px; color: #003A70"></i> <span>SGNMR</span> <span class="navbar-version">v{{VERSION}}</span></a></div><div class="navbar-collapse" uib-collapse="vm.isNavbarCollapsed" ng-switch="vm.isAuthenticated()"><ul class="nav navbar-nav navbar-right"><li ui-sref-active="active"><a ui-sref="home" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-home"></span> <span class="hidden-sm" data-translate="global.menu.home">Home</span></a></li><!-- jhipster-needle-add-element-to-menu - JHipster will add new menu items here --><li ng-class="{active: vm.$state.includes(\'entity\')}" ng-switch-when="true" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="entity-menu"><span><span class="glyphicon glyphicon-th-list"></span> <span class="hidden-sm" data-translate="global.menu.entities.main">Entities </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="norma" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.norma">Norma</span></a></li><li ui-sref-active="active"><a ui-sref="tipo-ordenamiento" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.tipoOrdenamiento">Tipo Ordenamiento</span></a></li><li ui-sref-active="active"><a ui-sref="materia" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.materia">Materia</span></a></li><li ui-sref-active="active"><a ui-sref="organo" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.organo">Organo</span></a></li><li ui-sref-active="active"><a ui-sref="documento" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.documento">Documento</span></a></li><li ui-sref-active="active"><a ui-sref="intrumento-relacionado" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.intrumentoRelacionado">Intrumento Relacionado</span></a></li><li ui-sref-active="active"><a ui-sref="organo-relevante" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.organoRelevante">Organo Relevante</span></a></li><li ui-sref-active="active"><a ui-sref="palabra-clave" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.palabraClave">Palabra Clave</span></a></li><!-- jhipster-needle-add-entity-to-menu - JHipster will add entities to the menu here --></ul></li><li ng-class="{active: vm.$state.includes(\'admin\')}" ng-switch-when="true" has-authority="ROLE_ADMIN" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="admin-menu"><span><span class="glyphicon glyphicon-tower"></span> <span class="hidden-sm" data-translate="global.menu.admin.main">Administration</span> <b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="user-management" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-user"></span>&nbsp; <span data-translate="global.menu.admin.userManagement">User management</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-metrics" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-dashboard"></span>&nbsp; <span data-translate="global.menu.admin.metrics">Metrics</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-health" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-heart"></span>&nbsp; <span data-translate="global.menu.admin.health">Health</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-configuration" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-list-alt"></span>&nbsp; <span data-translate="global.menu.admin.configuration">Configuration</span></a></li><li ui-sref-active="active"><a ui-sref="audits" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-bell"></span>&nbsp; <span data-translate="global.menu.admin.audits">Audits</span></a></li><li ui-sref-active="active"><a ui-sref="logs" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-tasks"></span>&nbsp; <span data-translate="global.menu.admin.logs">Logs</span></a></li><li ng-show="vm.swaggerEnabled" ui-sref-active="active"><a ui-sref="docs" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-book"></span>&nbsp; <span data-translate="global.menu.admin.apidocs">API</span></a></li><li ui-sref-active="active"><a ui-sref="entity-audit" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-list-alt"></span>&nbsp; <span data-translate="global.menu.admin.entity-audit">Entity Audit</span></a></li><li ui-sref-active="active"><a ui-sref="elasticsearch-reindex" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-refresh"></span>&nbsp; <span data-translate="global.menu.admin.elasticsearch-reindex">Elasticsearch Reindex</span></a></li><!-- jhipster-needle-add-element-to-admin-menu - JHipster will add entities to the admin menu here --></ul></li><li ui-sref-active="active" has-authority="ROLE_ADMIN" uib-dropdown class="dropdown pointer" ng-controller="JhiLanguageController as languageVm"><a class="dropdown-toggle" uib-dropdown-toggle href="" ng-if="languageVm.languages.length > 1"><span><span class="glyphicon glyphicon-flag"></span> <span class="hidden-sm" data-translate="global.menu.language">Language</span> <b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu ng-if="languageVm.languages.length > 1"><li active-menu="{{language}}" ng-repeat="language in languageVm.languages"><a href="" ng-click="languageVm.changeLanguage(language);vm.collapseNavbar();">{{language | findLanguageFromKey}}</a></li></ul></li><li ng-class="{active: vm.$state.includes(\'account\')}" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="account-menu"><span><span class="glyphicon glyphicon-user"></span> <span class="hidden-sm" data-translate="global.menu.account.main">Account </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active" ng-switch-when="true"><a ui-sref="settings" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-wrench"></span>&nbsp; <span data-translate="global.menu.account.settings">Settings</span></a></li><li ui-sref-active="active" ng-switch-when="true"><a ui-sref="password" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-lock"></span>&nbsp; <span data-translate="global.menu.account.password">Password</span></a></li><li ui-sref-active="active" ng-switch-when="true"><a href="" ng-click="vm.logout()" id="logout"><span class="glyphicon glyphicon-log-out"></span>&nbsp; <span data-translate="global.menu.account.logout">Sign out</span></a></li><li ui-sref-active="active" ng-switch-when="false"><a href="" ng-click="vm.login()" id="login"><span class="glyphicon glyphicon-log-in"></span>&nbsp; <span data-translate="global.menu.account.login">Sign in</span></a></li><li ui-sref-active="active" ng-switch-when="false"><a ui-sref="register" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-plus-sign"></span>&nbsp; <span data-translate="global.menu.account.register">Register</span></a></li></ul></li></ul></div></div></nav>');
$templateCache.put('app/layouts/private/private.html','<div class="body-bg"></div><main ng-if="$pageFinishedLoading" ng-class="{ \'menu-collapsed\': $baSidebarService.isMenuCollapsed() }"><aside class="al-sidebar"><div class="slimScrollDiv"><ul class="al-sidebar-list" ng-switch="vm.isAuthenticated()"><li ng-repeat="menu in vm.menu" class="al-sidebar-list-item" ng-class="{\'ba-sidebar-item-expanded\': menu.isOpen}" ng-show="menu.isVisible"><a ng-click="menu.isOpen = !menu.isOpen; menu.action();" class="al-sidebar-list-link" ui-sref-active="selected" href=""><i ng-class="menu.icon"></i> <span>{{menu.name}}</span> <b class="fa fa-angle-down" ui-sref-active="fa-angle-up" ng-if="menu.hasChild"></b></a><ul class="al-sidebar-sublist" ng-class="{\'slide-right\': item.slideRight}" ng-if="menu.hasChild"><li ng-repeat="child in menu.childrens" ui-sref-active="selected" class="ba-sidebar-sublist-item" ng-show="child.isVisible"><a ng-click="child.action();"><span ng-class="child.icon"></span>&nbsp; <span>{{child.name}}</span></a></li></ul></li></ul><div class="slimScrollBar"></div><div class="slimScrollRail"></div></div><div class="sidebar-hover-elem show-hover-elem" ng-style="{top: hoverElemTop + \'px\', height: hoverElemHeight + \'px\'}" ng-class="{\'show-hover-elem\': showHoverElem }" style="height: 42px"></div></aside><div class="page-top clearfix" scroll-position="scrolled" max-height="50" ng-class="{\'scrolled\': scrolled}"><a href="#/norma" class="al-logo clearfix"><span>SGNMR </span>Admin <small>v{{VERSION}}</small></a> <a href class="collapse-menu-link ion-navicon" ba-sidebar-toggle-menu></a></div><div class="al-main"><div class="al-content"><content-top></content-top><div ui-view="content" autoscroll="true" autoscroll-body-top></div></div></div><footer class="al-footer clearfix"><div class="al-footer-right"><i class="ion-heart"></i></div><div class="al-footer-main clearfix"><div class="al-copy">Suprema Corte de Justicia de la Naci\xF3n 2021</div><ul class="al-share clearfix"><!-- <li><i class="socicon socicon-facebook"></i></li>\n                <li><i class="socicon socicon-twitter"></i></li>\n                <li><i class="socicon socicon-google"></i></li>\n                <li><i class="socicon socicon-github"></i></li> --></ul></div></footer><back-top></back-top></main><div id="preloader" ng-show="!$pageFinishedLoading"><div></div></div>');
$templateCache.put('app/layouts/public/public.html','<div ui-view="navbar" ng-show="vm.isAuthenticated()" ng-cloak></div><header><!-- start header sticky --><div class="container-fluid hidden py-2" ng-show="!vm.isAuthenticated()" id="header-sticky" style="max-width: 1880px"><div class="row no-gutters justify-content-center align-items-center d-flex"><div class="col-lg-10 col-xs-12"><div class="row m-0 align-items-center d-flex"><div class="align-self-center mr-3" id="sticky-logo-horizontal"><a href="/" class="d-inline-block" aria-label="Ir a la p\xE1gina principal del sitio."><em class="icons-vdos icon-scjn-logo" aria-hidden="true"></em></a></div><div class="align-self-center mr-3" id="sticky-logo-vertical"><a aria-label="Ir a la p\xE1gina principal del sitio." class="d-inline-block" href="/"><em aria-hidden="true" class="icons-vdos icon-ccj-scjn-logovertical"></em></a></div><div class="col" id="navbar-sticky"><nav class="navbar navbar-expand-md"><ul class="nav navbar-nav" role="menubar" aria-label="Navegaci\xF3n principal del sitio."><li class="first" role="menuitem"><a href="">Inicio</a></li><li role="menuitem"><a href="/conoce-la-corte" target="_self">Conoce la Corte</a></li><li role="menuitem"><a href="/pleno" target="_self">Pleno y Salas</a></li><li role="menuitem"><a href="/presidencia" target="_self">Presidencia</a></li><li role="menuitem"><a href="/multimedia" target="_self">Prensa y Multimedia</a></li><li role="menuitem"><a href="/transparencia" target="_self">Transparencia</a></li><li role="menuitem"><a href="https://datos-personales.scjn.gob.mx/" hreflang="es" rel="noreferrer" class="nav-link" aria-label="Ir a la p\xE1gina principal del sitio: Datos Personales. Se abrir\xE1 en una nueva p\xE1gina." target="_blank">Protecci\xF3n de Datos Personales</a></li></ul></nav></div><div class="text-right ml-3 py-2" id="sticky-main-search"><a href="/gw/#/sistema-de-consulta/sitios" id="sticky-search-button" class="btn btn-link" aria-label="Realizar una b\xFAsqueda"><em class="icons-vdos icon-sisconsulta" aria-hidden="true"></em></a></div></div></div></div><div class="hidden" id="social-network-sticky"><a aria-label="Twitter de la Suprema Corte de Justicia de la Naci\xF3n" class="d-block twitter my-2" href="https://twitter.com/scjn" rel="noreferrer" target="_blank"><span class="fa-stack fa-1x"><em class="fas fa-circle fa-stack-2x fa-stack-background"></em> <em class="fas fa-circle fa-stack-2x"></em> <em class="fab fa-x-twitter fa-stack-1x fa-inverse"></em> </span></a><a aria-label="Facebook de la Suprema Corte de Justicia de la Naci\xF3n" class="d-block facebook my-2" href="https://www.facebook.com/SCJNMexico/" rel="noreferrer" target="_blank"><span class="fa-stack fa-1x"><em class="fas fa-circle fa-stack-2x fa-stack-background"></em> <em class="fas fa-circle fa-stack-2x"></em> <em class="fab fa-facebook-f fa-stack-1x fa-inverse"></em> </span></a><a aria-label="Canal de YouTube de la Suprema Corte de Justicia de la Naci\xF3n" class="d-block youtube my-2" href="https://www.youtube.com/scjn" rel="noreferrer" target="_blank"><span class="fa-stack fa-1x"><em class="fas fa-circle fa-stack-2x fa-stack-background"></em> <em class="fas fa-circle fa-stack-2x"></em> <em class="fab fa-youtube fa-stack-1x fa-inverse"></em> </span></a><a aria-label="Instagram de la Suprema Corte de Justicia de la Naci\xF3n" class="d-block instagram my-2" href="https://instagram.com/scjnmexico" rel="noreferrer" target="_blank"><span class="fa-stack fa-1x"><em class="fas fa-circle fa-stack-2x fa-stack-background"></em> <em class="fas fa-circle fa-stack-2x"></em> <em class="fab fa-instagram fa-stack-1x fa-inverse"></em> </span></a><a ria-label="Threads de la Suprema Corte de Justicia de la Naci\xF3n" class="d-block twitter my-2" href="https://www.threads.net/@scjnmexico" rel="noreferrer" target="_blank"><span class="fa-stack fa-1x"><em class="fas fa-circle fa-stack-2x fa-stack-background"></em> <em class="fas fa-circle fa-stack-2x"></em> <em class="fab fa-threads fa-stack-1x fa-inverse"></em> </span></a><a aria-label="LinkedIn de la Suprema Corte de Justicia de la Naci\xF3n" class="d-block linkedin my-2" href="https://www.linkedin.com/company/suprema-corte-de-justicia-de-la-naci%C3%B3n/?viewAsMember=true" rel="noreferrer" target="_blank"><span class="fa-stack fa-1x"><em class="fas fa-circle fa-stack-2x fa-stack-background"></em> <em class="fas fa-circle fa-stack-2x"></em> <em class="fab fa-linkedin-in fa-stack-1x fa-inverse"></em> </span></a><a aria-label="Tiktok de la Suprema Corte de Justicia de la Naci\xF3n" class="d-block twitter my-2" href="https://www.tiktok.com/@lacortemx" rel="noreferrer" target="_blank"><span class="fa-stack fa-1x"><em class="fas fa-circle fa-stack-2x fa-stack-background"></em> <em class="fas fa-circle fa-stack-2x"></em> <em class="fab fa-tiktok fa-stack-1x fa-inverse"></em></span></a></div></div><!-- end header sticky --><!-- start header web --><div class="container-fluid hidden-xs px-md-0 px-3" id="header" style="max-width: 1880px"><div class="row no-gutters justify-content-center d-flex"><div class="col-md-10 col-xs-12"><div class="row m-0 align-items-center d-flex" id="header-height"><!-- start logo --><div class="col pl-0" id="logo"><a href="/" rel="home" class="d-inline-block" aria-label="Ir a la p\xE1gina principal de la Suprema Corte de Justicia de la Naci\xF3n"><em class="icons-vdos icon-scjn-logo" aria-hidden="true"></em></a></div><!-- end logo --><div class="col pr-0"><div class="row m-0 justify-content-end align-items-center d-flex"><!-- start search --><div data-toggle="validator" id="web-main-search"><form ng-submit="vm.search()"><fieldset><legend class="sr-only">Buscador de la SCJN</legend><div class="input-group"><label for="web-search" id="web-words" class="sr-only sr-only-focusable">Buscar</label><input id="web-search" class="form-control border-right-0" type="text" ng-model="vm.searchValue"><div class="input-group-append"><button id="web-search-button" type="submit" name="web-search-button" class="btn btn-link" value="Buscar" aria-label="Realizar una b\xFAsqueda"><em class="icons-vdos icon-sisconsulta"></em></button></div></div></fieldset></form></div></div></div></div></div></div></div><!-- end header web --><!-- start header mobile --><div class="container-fluid visible-xs" id="header-mobile"><div class="pull-right" id="social-network-mobile"><!-- start social_network_mobile --><div class="region region-social-network-mobile"><div id="block-social-network-mobile" class="block block-block-content clearfix"><div><a aria-label="Twitter de la Suprema Corte de Justicia de la Naci\xF3n. Se abrir\xE1 en otra p\xE1gina." class="d-inline-block twitter" href="https://twitter.com/scjn" rel="noreferrer" target="_blank"><span class="fa-stack fa-1x"><em class="fas fa-circle fa-stack-2x" aria-hidden="true"></em> <em class="fab fa-x-twitter fa-stack-1x fa-inverse" aria-hidden="true"></em> </span></a><a aria-label="Facebook de la Suprema Corte de Justicia de la Naci\xF3n. Se abrir\xE1 en otra p\xE1gina." class="d-inline-block facebook" href="https://www.facebook.com/SCJNMexico/" rel="noreferrer" target="_blank"><span class="fa-stack fa-1x"><em class="fas fa-circle fa-stack-2x" aria-hidden="true"></em> <em class="fab fa-facebook-f fa-stack-1x fa-inverse" aria-hidden="true"></em> </span></a><a aria-label="Canal de YouTube de la Suprema Corte de Justicia de la Naci\xF3n. Se abrir\xE1 en otra p\xE1gina." class="d-inline-block youtube" href="https://youtube.com/scjn" rel="noreferrer" target="_blank"><span class="fa-stack fa-1x"><em class="fas fa-circle fa-stack-2x" aria-hidden="true"></em> <em class="fab fa-youtube fa-stack-1x fa-inverse" aria-hidden="true"></em> </span></a><a aria-label="Instagram de la Suprema Corte de Justicia de la Naci\xF3n. Se abrir\xE1 en otra p\xE1gina." class="d-inline-block instagram" href="https://instagram.com/scjnmexico" rel="noreferrer" target="_blank"><span class="fa-stack fa-1x"><em class="fas fa-circle fa-stack-2x" aria-hidden="true"></em> <em class="fab fa-instagram fa-stack-1x fa-inverse" aria-hidden="true"></em></span></a></div></div></div><!-- end social_network_mobile --></div></div><!-- end header mobile --><!-- start main menu --><div class="container-fluid py-md-0 py-sm-2 py-0 px-md-0 px-sm-3 px-4" id="navigation" style="max-width: 1880px"><div class="row no-gutters justify-content-center d-flex"><div class="col-md-10 col-xs-12"><!-- start navigation --><nav class="navbar mb-0"><div class="navbar-header"><a href="/" class="navbar-brand visible-xs" aria-label="Ir a la p\xE1gina principal de la Suprema Corte de Justicia de la Naci\xF3n"><em class="icons-vdos icon-scjn-logo" aria-hidden="true"></em> </a><button type="button" class="navbar-toggle collapsed my-sm-0 my-2" ng-click="vm.toggleMenuNavbar()"><span class="sr-only">Toggle navigation</span> <span class="icon-bar"></span> <span class="icon-bar"></span> <span class="icon-bar"></span></button></div><div id="navbar-collapse" class="navbar-collapse collapse" uib-collapse="vm.menuNavbarCollapsed"><div class="visible-xs" id="mobile-main-search"><form ng-submit="vm.search()"><div class="input-group"><label for="mobile-search" id="mobile-words" class="sr-only sr-only-focusable">Buscar</label><input id="mobile-search" class="form-control border-right-0" type="text" ng-model="vm.searchValue"><div class="input-group-append"><button id="mobile-search-button" class="btn btn-link" aria-label="Realizar una b\xFAsqueda" type="submit"><em class="icons-vdos icon-sisconsulta" aria-hidden="true"></em></button></div></div></form></div><nav role="navigation" aria-label="Men\xFA Principal"><ul class="nav navbar-nav" role="menubar" aria-label="Navegaci\xF3n principal del sitio."><li role="menuitem"><a href="/">Inicio</a></li><li role="menuitem"><a href="/conoce-la-corte">Conoce la Corte</a></li><li role="menuitem"><a href="/pleno">Pleno y Salas</a></li><li role="menuitem"><a href="/presidencia">Presidencia</a></li><li role="menuitem"><a href="/multimedia">Prensa y Multimedia</a></li><li role="menuitem"><a href="/transparencia">Transparencia</a></li><li role="menuitem"><a href="https://datos-personales.scjn.gob.mx/" hreflang="es" rel="noreferrer" class="nav-link" aria-label="Ir a la p\xE1gina principal del sitio: Datos Personales. Se abrir\xE1 en una nueva p\xE1gina." target="_blank">Protecci\xF3n de Datos Personales</a></li></ul></nav></div></nav><!-- end navigation --></div></div></div></header><!-- end header --><!-- start main content --><div class="container-fluid px-lg-0 px-3" id="main-content" role="main" style="max-width: 1880px; min-height: 460px"><div class="row no-gutters justify-content-center d-flex"><div class="col-md-10 col-xs-12"><div class="row"><div class="col-xs-12"><div class="region region-region-breadcrumb"><ol class="breadcrumb" aria-label="Breadcrumb"><li><a href="/">Inicio</a></li><li><a href="/conoce-la-corte">Conoce la Corte</a></li><li class="active">Marco Normativo</li></ol></div></div><div class="col-xs-12"><div class="row" ui-view="content"></div></div></div></div></div></div><!-- end main content --><!-- start footer --><footer class="container-fluid px-0" id="footer" style="max-width: 1880px"><button ng-click="vm.scrollToTop()" type="button" class="btn btn-link" id="scroll-to-top" aria-label="Regresar al principio de la p\xE1gina"><em class="fas fa-sort-up"></em></button><div class="row no-gutters justify-content-center d-flex"><div class="col-lg-10 col-xs-12"><div class="row mx-0"><!-- start location --><div class="col-md-3 col-xs-12 mb-md-0 mb-4 pl-3 pl-md-0"><h2>UBICACI\xD3N</h2><p><a class="d-block" href="https://goo.gl/maps/So7jpmUrWE12" aria-label="Se abrir\xE1 en Google Maps." rel="noreferrer" target="_blank">Suprema Corte de Justicia de la Naci\xF3n: Pino Su\xE1rez no. 2, Colonia Centro. Cuauht\xE9moc, C.P. 06065, M\xE9xico, Ciudad de M\xE9xico</a></p><h2 class="mt-4 mb-0"><a aria-label="Mapa de sitio del portal de la Suprema Corte de Justicia de la Naci\xF3n, se abrir\xE1 en otra p\xE1gina" href="https://www.scjn.gob.mx/mapa-de-sitio" target="_blank">MAPA DE SITIO</a></h2></div><!-- end location --><!-- start contact --><div class="col-md-3 col-xs-12 mb-md-0 mb-4"><h2>CONT\xC1CTANOS</h2><div><a aria-label="Directorio de la Suprema Corte de Justicia de la Naci\xF3n, se abrir\xE1 en otra p\xE1gina" class="d-inline-block mr-2" href="https://www.internet2.scjn.gob.mx/Directorio_Trans/Directorio.aspx" target="_blank"><span class="d-table-cell align-middle"><em aria-hidden="true" class="icons-vdos-circulo icon-telefono-circulo fs-2-5"></em> </span></a><a aria-label="Escr\xEDbenos al correo contacto@scjn.gob.mx, se abrir\xE1 en otra p\xE1gina" class="d-inline-block" href="https://www.scjn.gob.mx/contact" target="_blank"><span class="d-table-cell align-middle"><em aria-hidden="true" class="icons-vdos-circulo icon-correo-circulo fs-2-5"></em></span></a></div><h2 class="mt-4">REDES SOCIALES</h2><div class="d-table"><a aria-label="Twitter de la Suprema Corte de Justicia de la Naci\xF3n. Se abrir\xE1 en una nueva p\xE1gina." class="d-inline-block twitter mb-2" href="http://twitter.com/scjn" rel="noreferrer" target="_blank"><span class="fa-stack fa-1x"><em class="fas fa-circle fa-stack-2x"></em> <em class="fab fa-x-twitter fa-stack-1x fa-inverse"></em> </span></a><a aria-label="Facebook de la Suprema Corte de Justicia de la Naci\xF3n. Se abrir\xE1 en una nueva p\xE1gina." class="d-inline-block facebook mb-2" href="https://www.facebook.com/SCJNMexico/" rel="noreferrer" target="_blank"><span class="fa-stack fa-1x"><em class="fas fa-circle fa-stack-2x"></em> <em class="fab fa-facebook-f fa-stack-1x fa-inverse"></em> </span></a><a aria-label="Canal de YouTube de la Suprema Corte de Justicia de la Naci\xF3n. Se abrir\xE1 en una nueva p\xE1gina." class="d-inline-block youtube mb-2" href="https://www.youtube.com/scjn" rel="noreferrer" target="_blank"><span class="fa-stack fa-1x"><em class="fas fa-circle fa-stack-2x"></em> <em class="fab fa-youtube fa-stack-1x fa-inverse"></em> </span></a><a aria-label="Instagram de la Suprema Corte de Justicia de la Naci\xF3n. Se abrir\xE1 en una nueva p\xE1gina." class="d-inline-block youtube mb-2" href="https://instagram.com/scjnmexico" rel="noreferrer" target="_blank"><span class="fa-stack fa-1x"><em class="fas fa-circle fa-stack-2x"></em> <em class="fab fa-instagram fa-stack-1x fa-inverse"></em> </span></a><a aria-label="Threads de la Suprema Corte de Justicia de la Naci\xF3n. Se abrir\xE1 en una nueva p\xE1gina." class="d-inline-block twitter mb-2" href="https://www.threads.net/@scjnmexico" rel="noreferrer" target="_blank"><span class="fa-stack fa-1x"><em class="fas fa-circle fa-stack-2x"></em> <em class="fab fa-threads fa-stack-1x fa-inverse"></em> </span></a><a aria-label="Linkedin de la Suprema Corte de Justicia de la Naci\xF3n. Se abrir\xE1 en una nueva p\xE1gina." class="d-inline-block linkedin mb-2" href="https://www.linkedin.com/company/suprema-corte-de-justicia-de-la-naci%C3%B3n/?viewAsMember=true" rel="noreferrer" target="_blank"><span class="fa-stack fa-1x"><em class="fas fa-circle fa-stack-2x"></em> <em class="fab fa-linkedin-in fa-stack-1x fa-inverse"></em> </span></a><a aria-label="Tiktok de la Suprema Corte de Justicia de la Naci\xF3n. Se abrir\xE1 en una nueva p\xE1gina." class="d-inline-block twitter mb-2" href="https://www.tiktok.com/@lacortemx" rel="noreferrer" target="_blank"><span class="fa-stack fa-1x"><em class="fas fa-circle fa-stack-2x"></em> <em class="fab fa-tiktok fa-stack-1x fa-inverse"></em></span></a></div></div><!-- end contact --><!-- start complaint --><div class="col-md-3 col-xs-12 mb-md-0 mb-4"><div><a class="d-inline-block" href="/registro/denuncias-responsabilidades-administrativas"><span class="d-table-cell align-middle icon-denuncia pr-3"><em class="icons-vdos icon-denuncia-resp-admin fs-2-5" aria-hidden="true"></em></span><h2 class="d-table-cell align-middle">DENUNCIAS DE RESPONSABILIDADES ADMINISTRATIVAS</h2></a></div><div class="d-flex mt-1 pt-1"><a class="d-inline-block" href="/igualdad-de-genero/orientacion-materia-acoso-violencia"><span class="d-table-cell align-middle icon-denuncia pr-3"><em class="icons-vdos icon-enlace-acoso fs-2-5"></em></span><h2 class="d-table-cell align-middle mb-0">ASISTENCIA EN CASOS DE ACOSO SEXUAL Y VIOLENCIA DE G\xC9NERO</h2></a></div></div><!-- end complaint --><!-- start more_links --><div class="col-md-3 col-xs-12 pr-3 pr-md-0"><div id="icono-pnt"><a aria-label="Plataforma Nacional de Transparencia. Encontrar\xE1s Informaci\xF3n p\xFAblica, denuncias, Solicitudes, Recursos y un Buscador. Se abrir\xE1 en otra p\xE1gina" href="https://www.plataformadetransparencia.org.mx/web/guest/inicio" rel="noreferrer" target="_blank"></a></div></div><!-- end more_links --></div></div></div></footer><!-- end footer -->');
$templateCache.put('app/account/reset/finish/reset.finish.html','<div><div class="row"><div class="col-md-4 col-md-offset-4"><h1 data-translate="reset.finish.title">Reset password</h1><div class="alert alert-danger" data-translate="reset.finish.messages.keymissing" ng-show="vm.keyMissing"><strong>The password reset key is missing.</strong></div><div class="alert alert-warning" ng-hide="vm.success || vm.keyMissing"><p data-translate="reset.finish.messages.info">Choose a new password</p></div><div class="alert alert-danger" ng-show="vm.error"><p data-translate="reset.finish.messages.error">Your password couldn\'t be reset. Remember a password request is only valid for 24 hours.</p></div><div class="alert alert-success" ng-show="vm.success"><p data-translate="reset.finish.messages.success" translate-compile><strong>Your password has been reset.</strong> Please <a class="alert-link" href="" ng-click="vm.login()">sign in</a>.</p></div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div><div ng-hide="vm.keyMissing"><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.finishReset()" show-validation><div class="form-group"><label class="control-label" for="password" data-translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.resetAccount.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.resetAccount.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your password confirmation is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your password confirmation is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your password confirmation cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="reset.finish.form.button">Reset Password</button></form></div></div></div></div>');
$templateCache.put('app/account/reset/request/reset.request.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1 data-translate="reset.request.title">Reset your password</h1><div class="alert alert-danger" data-translate="reset.request.messages.notfound" ng-show="vm.errorEmailNotExists"><strong>Email address isn\'t registered!</strong> Please check and try again.</div><div class="alert alert-warning" ng-hide="vm.success"><p data-translate="reset.request.messages.info">Enter the email address you used to register.</p></div><div class="alert alert-success" ng-show="vm.success === \'OK\'"><p data-translate="reset.request.messages.success">Check your emails for details on how to reset your password.</p></div><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.requestReset()" show-validation><div class="form-group"><label class="control-label" for="email" data-translate="global.form.email">Email</label><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.resetAccount.email" ng-minlength="5" ng-maxlength="100" required><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" data-translate="global.messages.validate.email.required">Your email is required.</p><p class="help-block" ng-show="form.email.$error.email" data-translate="global.messages.validate.email.invalid">Your email is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" data-translate="global.messages.validate.email.minlength">Your email is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" data-translate="global.messages.validate.email.maxlength">Your email cannot be longer than 100 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="reset.request.form.button">Reset</button></form></div></div></div>');}]);})();